import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from "graphql";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSONObject: { input: any; output: any };
};

export type ActionPayload =
  | ActionPayloadLocationProfileChanged
  | ActionPayloadPostEnabled;

export type ActionPayloadInput = {
  ACTION_LOCATION_PROFILE_CHANGED?: InputMaybe<ActionPayloadLocationProfileChangedInput>;
  ACTION_POST_ENABLED?: InputMaybe<ActionPayloadPostEnabledInput>;
};

export type ActionPayloadInputCombo = {
  oneOf?: InputMaybe<ActionPayloadInput>;
  type: ActionPayloadType;
};

export type ActionPayloadLocationProfileChanged = {
  __typename?: "ActionPayloadLocationProfileChanged";
  location: Scalars["String"]["output"];
  profile: Scalars["String"]["output"];
  type: ActionPayloadType;
};

export type ActionPayloadLocationProfileChangedInput = {
  location: Scalars["String"]["input"];
  profile: Scalars["String"]["input"];
};

export type ActionPayloadPostEnabled = {
  __typename?: "ActionPayloadPostEnabled";
  enabled: Scalars["Boolean"]["output"];
  post: Scalars["String"]["output"];
  type: ActionPayloadType;
};

export type ActionPayloadPostEnabledInput = {
  enabled: Scalars["Boolean"]["input"];
  post: Scalars["String"]["input"];
};

export enum ActionPayloadType {
  ActionLocationProfileChanged = "ACTION_LOCATION_PROFILE_CHANGED",
  ActionPostEnabled = "ACTION_POST_ENABLED",
}

export type Animation = {
  __typename?: "Animation";
  enabled: Scalars["Boolean"]["output"];
  option: AnimationOption;
};

export type AnimationInput = {
  enabled: Scalars["Boolean"]["input"];
  option?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type AnimationOption =
  | AnimationOptionFade
  | AnimationOptionFlip
  | AnimationOptionWipe;

export type AnimationOptionFade = {
  __typename?: "AnimationOptionFade";
  duration: Scalars["Float"]["output"];
  type: Scalars["String"]["output"];
};

export type AnimationOptionFlip = {
  __typename?: "AnimationOptionFlip";
  direction: TileRotatePattern;
  duration: Scalars["Float"]["output"];
  type: Scalars["String"]["output"];
};

export type AnimationOptionWipe = {
  __typename?: "AnimationOptionWipe";
  duration: Scalars["Float"]["output"];
  function: AnimationWipeFunction;
  type: Scalars["String"]["output"];
};

export enum AnimationWipeFunction {
  Box = "box",
  Chevron = "chevron",
  Circle = "circle",
  Down = "down",
  Ellipse = "ellipse",
  Inset = "inset",
  Polygon = "polygon",
  Shutters = "shutters",
  Slots = "slots",
  Spiral = "spiral",
  Spotlight = "spotlight",
  Star = "star",
}

export enum BackgroundMediaMode {
  Normal = "normal",
  Off = "off",
  Video = "video",
}

export type ConditionValueType =
  | ConditionValueTypeBoolean
  | ConditionValueTypeNumber
  | ConditionValueTypeString;

export type ConditionValueTypeBoolean = {
  __typename?: "ConditionValueTypeBoolean";
  type: Scalars["String"]["output"];
  valueBoolean: Scalars["Boolean"]["output"];
};

export type ConditionValueTypeNumber = {
  __typename?: "ConditionValueTypeNumber";
  type: Scalars["String"]["output"];
  valueNumber: Scalars["Float"]["output"];
};

export type ConditionValueTypeString = {
  __typename?: "ConditionValueTypeString";
  type: Scalars["String"]["output"];
  valueString: Scalars["String"]["output"];
};

export type ContentUpdateOptions = {
  __typename?: "ContentUpdateOptions";
  staleFlyoutTimeout?: Maybe<Scalars["Float"]["output"]>;
  tileContentUpdateFrequency?: Maybe<Scalars["Float"]["output"]>;
  tileContentUpdatePct?: Maybe<Scalars["Float"]["output"]>;
};

export type ContentUpdateOptionsInput = {
  staleFlyoutTimeout: Scalars["Float"]["input"];
  tileContentUpdateFrequency: Scalars["Float"]["input"];
  tileContentUpdatePct: Scalars["Float"]["input"];
};

export type CreateScheduledEventRecurringSettingsInput = {
  bymonth?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  byweekday?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  count?: InputMaybe<Scalars["Float"]["input"]>;
  dtstart?: InputMaybe<Scalars["String"]["input"]>;
  freq?: Scalars["Float"]["input"];
  interval?: Scalars["Float"]["input"];
  tzid?: InputMaybe<Scalars["String"]["input"]>;
  until?: InputMaybe<Scalars["String"]["input"]>;
};

export type Customer = {
  __typename?: "Customer";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  auth0?: Maybe<CustomerAuth0Config>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CustomerAnalyticsConfigInput = {
  flyoutClosed?: InputMaybe<Scalars["Boolean"]["input"]>;
  qrCodeScanned?: InputMaybe<Scalars["Boolean"]["input"]>;
  restingStatePlayed?: InputMaybe<Scalars["Boolean"]["input"]>;
  searchQuery?: InputMaybe<Scalars["Boolean"]["input"]>;
  tileOpen?: InputMaybe<Scalars["Boolean"]["input"]>;
  tileShown?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CustomerAuth0Config = {
  __typename?: "CustomerAuth0Config";
  organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerAuth0Settings = {
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomerFilter = {
  auth0?: InputMaybe<CustomerAuth0Settings>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Device = {
  __typename?: "Device";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  accessToken?: Maybe<Scalars["String"]["output"]>;
  accessTokenSalt?: Maybe<Scalars["String"]["output"]>;
  assetTag: Scalars["String"]["output"];
  building?: Maybe<Scalars["String"]["output"]>;
  clientId?: Maybe<Scalars["String"]["output"]>;
  clientSecret?: Maybe<Scalars["String"]["output"]>;
  clientSecretSalt?: Maybe<Scalars["String"]["output"]>;
  config?: Maybe<DeviceActivationConfig>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  customer: Scalars["ID"]["output"];
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  license?: Maybe<Scalars["String"]["output"]>;
  licenseSalt?: Maybe<Scalars["String"]["output"]>;
  licenseVersion?: Maybe<Scalars["Float"]["output"]>;
  location?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organization: Scalars["String"]["output"];
  room?: Maybe<Scalars["String"]["output"]>;
  settings?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
  status: DeviceStatus;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DeviceActivationConfig = {
  __typename?: "DeviceActivationConfig";
  analytics?: Maybe<Scalars["Boolean"]["output"]>;
  menu?: Maybe<DeviceMenuLocation>;
  openDevToolsOnStart?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeviceActivationConfigInput = {
  analytics?: InputMaybe<Scalars["Boolean"]["input"]>;
  menu?: InputMaybe<DeviceMenuLocation>;
  openDevToolsOnStart?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DeviceFilter = {
  assetTag?: InputMaybe<Scalars["String"]["input"]>;
  building?: InputMaybe<Scalars["String"]["input"]>;
  customer?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  location?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<DeviceStatus>>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum DeviceMenuLocation {
  Bottomleft = "bottomleft",
  Bottomright = "bottomright",
  None = "none",
  Topleft = "topleft",
  Topright = "topright",
}

export enum DeviceStatus {
  Approved = "approved",
  Denied = "denied",
  Registered = "registered",
}

export type ExtraFieldCondition = {
  __typename?: "ExtraFieldCondition";
  field: Scalars["String"]["output"];
  value: ConditionValueType;
};

export type ExtraFieldMetadata = {
  __typename?: "ExtraFieldMetadata";
  allowOverride?: Maybe<ExtraFieldMetadataProperties>;
};

export type ExtraFieldMetadataProperties = {
  __typename?: "ExtraFieldMetadataProperties";
  defaultValue?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ExtraFieldType =
  | ExtraFieldTypeArray
  | ExtraFieldTypeBoolean
  | ExtraFieldTypeBox
  | ExtraFieldTypeColor
  | ExtraFieldTypeHelp
  | ExtraFieldTypeMedia
  | ExtraFieldTypeNumber
  | ExtraFieldTypeReference
  | ExtraFieldTypeRichText
  | ExtraFieldTypeSearch
  | ExtraFieldTypeSelect
  | ExtraFieldTypeText
  | ExtraFieldTypeTextLabel;

export type ExtraFieldTypeArray = {
  __typename?: "ExtraFieldTypeArray";
  extraFields: Array<ExtraFieldType>;
  label?: Maybe<Scalars["String"]["output"]>;
  showTitle?: Maybe<Scalars["Boolean"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeBoolean = {
  __typename?: "ExtraFieldTypeBoolean";
  defaultValue?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<ExtraFieldMetadata>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeBox = {
  __typename?: "ExtraFieldTypeBox";
  condition?: Maybe<ExtraFieldCondition>;
  extraFields: Array<ExtraFieldType>;
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeColor = {
  __typename?: "ExtraFieldTypeColor";
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<ExtraFieldMetadata>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeHelp = {
  __typename?: "ExtraFieldTypeHelp";
  label?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeMedia = {
  __typename?: "ExtraFieldTypeMedia";
  label?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeNumber = {
  __typename?: "ExtraFieldTypeNumber";
  condition?: Maybe<ExtraFieldCondition>;
  defaultValue?: Maybe<Scalars["Float"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeReference = {
  __typename?: "ExtraFieldTypeReference";
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  filter?: Maybe<ExtraFieldTypeReferenceFilter>;
  label?: Maybe<Scalars["String"]["output"]>;
  multiple?: Maybe<Scalars["Boolean"]["output"]>;
  nullable?: Maybe<Scalars["Boolean"]["output"]>;
  optionText?: Maybe<Scalars["String"]["output"]>;
  reference: ServiceAppCmsReferenceTypes;
  selectOptions?: Maybe<ExtraFieldTypeReferenceSelectOptions>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeReferenceFilter = {
  __typename?: "ExtraFieldTypeReferenceFilter";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ExtraFieldTypeReferenceSelectOptions = {
  __typename?: "ExtraFieldTypeReferenceSelectOptions";
  optionText: Scalars["String"]["output"];
};

export type ExtraFieldTypeRichText = {
  __typename?: "ExtraFieldTypeRichText";
  label?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeSearch = {
  __typename?: "ExtraFieldTypeSearch";
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeSelect = {
  __typename?: "ExtraFieldTypeSelect";
  choices: Array<ExtraFieldTypeSelectChoice>;
  condition?: Maybe<ExtraFieldCondition>;
  defaultChoice?: Maybe<Scalars["String"]["output"]>;
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeSelectChoice = {
  __typename?: "ExtraFieldTypeSelectChoice";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type ExtraFieldTypeText = {
  __typename?: "ExtraFieldTypeText";
  condition?: Maybe<ExtraFieldCondition>;
  defaultValue?: Maybe<Scalars["String"]["output"]>;
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ExtraFieldTypeTextLabel = {
  __typename?: "ExtraFieldTypeTextLabel";
  condition?: Maybe<ExtraFieldCondition>;
  initialValue?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export enum IconType {
  Media = "media",
  Text = "text",
  Textmedia = "textmedia",
}

export type Layout = {
  __typename?: "Layout";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  animation?: Maybe<Animation>;
  borderRadius?: Maybe<Scalars["Float"]["output"]>;
  content?: Maybe<ContentUpdateOptions>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  custom?: Maybe<LayoutCustomModel>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organization: Scalars["String"]["output"];
  padding?: Maybe<Scalars["Float"]["output"]>;
  template?: Maybe<Templates>;
  tileCount?: Maybe<Scalars["Float"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LayoutCustomModel = {
  __typename?: "LayoutCustomModel";
  height: Scalars["Float"]["output"];
  positions: Array<LayoutCustomModelPosition>;
  width: Scalars["Float"]["output"];
};

export type LayoutCustomModelInput = {
  height: Scalars["Float"]["input"];
  positions: Array<LayoutCustomModelPositionInput>;
  width: Scalars["Float"]["input"];
};

export type LayoutCustomModelPosition = {
  __typename?: "LayoutCustomModelPosition";
  height: Scalars["Float"]["output"];
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type LayoutCustomModelPositionInput = {
  height: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type LayoutQueryFilter = {
  animationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  template?: InputMaybe<Array<Templates>>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListMetadata = {
  __typename?: "ListMetadata";
  count: Scalars["Float"]["output"];
};

export type Location = {
  __typename?: "Location";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  device?: Maybe<LocationDeviceConfig>;
  id?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  profile?: Maybe<Scalars["ID"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type LocationDeviceConfig = {
  __typename?: "LocationDeviceConfig";
  appMenu?: Maybe<LocationDeviceConfigAppMenu>;
  screens?: Maybe<LocationDeviceConfigScreen>;
};

export type LocationDeviceConfigAppMenu = {
  __typename?: "LocationDeviceConfigAppMenu";
  positions?: Maybe<Array<Scalars["String"]["output"]>>;
  show?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LocationDeviceConfigAppMenuInput = {
  positions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  show?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LocationDeviceConfigOverscan = {
  __typename?: "LocationDeviceConfigOverscan";
  bottom?: Maybe<Scalars["Float"]["output"]>;
  left?: Maybe<Scalars["Float"]["output"]>;
  right?: Maybe<Scalars["Float"]["output"]>;
  top?: Maybe<Scalars["Float"]["output"]>;
};

export type LocationDeviceConfigOverscanInput = {
  bottom?: InputMaybe<Scalars["Float"]["input"]>;
  left?: InputMaybe<Scalars["Float"]["input"]>;
  right?: InputMaybe<Scalars["Float"]["input"]>;
  top?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LocationDeviceConfigScreen = {
  __typename?: "LocationDeviceConfigScreen";
  fullscreen?: Maybe<Scalars["Boolean"]["output"]>;
  overscan?: Maybe<LocationDeviceConfigOverscan>;
  screenOffset?: Maybe<LocationDeviceConfigScreenOffset>;
  videoSource?: Maybe<LocationDeviceConfigVideoSource>;
};

export type LocationDeviceConfigScreenInput = {
  fullscreen?: InputMaybe<Scalars["Boolean"]["input"]>;
  overscan?: InputMaybe<LocationDeviceConfigOverscanInput>;
  screenOffset?: InputMaybe<LocationDeviceConfigScreenOffsetInput>;
  videoSource?: InputMaybe<LocationDeviceConfigVideoSourceInput>;
};

export type LocationDeviceConfigScreenOffset = {
  __typename?: "LocationDeviceConfigScreenOffset";
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type LocationDeviceConfigScreenOffsetInput = {
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LocationDeviceConfigVideoSource = {
  __typename?: "LocationDeviceConfigVideoSource";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  height?: Maybe<Scalars["Float"]["output"]>;
  showCloseButton?: Maybe<Scalars["Boolean"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type LocationDeviceConfigVideoSourceInput = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  height?: InputMaybe<Scalars["Float"]["input"]>;
  showCloseButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export type LocationDeviceInput = {
  appMenu?: InputMaybe<LocationDeviceConfigAppMenuInput>;
  screens?: InputMaybe<LocationDeviceConfigScreenInput>;
};

export type LocationFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  profile?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LottieAsset = {
  __typename?: "LottieAsset";
  data?: Maybe<Scalars["JSONObject"]["output"]>;
  speed?: Maybe<Scalars["Float"]["output"]>;
};

export type Media = {
  __typename?: "Media";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  file?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isDir: Scalars["Boolean"]["output"];
  lottie?: Maybe<LottieAsset>;
  name: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  parent?: Maybe<Scalars["ID"]["output"]>;
  root?: Maybe<Scalars["Boolean"]["output"]>;
  size?: Maybe<Scalars["Float"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type MediaLottieAsset = {
  data?: InputMaybe<Scalars["JSONObject"]["input"]>;
  speed?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MediaQueryFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isDir?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  parent?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  root?: InputMaybe<Scalars["Boolean"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaUrlModel = {
  __typename?: "MediaUrlModel";
  fileName?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  createCustomer: Customer;
  createDevice: Device;
  createLayout: Layout;
  createLocation: Location;
  createMedia: Media;
  createPost: Post;
  createProfile: ProfileModel;
  createScheduledEvent: ScheduledEvent;
  createService: Service;
  createTag: Tag;
  deleteCustomer: Scalars["Boolean"]["output"];
  deleteDevice: Scalars["Boolean"]["output"];
  deleteLayout: Scalars["Boolean"]["output"];
  deleteLocation: Scalars["Boolean"]["output"];
  deleteMedia: Scalars["Boolean"]["output"];
  deletePost: Scalars["Boolean"]["output"];
  deleteProfile: Scalars["Boolean"]["output"];
  deleteScheduledEvent: Scalars["Boolean"]["output"];
  deleteService: Scalars["Boolean"]["output"];
  deleteTag: Scalars["Boolean"]["output"];
  enablePost: Post;
  regenerateDeviceLicense: Device;
  updateCustomer: Customer;
  updateDevice: Device;
  updateLayout: Layout;
  updateLocation: Location;
  updateMedia: Media;
  updatePost: Post;
  updateProfile: ProfileModel;
  updateScheduledEvent: ScheduledEvent;
  updateService: Service;
  updateTag: Tag;
  validateGqlModel: ValidationModel;
};

export type MutationCreateCustomerArgs = {
  activatedAnalytics?: InputMaybe<CustomerAnalyticsConfigInput>;
  name?: Scalars["String"]["input"];
};

export type MutationCreateDeviceArgs = {
  assetTag: Scalars["String"]["input"];
  building?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<DeviceActivationConfigInput>;
  customer: Scalars["ID"]["input"];
  location?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<Array<Scalars["JSONObject"]["input"]>>;
  status?: DeviceStatus;
};

export type MutationCreateLayoutArgs = {
  animation: AnimationInput;
  borderRadius?: Scalars["Float"]["input"];
  content: ContentUpdateOptionsInput;
  custom?: InputMaybe<LayoutCustomModelInput>;
  name?: Scalars["String"]["input"];
  padding?: Scalars["Float"]["input"];
  template?: Scalars["String"]["input"];
  tileCount?: Scalars["Float"]["input"];
};

export type MutationCreateLocationArgs = {
  device?: InputMaybe<LocationDeviceInput>;
  name?: Scalars["String"]["input"];
  profile?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationCreateMediaArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  file?: InputMaybe<Scalars["String"]["input"]>;
  isDir?: Scalars["Boolean"]["input"];
  lottie?: InputMaybe<MediaLottieAsset>;
  name?: Scalars["String"]["input"];
  parent?: InputMaybe<Scalars["ID"]["input"]>;
  size?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreatePostArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: Scalars["Boolean"]["input"];
  flyoutPosition?: InputMaybe<PostFlyoutPositionModelInput>;
  flyoutScale?: InputMaybe<Scalars["Float"]["input"]>;
  flyoutShowCloseButton?: Scalars["Boolean"]["input"];
  flyoutType?: InputMaybe<Scalars["ID"]["input"]>;
  hideFromSearch?: Scalars["Boolean"]["input"];
  qrCodeLink?: InputMaybe<Scalars["String"]["input"]>;
  qrCodeLinkByLocationProfile?: InputMaybe<
    Array<InputMaybe<PostQrCodeByProfileInput>>
  >;
  qrCodeLocation?: InputMaybe<PostQrCodeLocationInput>;
  qrCodeLocationPercent?: InputMaybe<PostQrCodeLocationPercentInput>;
  qrCodeStyle?: InputMaybe<PostQrCodeStyleInput>;
  qrCodeText?: InputMaybe<Scalars["String"]["input"]>;
  relatedPostAsset?: InputMaybe<Scalars["ID"]["input"]>;
  relatedPosts?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  staleFlyoutTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  tileAssets?: InputMaybe<Array<InputMaybe<PostTileAssetInput>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateProfileArgs = {
  background?: InputMaybe<ProfileBackgroundInput>;
  layouts?: InputMaybe<Array<ProfileLayoutInput>>;
  name: Scalars["String"]["input"];
  resting?: InputMaybe<ProfileRestingInput>;
  screen?: InputMaybe<ProfileScreenModelInput>;
  type: ScreenType;
};

export type MutationCreateScheduledEventArgs = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  endActionOneOf?: InputMaybe<Array<ActionPayloadInputCombo>>;
  endProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  recurring?: InputMaybe<CreateScheduledEventRecurringSettingsInput>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
  startActionOneOf?: InputMaybe<Array<ActionPayloadInputCombo>>;
  startProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateServiceArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  defaultValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  options?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type MutationCreateTagArgs = {
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconType?: InputMaybe<IconType>;
  mediaIcon?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationDeleteCustomerArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteDeviceArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteLayoutArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteLocationArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteMediaArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeletePostArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteProfileArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteScheduledEventArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteServiceArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteTagArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationEnablePostArgs = {
  enabled: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
};

export type MutationRegenerateDeviceLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type MutationUpdateCustomerArgs = {
  activatedAnalytics?: InputMaybe<CustomerAnalyticsConfigInput>;
  id: Scalars["String"]["input"];
  name?: Scalars["String"]["input"];
};

export type MutationUpdateDeviceArgs = {
  assetTag: Scalars["String"]["input"];
  building?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<DeviceActivationConfigInput>;
  customer: Scalars["ID"]["input"];
  id: Scalars["String"]["input"];
  location?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<Array<Scalars["JSONObject"]["input"]>>;
  status?: DeviceStatus;
};

export type MutationUpdateLayoutArgs = {
  animation: AnimationInput;
  borderRadius?: Scalars["Float"]["input"];
  content: ContentUpdateOptionsInput;
  custom?: InputMaybe<LayoutCustomModelInput>;
  id: Scalars["String"]["input"];
  name?: Scalars["String"]["input"];
  padding?: Scalars["Float"]["input"];
  template?: Scalars["String"]["input"];
  tileCount?: Scalars["Float"]["input"];
};

export type MutationUpdateLocationArgs = {
  device?: InputMaybe<LocationDeviceInput>;
  id: Scalars["String"]["input"];
  name?: Scalars["String"]["input"];
  profile?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationUpdateMediaArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  file?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  isDir?: Scalars["Boolean"]["input"];
  lottie?: InputMaybe<MediaLottieAsset>;
  name?: Scalars["String"]["input"];
  parent?: InputMaybe<Scalars["ID"]["input"]>;
  size?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdatePostArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: Scalars["Boolean"]["input"];
  flyoutPosition?: InputMaybe<PostFlyoutPositionModelInput>;
  flyoutScale?: InputMaybe<Scalars["Float"]["input"]>;
  flyoutShowCloseButton?: Scalars["Boolean"]["input"];
  flyoutType?: InputMaybe<Scalars["ID"]["input"]>;
  hideFromSearch?: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  qrCodeLink?: InputMaybe<Scalars["String"]["input"]>;
  qrCodeLinkByLocationProfile?: InputMaybe<
    Array<InputMaybe<PostQrCodeByProfileInput>>
  >;
  qrCodeLocation?: InputMaybe<PostQrCodeLocationInput>;
  qrCodeLocationPercent?: InputMaybe<PostQrCodeLocationPercentInput>;
  qrCodeStyle?: InputMaybe<PostQrCodeStyleInput>;
  qrCodeText?: InputMaybe<Scalars["String"]["input"]>;
  relatedPostAsset?: InputMaybe<Scalars["ID"]["input"]>;
  relatedPosts?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  staleFlyoutTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  tileAssets?: InputMaybe<Array<InputMaybe<PostTileAssetInput>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateProfileArgs = {
  background?: InputMaybe<ProfileBackgroundInput>;
  id: Scalars["String"]["input"];
  layouts?: InputMaybe<Array<ProfileLayoutInput>>;
  name: Scalars["String"]["input"];
  resting?: InputMaybe<ProfileRestingInput>;
  screen?: InputMaybe<ProfileScreenModelInput>;
  type: ScreenType;
};

export type MutationUpdateScheduledEventArgs = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  endActionOneOf?: InputMaybe<Array<ActionPayloadInputCombo>>;
  endProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  modifyType?: InputMaybe<ScheduledEventModificationType>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
  startActionOneOf?: InputMaybe<Array<ActionPayloadInputCombo>>;
  startProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateServiceArgs = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  defaultValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  id: Scalars["String"]["input"];
  options?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type MutationUpdateTagArgs = {
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconType?: InputMaybe<IconType>;
  id: Scalars["String"]["input"];
  mediaIcon?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationValidateGqlModelArgs = {
  action?: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
};

export type OrganizationFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrganizationModel = {
  __typename?: "OrganizationModel";
  id: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  orgId: Scalars["String"]["output"];
};

export enum OrientationType {
  Landscape = "landscape",
  Portrait = "portrait",
}

export type Post = {
  __typename?: "Post";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  flyoutPosition?: Maybe<PostFlyoutPositionModel>;
  flyoutScale?: Maybe<Scalars["Float"]["output"]>;
  flyoutShowCloseButton: Scalars["Boolean"]["output"];
  flyoutType?: Maybe<Scalars["ID"]["output"]>;
  hideFromSearch: Scalars["Boolean"]["output"];
  id?: Maybe<Scalars["String"]["output"]>;
  organization: Scalars["String"]["output"];
  qrCodeLink?: Maybe<Scalars["String"]["output"]>;
  qrCodeLinkByLocationProfile?: Maybe<Array<Maybe<PostQrCodeByProfile>>>;
  qrCodeLocation?: Maybe<PostQrCodeLocation>;
  qrCodeLocationPercent?: Maybe<PostQrCodeLocationPercent>;
  qrCodeStyle?: Maybe<PostQrCodeStyle>;
  qrCodeText?: Maybe<Scalars["String"]["output"]>;
  relatedPostAsset?: Maybe<Scalars["ID"]["output"]>;
  relatedPosts: Array<Scalars["ID"]["output"]>;
  staleFlyoutTimeout?: Maybe<Scalars["Float"]["output"]>;
  tags: Array<Scalars["ID"]["output"]>;
  tileAssets?: Maybe<Array<Maybe<PostTileAsset>>>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type PostFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  flyoutType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  hideFromSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  layouts?: InputMaybe<Array<Scalars["String"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  tileType?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PostFlyoutPositionModel = {
  __typename?: "PostFlyoutPositionModel";
  height?: Maybe<Scalars["Float"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type PostFlyoutPositionModelInput = {
  height?: InputMaybe<Scalars["Float"]["input"]>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum PostQrCodeAlignHorizontal {
  Center = "center",
  Left = "left",
  Right = "right",
}

export enum PostQrCodeAlignVertical {
  Bottom = "bottom",
  Center = "center",
  Top = "top",
}

export enum PostQrCodeBoxShape {
  Pill = "pill",
  Rounded = "rounded",
  Square = "square",
}

export type PostQrCodeByProfile = {
  __typename?: "PostQrCodeByProfile";
  location?: Maybe<Scalars["ID"]["output"]>;
  profile?: Maybe<Scalars["ID"]["output"]>;
  qrCodeLink?: Maybe<Scalars["String"]["output"]>;
};

export type PostQrCodeByProfileInput = {
  location?: InputMaybe<Scalars["ID"]["input"]>;
  profile?: InputMaybe<Scalars["ID"]["input"]>;
  qrCodeLink?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostQrCodeLocation = {
  __typename?: "PostQrCodeLocation";
  height?: Maybe<Scalars["Float"]["output"]>;
  size?: Maybe<PostQrCodeSize>;
  type?: Maybe<PostQrCodeLocationType>;
  width?: Maybe<Scalars["Float"]["output"]>;
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type PostQrCodeLocationInput = {
  height?: InputMaybe<Scalars["Float"]["input"]>;
  size?: InputMaybe<PostQrCodeSize>;
  type?: InputMaybe<PostQrCodeLocationType>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export type PostQrCodeLocationPercent = {
  __typename?: "PostQrCodeLocationPercent";
  height?: Maybe<Scalars["Float"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type PostQrCodeLocationPercentInput = {
  height?: InputMaybe<Scalars["Float"]["input"]>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum PostQrCodeLocationType {
  Bottom = "bottom",
  Custom = "custom",
  Top = "top",
}

export enum PostQrCodeSize {
  Large = "large",
  Medium = "medium",
  Small = "small",
}

export type PostQrCodeStyle = {
  __typename?: "PostQrCodeStyle";
  backdropColor?: Maybe<Scalars["String"]["output"]>;
  borderColor?: Maybe<Scalars["String"]["output"]>;
  borderEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  boxColor?: Maybe<Scalars["String"]["output"]>;
  boxShape?: Maybe<PostQrCodeBoxShape>;
  qrAlignHorizontal?: Maybe<PostQrCodeAlignHorizontal>;
  qrAlignVertical?: Maybe<PostQrCodeAlignVertical>;
  qrBackgroundColor?: Maybe<Scalars["String"]["output"]>;
  qrColor?: Maybe<Scalars["String"]["output"]>;
  qrSize?: Maybe<Scalars["Float"]["output"]>;
  textAlignHorizontal?: Maybe<PostQrCodeAlignHorizontal>;
  textAlignVertical?: Maybe<PostQrCodeAlignVertical>;
  textColor?: Maybe<Scalars["String"]["output"]>;
  textHidden?: Maybe<Scalars["Boolean"]["output"]>;
  textSize?: Maybe<Scalars["Float"]["output"]>;
};

export type PostQrCodeStyleInput = {
  backdropColor?: InputMaybe<Scalars["String"]["input"]>;
  borderColor?: InputMaybe<Scalars["String"]["input"]>;
  borderEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  boxColor?: InputMaybe<Scalars["String"]["input"]>;
  boxShape?: InputMaybe<PostQrCodeBoxShape>;
  qrAlignHorizontal?: InputMaybe<PostQrCodeAlignHorizontal>;
  qrAlignVertical?: InputMaybe<PostQrCodeAlignVertical>;
  qrBackgroundColor?: InputMaybe<Scalars["String"]["input"]>;
  qrColor?: InputMaybe<Scalars["String"]["input"]>;
  qrSize?: InputMaybe<Scalars["Float"]["input"]>;
  textAlignHorizontal?: InputMaybe<PostQrCodeAlignHorizontal>;
  textAlignVertical?: InputMaybe<PostQrCodeAlignVertical>;
  textColor?: InputMaybe<Scalars["String"]["input"]>;
  textHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  textSize?: InputMaybe<Scalars["Float"]["input"]>;
};

export type PostTileAsset = {
  __typename?: "PostTileAsset";
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  layout?: Maybe<Scalars["String"]["output"]>;
  media?: Maybe<Scalars["ID"]["output"]>;
  qrLinkPrefix?: Maybe<Scalars["String"]["output"]>;
  tileBackingImage?: Maybe<Scalars["ID"]["output"]>;
  tileType?: Maybe<Scalars["String"]["output"]>;
};

export type PostTileAssetInput = {
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  layout?: InputMaybe<Scalars["String"]["input"]>;
  media?: InputMaybe<Scalars["ID"]["input"]>;
  qrLinkPrefix?: InputMaybe<Scalars["String"]["input"]>;
  tileBackingImage?: InputMaybe<Scalars["ID"]["input"]>;
  tileType?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfileBackgroundInput = {
  backgroundMedia?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  backgroundMediaMode?: InputMaybe<BackgroundMediaMode>;
};

export type ProfileBackgroundModel = {
  __typename?: "ProfileBackgroundModel";
  backgroundMedia?: Maybe<Array<Scalars["ID"]["output"]>>;
  backgroundMediaMode?: Maybe<BackgroundMediaMode>;
};

export type ProfileFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Array<ScreenType>>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileLayoutInput = {
  detailed?: InputMaybe<Scalars["Boolean"]["input"]>;
  flyout?: InputMaybe<ProfileLayoutScreenFlyoutModelInput>;
  item?: InputMaybe<ProfileLayoutModelEntryInput>;
  items?: InputMaybe<Array<InputMaybe<ProfileLayoutModelEntryInput>>>;
  layout: Scalars["ID"]["input"];
  position?: InputMaybe<ProfileLayoutScreenPositionModelInput>;
};

export type ProfileLayoutModel = {
  __typename?: "ProfileLayoutModel";
  detailed?: Maybe<Scalars["Boolean"]["output"]>;
  flyout?: Maybe<ProfileLayoutScreenFlyoutModel>;
  item?: Maybe<ProfileLayoutModelEntry>;
  items?: Maybe<Array<Maybe<ProfileLayoutModelEntry>>>;
  layout?: Maybe<Scalars["ID"]["output"]>;
  position?: Maybe<ProfileLayoutScreenPositionModel>;
};

export type ProfileLayoutModelEntry = {
  __typename?: "ProfileLayoutModelEntry";
  posts?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
  tags?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
};

export type ProfileLayoutModelEntryInput = {
  posts?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ProfileLayoutScreenFlyoutModel = {
  __typename?: "ProfileLayoutScreenFlyoutModel";
  position?: Maybe<ProfileLayoutScreenPositionModel>;
};

export type ProfileLayoutScreenFlyoutModelInput = {
  position?: InputMaybe<ProfileLayoutScreenPositionModelInput>;
};

export type ProfileLayoutScreenModel = {
  __typename?: "ProfileLayoutScreenModel";
  columns?: Maybe<Scalars["Float"]["output"]>;
  count?: Maybe<Scalars["Float"]["output"]>;
  orientation?: Maybe<OrientationType>;
  resolution?: Maybe<Resolution>;
  rows?: Maybe<Scalars["Float"]["output"]>;
  size?: Maybe<ProfileScreenSizeModel>;
};

export type ProfileLayoutScreenPositionModel = {
  __typename?: "ProfileLayoutScreenPositionModel";
  height?: Maybe<Scalars["Float"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
  x?: Maybe<Scalars["Float"]["output"]>;
  y?: Maybe<Scalars["Float"]["output"]>;
};

export type ProfileLayoutScreenPositionModelInput = {
  height?: InputMaybe<Scalars["Float"]["input"]>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
  x?: InputMaybe<Scalars["Float"]["input"]>;
  y?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ProfileModel = {
  __typename?: "ProfileModel";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  background?: Maybe<ProfileBackgroundModel>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  layouts?: Maybe<Array<ProfileLayoutModel>>;
  name: Scalars["String"]["output"];
  organization: Scalars["String"]["output"];
  resting?: Maybe<ProfileRestingModel>;
  screen?: Maybe<ProfileLayoutScreenModel>;
  type?: Maybe<ScreenType>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ProfileRestingInput = {
  items?: InputMaybe<Array<ProfileRestingInputEntry>>;
  staleStateTimeout?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ProfileRestingInputEntry = {
  alphaOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  canInterrupt?: InputMaybe<Scalars["Boolean"]["input"]>;
  imageSettings?: InputMaybe<ProfileRestingInputEntryImageSettings>;
  media?: InputMaybe<Scalars["ID"]["input"]>;
  playAudio?: InputMaybe<Scalars["Boolean"]["input"]>;
  post?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProfileRestingInputEntryImageSettings = {
  showTime?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ProfileRestingModel = {
  __typename?: "ProfileRestingModel";
  items?: Maybe<Array<ProfileRestingModelEntry>>;
  staleStateTimeout?: Maybe<Scalars["Float"]["output"]>;
};

export type ProfileRestingModelEntry = {
  __typename?: "ProfileRestingModelEntry";
  alphaOn?: Maybe<Scalars["Boolean"]["output"]>;
  canInterrupt?: Maybe<Scalars["Boolean"]["output"]>;
  imageSettings?: Maybe<ProfileRestingModelEntryImageSettings>;
  media?: Maybe<Scalars["ID"]["output"]>;
  playAudio?: Maybe<Scalars["Boolean"]["output"]>;
  post?: Maybe<Scalars["ID"]["output"]>;
};

export type ProfileRestingModelEntryImageSettings = {
  __typename?: "ProfileRestingModelEntryImageSettings";
  showTime?: Maybe<Scalars["Float"]["output"]>;
};

export type ProfileScreenModelInput = {
  columns?: InputMaybe<Scalars["Float"]["input"]>;
  count?: InputMaybe<Scalars["Float"]["input"]>;
  orientation?: InputMaybe<OrientationType>;
  resolution?: InputMaybe<Resolution>;
  rows?: InputMaybe<Scalars["Float"]["input"]>;
  size?: InputMaybe<ProfileScreenModelSizeInput>;
};

export type ProfileScreenModelSizeInput = {
  height?: InputMaybe<Scalars["Float"]["input"]>;
  width?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ProfileScreenSizeModel = {
  __typename?: "ProfileScreenSizeModel";
  height?: Maybe<Scalars["Float"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  Customer: Customer;
  Device: Device;
  Layout: Layout;
  Location: Location;
  Media: Media;
  Post: Post;
  ScheduledEvent: ScheduledEvent;
  Service: Service;
  Tag: Tag;
  _allCustomersMeta: ListMetadata;
  _allDevicesMeta: ListMetadata;
  _allLayoutsMeta: ListMetadata;
  _allLocationsMeta: ListMetadata;
  _allManagementServicesMeta: ListMetadata;
  _allMediaMeta: ListMetadata;
  _allPostsMeta: ListMetadata;
  _allProfilesMeta: ListMetadata;
  _allScheduledEventsMeta: ListMetadata;
  _allServicesMeta: ListMetadata;
  _allTagsMeta: ListMetadata;
  allCustomers: Array<Customer>;
  allDevices: Array<Device>;
  allLayouts: Array<Layout>;
  allLocations: Array<Location>;
  allManagementServices: Array<Service>;
  allMedia: Array<Media>;
  allPosts: Array<Post>;
  allProfiles: Array<ProfileModel>;
  allScheduledEvents: Array<ScheduledEvent>;
  allServices: Array<Service>;
  allTags: Array<Tag>;
  getDeviceLicense: Device;
  getMediaDownloadUrl: MediaUrlModel;
  getMediaUploadUrl: MediaUrlModel;
  getOrganizations: Array<OrganizationModel>;
  getProfile: ProfileModel;
};

export type QueryCustomerArgs = {
  id: Scalars["String"]["input"];
};

export type QueryDeviceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLayoutArgs = {
  id: Scalars["String"]["input"];
};

export type QueryLocationArgs = {
  id: Scalars["String"]["input"];
};

export type QueryMediaArgs = {
  id: Scalars["String"]["input"];
};

export type QueryPostArgs = {
  id: Scalars["String"]["input"];
};

export type QueryScheduledEventArgs = {
  id: Scalars["String"]["input"];
};

export type QueryServiceArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTagArgs = {
  id: Scalars["String"]["input"];
};

export type Query_AllCustomersMetaArgs = {
  filter?: InputMaybe<CustomerFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllDevicesMetaArgs = {
  filter?: InputMaybe<DeviceFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllLayoutsMetaArgs = {
  filter?: InputMaybe<LayoutQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllLocationsMetaArgs = {
  filter?: InputMaybe<LocationFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllManagementServicesMetaArgs = {
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllMediaMetaArgs = {
  filter?: InputMaybe<MediaQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllPostsMetaArgs = {
  filter?: InputMaybe<PostFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllProfilesMetaArgs = {
  filter?: InputMaybe<ProfileFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllScheduledEventsMetaArgs = {
  filter?: InputMaybe<ScheduledEventFilter>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllServicesMetaArgs = {
  filter?: InputMaybe<ServiceQueryFilter>;
  orgId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query_AllTagsMetaArgs = {
  filter?: InputMaybe<TagQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllDevicesArgs = {
  filter?: InputMaybe<DeviceFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllLayoutsArgs = {
  filter?: InputMaybe<LayoutQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllLocationsArgs = {
  filter?: InputMaybe<LocationFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllManagementServicesArgs = {
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllMediaArgs = {
  filter?: InputMaybe<MediaQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllPostsArgs = {
  filter?: InputMaybe<PostFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllProfilesArgs = {
  filter?: InputMaybe<ProfileFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllScheduledEventsArgs = {
  filter?: InputMaybe<ScheduledEventFilter>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllServicesArgs = {
  filter?: InputMaybe<ServiceQueryFilter>;
  orgId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllTagsArgs = {
  filter?: InputMaybe<TagQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetDeviceLicenseArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetMediaDownloadUrlArgs = {
  fileName: Scalars["String"]["input"];
};

export type QueryGetMediaUploadUrlArgs = {
  fileName: Scalars["String"]["input"];
};

export type QueryGetOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  orgIds?: Array<Scalars["String"]["input"]>;
};

export type QueryGetProfileArgs = {
  id: Scalars["String"]["input"];
};

export enum Resolution {
  Fhd = "FHD",
  Uhd = "UHD",
}

export type ScheduledEvent = {
  __typename?: "ScheduledEvent";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  end?: Maybe<Scalars["DateTime"]["output"]>;
  endAction?: Maybe<Array<ActionPayload>>;
  endProcessed?: Maybe<Scalars["Boolean"]["output"]>;
  groupId?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  organization: Scalars["String"]["output"];
  recurring?: Maybe<ScheduledEventRecurringSettings>;
  start?: Maybe<Scalars["DateTime"]["output"]>;
  startAction?: Maybe<Array<ActionPayload>>;
  startProcessed?: Maybe<Scalars["Boolean"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ScheduledEventFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  end?: InputMaybe<Scalars["String"]["input"]>;
  endProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  end_gte?: InputMaybe<Scalars["String"]["input"]>;
  end_lte?: InputMaybe<Scalars["String"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["String"]["input"]>;
  startProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  start_gte?: InputMaybe<Scalars["String"]["input"]>;
  start_lte?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ScheduledEventModificationType {
  All = "all",
  Single = "single",
}

export type ScheduledEventRecurringSettings = {
  __typename?: "ScheduledEventRecurringSettings";
  bymonth?: Maybe<Array<Scalars["Float"]["output"]>>;
  byweekday?: Maybe<Array<Scalars["Float"]["output"]>>;
  count?: Maybe<Scalars["Float"]["output"]>;
  dtstart?: Maybe<Scalars["String"]["output"]>;
  freq?: Maybe<Scalars["Float"]["output"]>;
  interval?: Maybe<Scalars["Float"]["output"]>;
  tzid?: Maybe<Scalars["String"]["output"]>;
  until?: Maybe<Scalars["String"]["output"]>;
};

export enum ScreenType {
  Custom = "custom",
  Tv = "tv",
}

export type Service = {
  __typename?: "Service";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  defaultValues?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  machineName?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  options?: Maybe<ServiceOption>;
  type: ServiceTypes;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum ServiceAppCmsReferenceTypes {
  Layout = "Layout",
  Location = "Location",
  Media = "Media",
  Post = "Post",
  Profile = "Profile",
  Service = "Service",
  Tag = "Tag",
}

export type ServiceOption = {
  __typename?: "ServiceOption";
  cms?: Maybe<ServiceOptionApp>;
};

export type ServiceOptionApp = {
  __typename?: "ServiceOptionApp";
  post?: Maybe<ServiceOptionAppCmsFunction>;
  service?: Maybe<ServiceOptionAppCmsFunction>;
};

export type ServiceOptionAppCmsFunction = {
  __typename?: "ServiceOptionAppCmsFunction";
  extraFields?: Maybe<Array<ExtraFieldType>>;
  previewMediaSource?: Maybe<Scalars["String"]["output"]>;
  qrCodeEmbeddedInFlyout?: Maybe<Scalars["Boolean"]["output"]>;
  showMediaInput?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ServiceQueryFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<ServiceTypes>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ServiceTypes {
  Feature = "feature",
  Flyout = "flyout",
  Tile = "tile",
}

export type Tag = {
  __typename?: "Tag";
  _id?: Maybe<Scalars["String"]["output"]>;
  _version?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  customData?: Maybe<Scalars["JSONObject"]["output"]>;
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  iconType?: Maybe<IconType>;
  id?: Maybe<Scalars["String"]["output"]>;
  mediaIcon?: Maybe<Scalars["ID"]["output"]>;
  organization: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TagQueryFilter = {
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  iconType?: InputMaybe<Array<IconType>>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  q?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  withDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum Templates {
  Custom = "Custom",
  FiveByOne = "FiveByOne",
  FiveByThree = "FiveByThree",
  OneByFive = "OneByFive",
  OneByOne = "OneByOne",
  OneByThree = "OneByThree",
  ThreeByFive = "ThreeByFive",
  ThreeByOne = "ThreeByOne",
  TwoByTwo = "TwoByTwo",
  ZeroByZero = "ZeroByZero",
}

export enum TileRotatePattern {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export type ValidationModel = {
  __typename?: "ValidationModel";
  errors?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
};

export type GetCustomerQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetCustomerQuery = {
  __typename?: "Query";
  item: {
    __typename: "Customer";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    key: string;
    name: string;
    updatedAt?: any | null;
    auth0?: {
      __typename?: "CustomerAuth0Config";
      organizationId?: string | null;
    } | null;
  };
};

export type GetCustomerGridQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCustomerGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Customer";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    key: string;
    name: string;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetCustomerListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<CustomerFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetCustomerListNameIdQuery = {
  __typename?: "Query";
  items: Array<{ __typename?: "Customer"; id?: string | null; name: string }>;
};

export type CreateCustomerMutationVariables = Exact<{
  activatedAnalytics?: InputMaybe<CustomerAnalyticsConfigInput>;
  name: Scalars["String"]["input"];
}>;

export type CreateCustomerMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Customer";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    key: string;
    name: string;
    updatedAt?: any | null;
    auth0?: {
      __typename?: "CustomerAuth0Config";
      organizationId?: string | null;
    } | null;
  };
};

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteCustomerMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateCustomerMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  activatedAnalytics?: InputMaybe<CustomerAnalyticsConfigInput>;
  name: Scalars["String"]["input"];
}>;

export type UpdateCustomerMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Customer";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    key: string;
    name: string;
    updatedAt?: any | null;
    auth0?: {
      __typename?: "CustomerAuth0Config";
      organizationId?: string | null;
    } | null;
  };
};

export type GetDeviceQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetDeviceQuery = {
  __typename?: "Query";
  item: {
    __typename: "Device";
    _id?: string | null;
    _version?: number | null;
    assetTag: string;
    building?: string | null;
    createdAt?: any | null;
    customer: string;
    deleted?: boolean | null;
    id?: string | null;
    license?: string | null;
    licenseVersion?: number | null;
    location?: string | null;
    name?: string | null;
    organization: string;
    room?: string | null;
    status: DeviceStatus;
    updatedAt?: any | null;
    config?: {
      __typename?: "DeviceActivationConfig";
      analytics?: boolean | null;
      openDevToolsOnStart?: boolean | null;
      menu?: DeviceMenuLocation | null;
    } | null;
  };
};

export type GetDeviceGridQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDeviceGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Device";
    _id?: string | null;
    _version?: number | null;
    assetTag: string;
    building?: string | null;
    customer: string;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    location?: string | null;
    name?: string | null;
    organization: string;
    room?: string | null;
    status: DeviceStatus;
    updatedAt?: any | null;
    config?: {
      __typename?: "DeviceActivationConfig";
      analytics?: boolean | null;
      openDevToolsOnStart?: boolean | null;
      menu?: DeviceMenuLocation | null;
    } | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetDeviceListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDeviceListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "Device";
    id?: string | null;
    name?: string | null;
  }>;
};

export type CreateDeviceMutationVariables = Exact<{
  assetTag: Scalars["String"]["input"];
  building?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<DeviceActivationConfigInput>;
  customer: Scalars["ID"]["input"];
  location?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<
    Array<Scalars["JSONObject"]["input"]> | Scalars["JSONObject"]["input"]
  >;
  status: DeviceStatus;
}>;

export type CreateDeviceMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Device";
    _id?: string | null;
    _version?: number | null;
    assetTag: string;
    building?: string | null;
    createdAt?: any | null;
    customer: string;
    deleted?: boolean | null;
    id?: string | null;
    license?: string | null;
    licenseVersion?: number | null;
    location?: string | null;
    name?: string | null;
    organization: string;
    room?: string | null;
    status: DeviceStatus;
    updatedAt?: any | null;
    config?: {
      __typename?: "DeviceActivationConfig";
      analytics?: boolean | null;
      openDevToolsOnStart?: boolean | null;
      menu?: DeviceMenuLocation | null;
    } | null;
  };
};

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteDeviceMutation = { __typename?: "Mutation"; data: boolean };

export type RegenerateDeviceLicenseMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type RegenerateDeviceLicenseMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Device";
    _id?: string | null;
    _version?: number | null;
    assetTag: string;
    building?: string | null;
    createdAt?: any | null;
    customer: string;
    deleted?: boolean | null;
    id?: string | null;
    license?: string | null;
    licenseVersion?: number | null;
    location?: string | null;
    name?: string | null;
    organization: string;
    room?: string | null;
    status: DeviceStatus;
    updatedAt?: any | null;
    config?: {
      __typename?: "DeviceActivationConfig";
      analytics?: boolean | null;
      openDevToolsOnStart?: boolean | null;
      menu?: DeviceMenuLocation | null;
    } | null;
  };
};

export type UpdateDeviceMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  assetTag: Scalars["String"]["input"];
  building?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<DeviceActivationConfigInput>;
  customer: Scalars["ID"]["input"];
  location?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  room?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<
    Array<Scalars["JSONObject"]["input"]> | Scalars["JSONObject"]["input"]
  >;
  status: DeviceStatus;
}>;

export type UpdateDeviceMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Device";
    _id?: string | null;
    _version?: number | null;
    assetTag: string;
    building?: string | null;
    createdAt?: any | null;
    customer: string;
    deleted?: boolean | null;
    id?: string | null;
    license?: string | null;
    licenseVersion?: number | null;
    location?: string | null;
    name?: string | null;
    organization: string;
    room?: string | null;
    status: DeviceStatus;
    updatedAt?: any | null;
    config?: {
      __typename?: "DeviceActivationConfig";
      analytics?: boolean | null;
      openDevToolsOnStart?: boolean | null;
      menu?: DeviceMenuLocation | null;
    } | null;
  };
};

type AnimationOptionFragment_AnimationOptionFade_Fragment = {
  __typename?: "AnimationOptionFade";
  type: string;
  duration: number;
};

type AnimationOptionFragment_AnimationOptionFlip_Fragment = {
  __typename?: "AnimationOptionFlip";
  type: string;
  direction: TileRotatePattern;
  duration: number;
};

type AnimationOptionFragment_AnimationOptionWipe_Fragment = {
  __typename?: "AnimationOptionWipe";
  type: string;
  duration: number;
  function: AnimationWipeFunction;
};

export type AnimationOptionFragmentFragment =
  | AnimationOptionFragment_AnimationOptionFade_Fragment
  | AnimationOptionFragment_AnimationOptionFlip_Fragment
  | AnimationOptionFragment_AnimationOptionWipe_Fragment;

export type GetLayoutQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetLayoutQuery = {
  __typename?: "Query";
  item: {
    __typename: "Layout";
    _id?: string | null;
    _version?: number | null;
    id?: string | null;
    borderRadius?: number | null;
    name?: string | null;
    organization: string;
    padding?: number | null;
    template?: Templates | null;
    tileCount?: number | null;
    animation?: {
      __typename?: "Animation";
      enabled: boolean;
      option:
        | { __typename?: "AnimationOptionFade"; type: string; duration: number }
        | {
            __typename?: "AnimationOptionFlip";
            type: string;
            direction: TileRotatePattern;
            duration: number;
          }
        | {
            __typename?: "AnimationOptionWipe";
            type: string;
            duration: number;
            function: AnimationWipeFunction;
          };
    } | null;
    content?: {
      __typename?: "ContentUpdateOptions";
      tileContentUpdatePct?: number | null;
      tileContentUpdateFrequency?: number | null;
      staleFlyoutTimeout?: number | null;
    } | null;
    custom?: {
      __typename?: "LayoutCustomModel";
      width: number;
      height: number;
      positions: Array<{
        __typename?: "LayoutCustomModelPosition";
        x: number;
        y: number;
        width: number;
        height: number;
      }>;
    } | null;
  };
};

export type GetLayoutGridQueryVariables = Exact<{
  filter?: InputMaybe<LayoutQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLayoutGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Layout";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name?: string | null;
    organization: string;
    template?: Templates | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetLayoutListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<LayoutQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLayoutListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "Layout";
    id?: string | null;
    name?: string | null;
  }>;
};

export type CreateLayoutMutationVariables = Exact<{
  animation: AnimationInput;
  borderRadius: Scalars["Float"]["input"];
  content: ContentUpdateOptionsInput;
  custom?: InputMaybe<LayoutCustomModelInput>;
  name: Scalars["String"]["input"];
  padding: Scalars["Float"]["input"];
  template: Scalars["String"]["input"];
  tileCount: Scalars["Float"]["input"];
}>;

export type CreateLayoutMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Layout";
    _id?: string | null;
    _version?: number | null;
    id?: string | null;
    borderRadius?: number | null;
    name?: string | null;
    organization: string;
    padding?: number | null;
    template?: Templates | null;
    tileCount?: number | null;
    animation?: {
      __typename?: "Animation";
      enabled: boolean;
      option:
        | { __typename?: "AnimationOptionFade"; type: string; duration: number }
        | {
            __typename?: "AnimationOptionFlip";
            type: string;
            direction: TileRotatePattern;
            duration: number;
          }
        | {
            __typename?: "AnimationOptionWipe";
            type: string;
            duration: number;
            function: AnimationWipeFunction;
          };
    } | null;
    content?: {
      __typename?: "ContentUpdateOptions";
      tileContentUpdatePct?: number | null;
      tileContentUpdateFrequency?: number | null;
      staleFlyoutTimeout?: number | null;
    } | null;
    custom?: {
      __typename?: "LayoutCustomModel";
      width: number;
      height: number;
      positions: Array<{
        __typename?: "LayoutCustomModelPosition";
        x: number;
        y: number;
        width: number;
        height: number;
      }>;
    } | null;
  };
};

export type DeleteLayoutMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteLayoutMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateLayoutMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  animation: AnimationInput;
  borderRadius: Scalars["Float"]["input"];
  content: ContentUpdateOptionsInput;
  custom?: InputMaybe<LayoutCustomModelInput>;
  name: Scalars["String"]["input"];
  padding: Scalars["Float"]["input"];
  template: Scalars["String"]["input"];
  tileCount: Scalars["Float"]["input"];
}>;

export type UpdateLayoutMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Layout";
    _id?: string | null;
    _version?: number | null;
    id?: string | null;
    borderRadius?: number | null;
    name?: string | null;
    organization: string;
    padding?: number | null;
    template?: Templates | null;
    tileCount?: number | null;
    animation?: {
      __typename?: "Animation";
      enabled: boolean;
      option:
        | { __typename?: "AnimationOptionFade"; type: string; duration: number }
        | {
            __typename?: "AnimationOptionFlip";
            type: string;
            direction: TileRotatePattern;
            duration: number;
          }
        | {
            __typename?: "AnimationOptionWipe";
            type: string;
            duration: number;
            function: AnimationWipeFunction;
          };
    } | null;
    content?: {
      __typename?: "ContentUpdateOptions";
      tileContentUpdatePct?: number | null;
      tileContentUpdateFrequency?: number | null;
      staleFlyoutTimeout?: number | null;
    } | null;
    custom?: {
      __typename?: "LayoutCustomModel";
      width: number;
      height: number;
      positions: Array<{
        __typename?: "LayoutCustomModelPosition";
        x: number;
        y: number;
        width: number;
        height: number;
      }>;
    } | null;
  };
};

export type GetLocationQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetLocationQuery = {
  __typename?: "Query";
  item: {
    __typename: "Location";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    profile?: string | null;
    updatedAt?: any | null;
    device?: {
      __typename?: "LocationDeviceConfig";
      appMenu?: {
        __typename?: "LocationDeviceConfigAppMenu";
        positions?: Array<string> | null;
        show?: boolean | null;
      } | null;
      screens?: {
        __typename?: "LocationDeviceConfigScreen";
        fullscreen?: boolean | null;
        overscan?: {
          __typename?: "LocationDeviceConfigOverscan";
          bottom?: number | null;
          left?: number | null;
          right?: number | null;
          top?: number | null;
        } | null;
        screenOffset?: {
          __typename?: "LocationDeviceConfigScreenOffset";
          x?: number | null;
          y?: number | null;
        } | null;
        videoSource?: {
          __typename?: "LocationDeviceConfigVideoSource";
          enabled?: boolean | null;
          showCloseButton?: boolean | null;
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
    } | null;
  };
};

export type GetLocationGridQueryVariables = Exact<{
  filter?: InputMaybe<LocationFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLocationGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Location";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    profile?: string | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetLocationListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<LocationFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetLocationListNameIdQuery = {
  __typename?: "Query";
  items: Array<{ __typename?: "Location"; id?: string | null; name: string }>;
};

export type CreateLocationMutationVariables = Exact<{
  device?: InputMaybe<LocationDeviceInput>;
  name: Scalars["String"]["input"];
  profile?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CreateLocationMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Location";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    profile?: string | null;
    updatedAt?: any | null;
    device?: {
      __typename?: "LocationDeviceConfig";
      appMenu?: {
        __typename?: "LocationDeviceConfigAppMenu";
        positions?: Array<string> | null;
        show?: boolean | null;
      } | null;
      screens?: {
        __typename?: "LocationDeviceConfigScreen";
        fullscreen?: boolean | null;
        overscan?: {
          __typename?: "LocationDeviceConfigOverscan";
          bottom?: number | null;
          left?: number | null;
          right?: number | null;
          top?: number | null;
        } | null;
        screenOffset?: {
          __typename?: "LocationDeviceConfigScreenOffset";
          x?: number | null;
          y?: number | null;
        } | null;
        videoSource?: {
          __typename?: "LocationDeviceConfigVideoSource";
          enabled?: boolean | null;
          showCloseButton?: boolean | null;
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
    } | null;
  };
};

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteLocationMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  device?: InputMaybe<LocationDeviceInput>;
  name: Scalars["String"]["input"];
  profile?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type UpdateLocationMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Location";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    profile?: string | null;
    updatedAt?: any | null;
    device?: {
      __typename?: "LocationDeviceConfig";
      appMenu?: {
        __typename?: "LocationDeviceConfigAppMenu";
        positions?: Array<string> | null;
        show?: boolean | null;
      } | null;
      screens?: {
        __typename?: "LocationDeviceConfigScreen";
        fullscreen?: boolean | null;
        overscan?: {
          __typename?: "LocationDeviceConfigOverscan";
          bottom?: number | null;
          left?: number | null;
          right?: number | null;
          top?: number | null;
        } | null;
        screenOffset?: {
          __typename?: "LocationDeviceConfigScreenOffset";
          x?: number | null;
          y?: number | null;
        } | null;
        videoSource?: {
          __typename?: "LocationDeviceConfigVideoSource";
          enabled?: boolean | null;
          showCloseButton?: boolean | null;
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
    } | null;
  };
};

export type GetMediaQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetMediaQuery = {
  __typename?: "Query";
  item: {
    __typename: "Media";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    file?: string | null;
    id?: string | null;
    isDir: boolean;
    name: string;
    organization: string;
    parent?: string | null;
    root?: boolean | null;
    size?: number | null;
    type?: string | null;
    updatedAt?: any | null;
    lottie?: {
      __typename?: "LottieAsset";
      data?: any | null;
      speed?: number | null;
    } | null;
  };
};

export type GetMediaGridQueryVariables = Exact<{
  filter?: InputMaybe<MediaQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetMediaGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Media";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    file?: string | null;
    id?: string | null;
    isDir: boolean;
    name: string;
    organization: string;
    parent?: string | null;
    root?: boolean | null;
    size?: number | null;
    type?: string | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetMediaDownloadUrlQueryVariables = Exact<{
  fileName: Scalars["String"]["input"];
}>;

export type GetMediaDownloadUrlQuery = {
  __typename?: "Query";
  item: {
    __typename: "MediaUrlModel";
    fileName?: string | null;
    url?: string | null;
  };
};

export type GetMediaUploadUrlQueryVariables = Exact<{
  fileName: Scalars["String"]["input"];
}>;

export type GetMediaUploadUrlQuery = {
  __typename?: "Query";
  item: {
    __typename: "MediaUrlModel";
    fileName?: string | null;
    url?: string | null;
  };
};

export type CreateMediaMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]["input"]>;
  isDir?: InputMaybe<Scalars["Boolean"]["input"]>;
  parent?: InputMaybe<Scalars["ID"]["input"]>;
  size?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["String"]["input"]>;
  lottie?: InputMaybe<MediaLottieAsset>;
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
}>;

export type CreateMediaMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Media";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    customData?: any | null;
    deleted?: boolean | null;
    file?: string | null;
    id?: string | null;
    isDir: boolean;
    name: string;
    organization: string;
    parent?: string | null;
    root?: boolean | null;
    size?: number | null;
    type?: string | null;
    updatedAt?: any | null;
    lottie?: {
      __typename: "LottieAsset";
      data?: any | null;
      speed?: number | null;
    } | null;
  };
};

export type DeleteMediaMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteMediaMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateMediaMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  isDir?: InputMaybe<Scalars["Boolean"]["input"]>;
  parent?: InputMaybe<Scalars["ID"]["input"]>;
  size?: InputMaybe<Scalars["Float"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["String"]["input"]>;
  lottie?: InputMaybe<MediaLottieAsset>;
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
}>;

export type UpdateMediaMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Media";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    customData?: any | null;
    deleted?: boolean | null;
    file?: string | null;
    id?: string | null;
    isDir: boolean;
    name: string;
    organization: string;
    parent?: string | null;
    root?: boolean | null;
    size?: number | null;
    type?: string | null;
    updatedAt?: any | null;
    lottie?: {
      __typename: "LottieAsset";
      data?: any | null;
      speed?: number | null;
    } | null;
  };
};

export type GetOrganizationListNameIdQueryVariables = Exact<{
  orgIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  filter?: InputMaybe<OrganizationFilter>;
}>;

export type GetOrganizationListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "OrganizationModel";
    id: string;
    name?: string | null;
    orgId: string;
  }>;
};

export type GetPostQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetPostQuery = {
  __typename?: "Query";
  item: {
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    customData?: any | null;
    deleted?: boolean | null;
    enabled?: boolean | null;
    flyoutShowCloseButton: boolean;
    flyoutScale?: number | null;
    flyoutType?: string | null;
    hideFromSearch: boolean;
    id?: string | null;
    organization: string;
    qrCodeLink?: string | null;
    qrCodeText?: string | null;
    relatedPostAsset?: string | null;
    relatedPosts: Array<string>;
    staleFlyoutTimeout?: number | null;
    tags: Array<string>;
    title?: string | null;
    updatedAt?: any | null;
    flyoutPosition?: {
      __typename?: "PostFlyoutPositionModel";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLinkByLocationProfile?: Array<{
      __typename?: "PostQrCodeByProfile";
      location?: string | null;
      profile?: string | null;
      qrCodeLink?: string | null;
    } | null> | null;
    qrCodeLocation?: {
      __typename?: "PostQrCodeLocation";
      type?: PostQrCodeLocationType | null;
      size?: PostQrCodeSize | null;
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLocationPercent?: {
      __typename?: "PostQrCodeLocationPercent";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeStyle?: {
      __typename?: "PostQrCodeStyle";
      backdropColor?: string | null;
      boxShape?: PostQrCodeBoxShape | null;
      boxColor?: string | null;
      borderEnabled?: boolean | null;
      borderColor?: string | null;
      textColor?: string | null;
      textSize?: number | null;
      textHidden?: boolean | null;
      qrColor?: string | null;
      qrBackgroundColor?: string | null;
      qrSize?: number | null;
      qrAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      qrAlignVertical?: PostQrCodeAlignVertical | null;
      textAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      textAlignVertical?: PostQrCodeAlignVertical | null;
    } | null;
    tileAssets?: Array<{
      __typename?: "PostTileAsset";
      customData?: any | null;
      layout?: string | null;
      media?: string | null;
      qrLinkPrefix?: string | null;
      tileBackingImage?: string | null;
      tileType?: string | null;
    } | null> | null;
  };
};

export type GetPostGridQueryVariables = Exact<{
  filter?: InputMaybe<PostFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPostGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    enabled?: boolean | null;
    flyoutType?: string | null;
    id?: string | null;
    organization: string;
    tags: Array<string>;
    title?: string | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetPostListFullQueryVariables = Exact<{
  filter?: InputMaybe<PostFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPostListFullQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    customData?: any | null;
    deleted?: boolean | null;
    enabled?: boolean | null;
    flyoutShowCloseButton: boolean;
    flyoutScale?: number | null;
    flyoutType?: string | null;
    hideFromSearch: boolean;
    id?: string | null;
    organization: string;
    qrCodeLink?: string | null;
    qrCodeText?: string | null;
    relatedPostAsset?: string | null;
    relatedPosts: Array<string>;
    staleFlyoutTimeout?: number | null;
    tags: Array<string>;
    title?: string | null;
    updatedAt?: any | null;
    flyoutPosition?: {
      __typename?: "PostFlyoutPositionModel";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLinkByLocationProfile?: Array<{
      __typename?: "PostQrCodeByProfile";
      location?: string | null;
      profile?: string | null;
      qrCodeLink?: string | null;
    } | null> | null;
    qrCodeLocation?: {
      __typename?: "PostQrCodeLocation";
      type?: PostQrCodeLocationType | null;
      size?: PostQrCodeSize | null;
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLocationPercent?: {
      __typename?: "PostQrCodeLocationPercent";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeStyle?: {
      __typename?: "PostQrCodeStyle";
      backdropColor?: string | null;
      boxShape?: PostQrCodeBoxShape | null;
      boxColor?: string | null;
      borderEnabled?: boolean | null;
      borderColor?: string | null;
      textColor?: string | null;
      textSize?: number | null;
      textHidden?: boolean | null;
      qrColor?: string | null;
      qrBackgroundColor?: string | null;
      qrSize?: number | null;
      qrAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      qrAlignVertical?: PostQrCodeAlignVertical | null;
      textAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      textAlignVertical?: PostQrCodeAlignVertical | null;
    } | null;
    tileAssets?: Array<{
      __typename?: "PostTileAsset";
      customData?: any | null;
      layout?: string | null;
      media?: string | null;
      qrLinkPrefix?: string | null;
      tileBackingImage?: string | null;
      tileType?: string | null;
    } | null> | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetPostListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<PostFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sample?: InputMaybe<Scalars["Boolean"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPostListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "Post";
    id?: string | null;
    title?: string | null;
  }>;
  total: { __typename?: "ListMetadata"; count: number };
};

export type CreatePostMutationVariables = Exact<{
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  enabled: Scalars["Boolean"]["input"];
  flyoutPosition?: InputMaybe<PostFlyoutPositionModelInput>;
  flyoutShowCloseButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  flyoutScale?: InputMaybe<Scalars["Float"]["input"]>;
  flyoutType?: InputMaybe<Scalars["ID"]["input"]>;
  hideFromSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
  qrCodeLink?: InputMaybe<Scalars["String"]["input"]>;
  qrCodeLinkByLocationProfile?: InputMaybe<
    Array<PostQrCodeByProfileInput> | PostQrCodeByProfileInput
  >;
  qrCodeLocation?: InputMaybe<PostQrCodeLocationInput>;
  qrCodeLocationPercent?: InputMaybe<PostQrCodeLocationPercentInput>;
  qrCodeStyle?: InputMaybe<PostQrCodeStyleInput>;
  qrCodeText?: InputMaybe<Scalars["String"]["input"]>;
  relatedPostAsset?: InputMaybe<Scalars["ID"]["input"]>;
  relatedPosts?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  staleFlyoutTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  tags?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  tileAssets?: InputMaybe<Array<PostTileAssetInput> | PostTileAssetInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreatePostMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    customData?: any | null;
    deleted?: boolean | null;
    enabled?: boolean | null;
    flyoutShowCloseButton: boolean;
    flyoutScale?: number | null;
    flyoutType?: string | null;
    hideFromSearch: boolean;
    id?: string | null;
    organization: string;
    qrCodeLink?: string | null;
    qrCodeText?: string | null;
    relatedPostAsset?: string | null;
    relatedPosts: Array<string>;
    staleFlyoutTimeout?: number | null;
    tags: Array<string>;
    title?: string | null;
    updatedAt?: any | null;
    flyoutPosition?: {
      __typename?: "PostFlyoutPositionModel";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLinkByLocationProfile?: Array<{
      __typename?: "PostQrCodeByProfile";
      location?: string | null;
      profile?: string | null;
      qrCodeLink?: string | null;
    } | null> | null;
    qrCodeLocation?: {
      __typename?: "PostQrCodeLocation";
      type?: PostQrCodeLocationType | null;
      size?: PostQrCodeSize | null;
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLocationPercent?: {
      __typename?: "PostQrCodeLocationPercent";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeStyle?: {
      __typename?: "PostQrCodeStyle";
      backdropColor?: string | null;
      boxShape?: PostQrCodeBoxShape | null;
      boxColor?: string | null;
      borderEnabled?: boolean | null;
      borderColor?: string | null;
      textColor?: string | null;
      textSize?: number | null;
      textHidden?: boolean | null;
      qrColor?: string | null;
      qrBackgroundColor?: string | null;
      qrSize?: number | null;
      qrAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      qrAlignVertical?: PostQrCodeAlignVertical | null;
      textAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      textAlignVertical?: PostQrCodeAlignVertical | null;
    } | null;
    tileAssets?: Array<{
      __typename?: "PostTileAsset";
      customData?: any | null;
      layout?: string | null;
      media?: string | null;
      qrLinkPrefix?: string | null;
      tileBackingImage?: string | null;
      tileType?: string | null;
    } | null> | null;
  };
};

export type DeletePostMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeletePostMutation = { __typename?: "Mutation"; data: boolean };

export type EnablePostMutationVariables = Exact<{
  enabled: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
}>;

export type EnablePostMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    enabled?: boolean | null;
    id?: string | null;
    updatedAt?: any | null;
  };
};

export type UpdatePostMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  customData?: InputMaybe<Scalars["JSONObject"]["input"]>;
  enabled: Scalars["Boolean"]["input"];
  flyoutPosition?: InputMaybe<PostFlyoutPositionModelInput>;
  flyoutShowCloseButton?: InputMaybe<Scalars["Boolean"]["input"]>;
  flyoutScale?: InputMaybe<Scalars["Float"]["input"]>;
  flyoutType?: InputMaybe<Scalars["ID"]["input"]>;
  hideFromSearch?: InputMaybe<Scalars["Boolean"]["input"]>;
  qrCodeLink?: InputMaybe<Scalars["String"]["input"]>;
  qrCodeLinkByLocationProfile?: InputMaybe<
    Array<PostQrCodeByProfileInput> | PostQrCodeByProfileInput
  >;
  qrCodeLocation?: InputMaybe<PostQrCodeLocationInput>;
  qrCodeLocationPercent?: InputMaybe<PostQrCodeLocationPercentInput>;
  qrCodeStyle?: InputMaybe<PostQrCodeStyleInput>;
  qrCodeText?: InputMaybe<Scalars["String"]["input"]>;
  relatedPostAsset?: InputMaybe<Scalars["ID"]["input"]>;
  relatedPosts?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  staleFlyoutTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  tags?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
  tileAssets?: InputMaybe<Array<PostTileAssetInput> | PostTileAssetInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdatePostMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Post";
    _id?: string | null;
    _version?: number | null;
    customData?: any | null;
    deleted?: boolean | null;
    enabled?: boolean | null;
    flyoutShowCloseButton: boolean;
    flyoutScale?: number | null;
    flyoutType?: string | null;
    hideFromSearch: boolean;
    id?: string | null;
    organization: string;
    qrCodeLink?: string | null;
    qrCodeText?: string | null;
    relatedPostAsset?: string | null;
    relatedPosts: Array<string>;
    staleFlyoutTimeout?: number | null;
    tags: Array<string>;
    title?: string | null;
    updatedAt?: any | null;
    flyoutPosition?: {
      __typename?: "PostFlyoutPositionModel";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLinkByLocationProfile?: Array<{
      __typename?: "PostQrCodeByProfile";
      location?: string | null;
      profile?: string | null;
      qrCodeLink?: string | null;
    } | null> | null;
    qrCodeLocation?: {
      __typename?: "PostQrCodeLocation";
      type?: PostQrCodeLocationType | null;
      size?: PostQrCodeSize | null;
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeLocationPercent?: {
      __typename?: "PostQrCodeLocationPercent";
      x?: number | null;
      y?: number | null;
      width?: number | null;
      height?: number | null;
    } | null;
    qrCodeStyle?: {
      __typename?: "PostQrCodeStyle";
      backdropColor?: string | null;
      boxShape?: PostQrCodeBoxShape | null;
      boxColor?: string | null;
      borderEnabled?: boolean | null;
      borderColor?: string | null;
      textColor?: string | null;
      textSize?: number | null;
      textHidden?: boolean | null;
      qrColor?: string | null;
      qrBackgroundColor?: string | null;
      qrSize?: number | null;
      qrAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      qrAlignVertical?: PostQrCodeAlignVertical | null;
      textAlignHorizontal?: PostQrCodeAlignHorizontal | null;
      textAlignVertical?: PostQrCodeAlignVertical | null;
    } | null;
    tileAssets?: Array<{
      __typename?: "PostTileAsset";
      customData?: any | null;
      layout?: string | null;
      media?: string | null;
      qrLinkPrefix?: string | null;
      tileBackingImage?: string | null;
      tileType?: string | null;
    } | null> | null;
  };
};

export type GetProfileQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetProfileQuery = {
  __typename?: "Query";
  item: {
    __typename: "ProfileModel";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    type?: ScreenType | null;
    updatedAt?: any | null;
    background?: {
      __typename?: "ProfileBackgroundModel";
      backgroundMedia?: Array<string> | null;
      backgroundMediaMode?: BackgroundMediaMode | null;
    } | null;
    layouts?: Array<{
      __typename?: "ProfileLayoutModel";
      detailed?: boolean | null;
      layout?: string | null;
      flyout?: {
        __typename?: "ProfileLayoutScreenFlyoutModel";
        position?: {
          __typename?: "ProfileLayoutScreenPositionModel";
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
      item?: {
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null;
      items?: Array<{
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null> | null;
      position?: {
        __typename?: "ProfileLayoutScreenPositionModel";
        x?: number | null;
        y?: number | null;
        width?: number | null;
        height?: number | null;
      } | null;
    }> | null;
    resting?: {
      __typename?: "ProfileRestingModel";
      staleStateTimeout?: number | null;
      items?: Array<{
        __typename?: "ProfileRestingModelEntry";
        alphaOn?: boolean | null;
        canInterrupt?: boolean | null;
        media?: string | null;
        playAudio?: boolean | null;
        post?: string | null;
        imageSettings?: {
          __typename?: "ProfileRestingModelEntryImageSettings";
          showTime?: number | null;
        } | null;
      }> | null;
    } | null;
    screen?: {
      __typename?: "ProfileLayoutScreenModel";
      columns?: number | null;
      count?: number | null;
      orientation?: OrientationType | null;
      resolution?: Resolution | null;
      rows?: number | null;
      size?: {
        __typename?: "ProfileScreenSizeModel";
        width?: number | null;
        height?: number | null;
      } | null;
    } | null;
  };
};

export type GetProfileGridQueryVariables = Exact<{
  filter?: InputMaybe<ProfileFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProfileGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "ProfileModel";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    type?: ScreenType | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetProfileListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<ProfileFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetProfileListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "ProfileModel";
    id?: string | null;
    name: string;
  }>;
};

export type CreateProfileMutationVariables = Exact<{
  background?: InputMaybe<ProfileBackgroundInput>;
  layouts?: InputMaybe<Array<ProfileLayoutInput> | ProfileLayoutInput>;
  name: Scalars["String"]["input"];
  resting?: InputMaybe<ProfileRestingInput>;
  screen?: InputMaybe<ProfileScreenModelInput>;
  type: ScreenType;
}>;

export type CreateProfileMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "ProfileModel";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    type?: ScreenType | null;
    updatedAt?: any | null;
    background?: {
      __typename?: "ProfileBackgroundModel";
      backgroundMedia?: Array<string> | null;
      backgroundMediaMode?: BackgroundMediaMode | null;
    } | null;
    layouts?: Array<{
      __typename?: "ProfileLayoutModel";
      detailed?: boolean | null;
      layout?: string | null;
      flyout?: {
        __typename?: "ProfileLayoutScreenFlyoutModel";
        position?: {
          __typename?: "ProfileLayoutScreenPositionModel";
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
      item?: {
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null;
      items?: Array<{
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null> | null;
      position?: {
        __typename?: "ProfileLayoutScreenPositionModel";
        x?: number | null;
        y?: number | null;
        width?: number | null;
        height?: number | null;
      } | null;
    }> | null;
    resting?: {
      __typename?: "ProfileRestingModel";
      staleStateTimeout?: number | null;
      items?: Array<{
        __typename?: "ProfileRestingModelEntry";
        alphaOn?: boolean | null;
        canInterrupt?: boolean | null;
        media?: string | null;
        playAudio?: boolean | null;
        post?: string | null;
        imageSettings?: {
          __typename?: "ProfileRestingModelEntryImageSettings";
          showTime?: number | null;
        } | null;
      }> | null;
    } | null;
    screen?: {
      __typename?: "ProfileLayoutScreenModel";
      columns?: number | null;
      count?: number | null;
      orientation?: OrientationType | null;
      resolution?: Resolution | null;
      rows?: number | null;
      size?: {
        __typename?: "ProfileScreenSizeModel";
        width?: number | null;
        height?: number | null;
      } | null;
    } | null;
  };
};

export type DeleteProfileMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteProfileMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateProfileMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  background?: InputMaybe<ProfileBackgroundInput>;
  layouts?: InputMaybe<Array<ProfileLayoutInput> | ProfileLayoutInput>;
  name: Scalars["String"]["input"];
  resting?: InputMaybe<ProfileRestingInput>;
  screen?: InputMaybe<ProfileScreenModelInput>;
  type: ScreenType;
}>;

export type UpdateProfileMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "ProfileModel";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    name: string;
    organization: string;
    type?: ScreenType | null;
    updatedAt?: any | null;
    background?: {
      __typename?: "ProfileBackgroundModel";
      backgroundMedia?: Array<string> | null;
      backgroundMediaMode?: BackgroundMediaMode | null;
    } | null;
    layouts?: Array<{
      __typename?: "ProfileLayoutModel";
      detailed?: boolean | null;
      layout?: string | null;
      flyout?: {
        __typename?: "ProfileLayoutScreenFlyoutModel";
        position?: {
          __typename?: "ProfileLayoutScreenPositionModel";
          x?: number | null;
          y?: number | null;
          width?: number | null;
          height?: number | null;
        } | null;
      } | null;
      item?: {
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null;
      items?: Array<{
        __typename?: "ProfileLayoutModelEntry";
        posts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
      } | null> | null;
      position?: {
        __typename?: "ProfileLayoutScreenPositionModel";
        x?: number | null;
        y?: number | null;
        width?: number | null;
        height?: number | null;
      } | null;
    }> | null;
    resting?: {
      __typename?: "ProfileRestingModel";
      staleStateTimeout?: number | null;
      items?: Array<{
        __typename?: "ProfileRestingModelEntry";
        alphaOn?: boolean | null;
        canInterrupt?: boolean | null;
        media?: string | null;
        playAudio?: boolean | null;
        post?: string | null;
        imageSettings?: {
          __typename?: "ProfileRestingModelEntryImageSettings";
          showTime?: number | null;
        } | null;
      }> | null;
    } | null;
    screen?: {
      __typename?: "ProfileLayoutScreenModel";
      columns?: number | null;
      count?: number | null;
      orientation?: OrientationType | null;
      resolution?: Resolution | null;
      rows?: number | null;
      size?: {
        __typename?: "ProfileScreenSizeModel";
        width?: number | null;
        height?: number | null;
      } | null;
    } | null;
  };
};

type ActionPayloadProps_ActionPayloadLocationProfileChanged_Fragment = {
  __typename?: "ActionPayloadLocationProfileChanged";
  type: ActionPayloadType;
  location: string;
  profile: string;
};

type ActionPayloadProps_ActionPayloadPostEnabled_Fragment = {
  __typename?: "ActionPayloadPostEnabled";
  type: ActionPayloadType;
  enabled: boolean;
  post: string;
};

export type ActionPayloadPropsFragment =
  | ActionPayloadProps_ActionPayloadLocationProfileChanged_Fragment
  | ActionPayloadProps_ActionPayloadPostEnabled_Fragment;

export type GetScheduledEventQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetScheduledEventQuery = {
  __typename?: "Query";
  item: {
    __typename: "ScheduledEvent";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    end?: any | null;
    endProcessed?: boolean | null;
    groupId?: string | null;
    id?: string | null;
    name?: string | null;
    notes?: string | null;
    organization: string;
    start?: any | null;
    startProcessed?: boolean | null;
    timezone?: string | null;
    updatedAt?: any | null;
    endAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
    recurring?: {
      __typename?: "ScheduledEventRecurringSettings";
      bymonth?: Array<number> | null;
      byweekday?: Array<number> | null;
      count?: number | null;
      dtstart?: string | null;
      freq?: number | null;
      interval?: number | null;
      tzid?: string | null;
      until?: string | null;
    } | null;
    startAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
  };
};

export type GetScheduledEventsQueryVariables = Exact<{
  filter?: InputMaybe<ScheduledEventFilter>;
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetScheduledEventsQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "ScheduledEvent";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    end?: any | null;
    endProcessed?: boolean | null;
    groupId?: string | null;
    id?: string | null;
    name?: string | null;
    notes?: string | null;
    organization: string;
    start?: any | null;
    startProcessed?: boolean | null;
    timezone?: string | null;
    updatedAt?: any | null;
    endAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
    recurring?: {
      __typename?: "ScheduledEventRecurringSettings";
      bymonth?: Array<number> | null;
      byweekday?: Array<number> | null;
      count?: number | null;
      dtstart?: string | null;
      freq?: number | null;
      interval?: number | null;
      tzid?: string | null;
      until?: string | null;
    } | null;
    startAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type CreateScheduledEventMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  start: Scalars["DateTime"]["input"];
  startActionOneOf?: InputMaybe<
    Array<ActionPayloadInputCombo> | ActionPayloadInputCombo
  >;
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  endActionOneOf?: InputMaybe<
    Array<ActionPayloadInputCombo> | ActionPayloadInputCombo
  >;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  recurring?: InputMaybe<CreateScheduledEventRecurringSettingsInput>;
  startProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  endProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateScheduledEventMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "ScheduledEvent";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    end?: any | null;
    endProcessed?: boolean | null;
    groupId?: string | null;
    id?: string | null;
    name?: string | null;
    notes?: string | null;
    organization: string;
    start?: any | null;
    startProcessed?: boolean | null;
    timezone?: string | null;
    updatedAt?: any | null;
    endAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
    recurring?: {
      __typename?: "ScheduledEventRecurringSettings";
      bymonth?: Array<number> | null;
      byweekday?: Array<number> | null;
      count?: number | null;
      dtstart?: string | null;
      freq?: number | null;
      interval?: number | null;
      tzid?: string | null;
      until?: string | null;
    } | null;
    startAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
  };
};

export type DeleteScheduledEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteScheduledEventMutation = {
  __typename?: "Mutation";
  data: boolean;
};

export type UpdateScheduledEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  groupId?: InputMaybe<Scalars["String"]["input"]>;
  start: Scalars["DateTime"]["input"];
  startActionOneOf?: InputMaybe<
    Array<ActionPayloadInputCombo> | ActionPayloadInputCombo
  >;
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  endActionOneOf?: InputMaybe<
    Array<ActionPayloadInputCombo> | ActionPayloadInputCombo
  >;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  modifyType?: InputMaybe<ScheduledEventModificationType>;
  startProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  endProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateScheduledEventMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "ScheduledEvent";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    end?: any | null;
    endProcessed?: boolean | null;
    groupId?: string | null;
    id?: string | null;
    name?: string | null;
    notes?: string | null;
    organization: string;
    start?: any | null;
    startProcessed?: boolean | null;
    timezone?: string | null;
    updatedAt?: any | null;
    endAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
    recurring?: {
      __typename?: "ScheduledEventRecurringSettings";
      bymonth?: Array<number> | null;
      byweekday?: Array<number> | null;
      count?: number | null;
      dtstart?: string | null;
      freq?: number | null;
      interval?: number | null;
      tzid?: string | null;
      until?: string | null;
    } | null;
    startAction?: Array<
      | {
          __typename?: "ActionPayloadLocationProfileChanged";
          type: ActionPayloadType;
          location: string;
          profile: string;
        }
      | {
          __typename?: "ActionPayloadPostEnabled";
          type: ActionPayloadType;
          enabled: boolean;
          post: string;
        }
    > | null;
  };
};

type ConditionValueTypePropsStatic_ConditionValueTypeBoolean_Fragment = {
  __typename?: "ConditionValueTypeBoolean";
  type: string;
  valueBoolean: boolean;
};

type ConditionValueTypePropsStatic_ConditionValueTypeNumber_Fragment = {
  __typename?: "ConditionValueTypeNumber";
  type: string;
  valueNumber: number;
};

type ConditionValueTypePropsStatic_ConditionValueTypeString_Fragment = {
  __typename?: "ConditionValueTypeString";
  type: string;
  valueString: string;
};

export type ConditionValueTypePropsStaticFragment =
  | ConditionValueTypePropsStatic_ConditionValueTypeBoolean_Fragment
  | ConditionValueTypePropsStatic_ConditionValueTypeNumber_Fragment
  | ConditionValueTypePropsStatic_ConditionValueTypeString_Fragment;

export type ExtraFieldTypeArrayPropsStaticFragment = {
  __typename?: "ExtraFieldTypeArray";
  type: string;
  label?: string | null;
  showTitle?: boolean | null;
  source: string;
};

export type ExtraFieldTypeBoxPropsStaticFragment = {
  __typename?: "ExtraFieldTypeBox";
  type: string;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeArray_Fragment = {
  __typename?: "ExtraFieldTypeArray";
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeBoolean_Fragment = {
  __typename?: "ExtraFieldTypeBoolean";
  type: string;
  label?: string | null;
  source: string;
  defaultValueBoolean?: boolean | null;
  metadata?: {
    __typename?: "ExtraFieldMetadata";
    allowOverride?: {
      __typename?: "ExtraFieldMetadataProperties";
      defaultValue?: boolean | null;
    } | null;
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeBox_Fragment = {
  __typename?: "ExtraFieldTypeBox";
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeColor_Fragment = {
  __typename?: "ExtraFieldTypeColor";
  type: string;
  label?: string | null;
  source: string;
  defaultValueColor?: string | null;
  metadata?: {
    __typename?: "ExtraFieldMetadata";
    allowOverride?: {
      __typename?: "ExtraFieldMetadataProperties";
      defaultValue?: boolean | null;
    } | null;
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeHelp_Fragment = {
  __typename?: "ExtraFieldTypeHelp";
  type: string;
  label?: string | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeMedia_Fragment = {
  __typename?: "ExtraFieldTypeMedia";
  type: string;
  label?: string | null;
  source: string;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeNumber_Fragment = {
  __typename?: "ExtraFieldTypeNumber";
  type: string;
  label?: string | null;
  source: string;
  defaultValueNumber?: number | null;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeReference_Fragment = {
  __typename?: "ExtraFieldTypeReference";
  type: string;
  disabled?: boolean | null;
  label?: string | null;
  multiple?: boolean | null;
  nullable?: boolean | null;
  optionText?: string | null;
  reference: ServiceAppCmsReferenceTypes;
  source: string;
  filter?: {
    __typename?: "ExtraFieldTypeReferenceFilter";
    type?: string | null;
    enabled?: boolean | null;
  } | null;
  selectOptions?: {
    __typename?: "ExtraFieldTypeReferenceSelectOptions";
    optionText: string;
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeRichText_Fragment = {
  __typename?: "ExtraFieldTypeRichText";
  type: string;
  label?: string | null;
  source: string;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeSearch_Fragment = {
  __typename?: "ExtraFieldTypeSearch";
  type: string;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeSelect_Fragment = {
  __typename?: "ExtraFieldTypeSelect";
  type: string;
  defaultChoice?: string | null;
  defaultValue?: string | null;
  label?: string | null;
  source: string;
  choices: Array<{
    __typename?: "ExtraFieldTypeSelectChoice";
    id: string;
    name: string;
  }>;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeText_Fragment = {
  __typename?: "ExtraFieldTypeText";
  type: string;
  defaultValue?: string | null;
  disabled?: boolean | null;
  label?: string | null;
  source: string;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsStatic_ExtraFieldTypeTextLabel_Fragment = {
  __typename?: "ExtraFieldTypeTextLabel";
  type: string;
  initialValue?: string | null;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

export type ExtraFieldTypePropsStaticFragment =
  | ExtraFieldTypePropsStatic_ExtraFieldTypeArray_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeBoolean_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeBox_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeColor_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeHelp_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeMedia_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeNumber_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeReference_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeRichText_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeSearch_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeSelect_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeText_Fragment
  | ExtraFieldTypePropsStatic_ExtraFieldTypeTextLabel_Fragment;

type ExtraFieldTypePropsRecursive_ExtraFieldTypeArray_Fragment = {
  __typename?: "ExtraFieldTypeArray";
  type: string;
  label?: string | null;
  showTitle?: boolean | null;
  source: string;
  extraFields: Array<
    | {
        __typename?: "ExtraFieldTypeArray";
        type: string;
        label?: string | null;
        showTitle?: boolean | null;
        source: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
      }
    | {
        __typename?: "ExtraFieldTypeBoolean";
        type: string;
        label?: string | null;
        source: string;
        defaultValueBoolean?: boolean | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeBox";
        type: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeColor";
        type: string;
        label?: string | null;
        source: string;
        defaultValueColor?: string | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | { __typename?: "ExtraFieldTypeHelp"; type: string; label?: string | null }
    | {
        __typename?: "ExtraFieldTypeMedia";
        type: string;
        label?: string | null;
        source: string;
      }
    | {
        __typename?: "ExtraFieldTypeNumber";
        type: string;
        label?: string | null;
        source: string;
        defaultValueNumber?: number | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeReference";
        type: string;
        disabled?: boolean | null;
        label?: string | null;
        multiple?: boolean | null;
        nullable?: boolean | null;
        optionText?: string | null;
        reference: ServiceAppCmsReferenceTypes;
        source: string;
        filter?: {
          __typename?: "ExtraFieldTypeReferenceFilter";
          type?: string | null;
          enabled?: boolean | null;
        } | null;
        selectOptions?: {
          __typename?: "ExtraFieldTypeReferenceSelectOptions";
          optionText: string;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeRichText";
        type: string;
        label?: string | null;
        source: string;
      }
    | { __typename?: "ExtraFieldTypeSearch"; type: string }
    | {
        __typename?: "ExtraFieldTypeSelect";
        type: string;
        defaultChoice?: string | null;
        defaultValue?: string | null;
        label?: string | null;
        source: string;
        choices: Array<{
          __typename?: "ExtraFieldTypeSelectChoice";
          id: string;
          name: string;
        }>;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeText";
        type: string;
        defaultValue?: string | null;
        disabled?: boolean | null;
        label?: string | null;
        source: string;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeTextLabel";
        type: string;
        initialValue?: string | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
  >;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeBoolean_Fragment = {
  __typename?: "ExtraFieldTypeBoolean";
  type: string;
  label?: string | null;
  source: string;
  defaultValueBoolean?: boolean | null;
  metadata?: {
    __typename?: "ExtraFieldMetadata";
    allowOverride?: {
      __typename?: "ExtraFieldMetadataProperties";
      defaultValue?: boolean | null;
    } | null;
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeBox_Fragment = {
  __typename?: "ExtraFieldTypeBox";
  type: string;
  extraFields: Array<
    | {
        __typename?: "ExtraFieldTypeArray";
        type: string;
        label?: string | null;
        showTitle?: boolean | null;
        source: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
      }
    | {
        __typename?: "ExtraFieldTypeBoolean";
        type: string;
        label?: string | null;
        source: string;
        defaultValueBoolean?: boolean | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeBox";
        type: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeColor";
        type: string;
        label?: string | null;
        source: string;
        defaultValueColor?: string | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | { __typename?: "ExtraFieldTypeHelp"; type: string; label?: string | null }
    | {
        __typename?: "ExtraFieldTypeMedia";
        type: string;
        label?: string | null;
        source: string;
      }
    | {
        __typename?: "ExtraFieldTypeNumber";
        type: string;
        label?: string | null;
        source: string;
        defaultValueNumber?: number | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeReference";
        type: string;
        disabled?: boolean | null;
        label?: string | null;
        multiple?: boolean | null;
        nullable?: boolean | null;
        optionText?: string | null;
        reference: ServiceAppCmsReferenceTypes;
        source: string;
        filter?: {
          __typename?: "ExtraFieldTypeReferenceFilter";
          type?: string | null;
          enabled?: boolean | null;
        } | null;
        selectOptions?: {
          __typename?: "ExtraFieldTypeReferenceSelectOptions";
          optionText: string;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeRichText";
        type: string;
        label?: string | null;
        source: string;
      }
    | { __typename?: "ExtraFieldTypeSearch"; type: string }
    | {
        __typename?: "ExtraFieldTypeSelect";
        type: string;
        defaultChoice?: string | null;
        defaultValue?: string | null;
        label?: string | null;
        source: string;
        choices: Array<{
          __typename?: "ExtraFieldTypeSelectChoice";
          id: string;
          name: string;
        }>;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeText";
        type: string;
        defaultValue?: string | null;
        disabled?: boolean | null;
        label?: string | null;
        source: string;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeTextLabel";
        type: string;
        initialValue?: string | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
  >;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeColor_Fragment = {
  __typename?: "ExtraFieldTypeColor";
  type: string;
  label?: string | null;
  source: string;
  defaultValueColor?: string | null;
  metadata?: {
    __typename?: "ExtraFieldMetadata";
    allowOverride?: {
      __typename?: "ExtraFieldMetadataProperties";
      defaultValue?: boolean | null;
    } | null;
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeHelp_Fragment = {
  __typename?: "ExtraFieldTypeHelp";
  type: string;
  label?: string | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeMedia_Fragment = {
  __typename?: "ExtraFieldTypeMedia";
  type: string;
  label?: string | null;
  source: string;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeNumber_Fragment = {
  __typename?: "ExtraFieldTypeNumber";
  type: string;
  label?: string | null;
  source: string;
  defaultValueNumber?: number | null;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeReference_Fragment = {
  __typename?: "ExtraFieldTypeReference";
  type: string;
  disabled?: boolean | null;
  label?: string | null;
  multiple?: boolean | null;
  nullable?: boolean | null;
  optionText?: string | null;
  reference: ServiceAppCmsReferenceTypes;
  source: string;
  filter?: {
    __typename?: "ExtraFieldTypeReferenceFilter";
    type?: string | null;
    enabled?: boolean | null;
  } | null;
  selectOptions?: {
    __typename?: "ExtraFieldTypeReferenceSelectOptions";
    optionText: string;
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeRichText_Fragment = {
  __typename?: "ExtraFieldTypeRichText";
  type: string;
  label?: string | null;
  source: string;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeSearch_Fragment = {
  __typename?: "ExtraFieldTypeSearch";
  type: string;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeSelect_Fragment = {
  __typename?: "ExtraFieldTypeSelect";
  type: string;
  defaultChoice?: string | null;
  defaultValue?: string | null;
  label?: string | null;
  source: string;
  choices: Array<{
    __typename?: "ExtraFieldTypeSelectChoice";
    id: string;
    name: string;
  }>;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeText_Fragment = {
  __typename?: "ExtraFieldTypeText";
  type: string;
  defaultValue?: string | null;
  disabled?: boolean | null;
  label?: string | null;
  source: string;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

type ExtraFieldTypePropsRecursive_ExtraFieldTypeTextLabel_Fragment = {
  __typename?: "ExtraFieldTypeTextLabel";
  type: string;
  initialValue?: string | null;
  condition?: {
    __typename?: "ExtraFieldCondition";
    field: string;
    value:
      | {
          __typename?: "ConditionValueTypeBoolean";
          type: string;
          valueBoolean: boolean;
        }
      | {
          __typename?: "ConditionValueTypeNumber";
          type: string;
          valueNumber: number;
        }
      | {
          __typename?: "ConditionValueTypeString";
          type: string;
          valueString: string;
        };
  } | null;
};

export type ExtraFieldTypePropsRecursiveFragment =
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeArray_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeBoolean_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeBox_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeColor_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeHelp_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeMedia_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeNumber_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeReference_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeRichText_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeSearch_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeSelect_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeText_Fragment
  | ExtraFieldTypePropsRecursive_ExtraFieldTypeTextLabel_Fragment;

export type ServiceOptionAppCmsFunctionPropsFragment = {
  __typename?: "ServiceOptionAppCmsFunction";
  showMediaInput?: boolean | null;
  qrCodeEmbeddedInFlyout?: boolean | null;
  previewMediaSource?: string | null;
  extraFields?: Array<
    | {
        __typename?: "ExtraFieldTypeArray";
        type: string;
        label?: string | null;
        showTitle?: boolean | null;
        source: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
      }
    | {
        __typename?: "ExtraFieldTypeBoolean";
        type: string;
        label?: string | null;
        source: string;
        defaultValueBoolean?: boolean | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeBox";
        type: string;
        extraFields: Array<
          | {
              __typename?: "ExtraFieldTypeArray";
              type: string;
              label?: string | null;
              showTitle?: boolean | null;
              source: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
            }
          | {
              __typename?: "ExtraFieldTypeBoolean";
              type: string;
              label?: string | null;
              source: string;
              defaultValueBoolean?: boolean | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeBox";
              type: string;
              extraFields: Array<
                | {
                    __typename?: "ExtraFieldTypeArray";
                    type: string;
                    label?: string | null;
                    showTitle?: boolean | null;
                    source: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                  }
                | {
                    __typename?: "ExtraFieldTypeBoolean";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueBoolean?: boolean | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeBox";
                    type: string;
                    extraFields: Array<
                      | {
                          __typename?: "ExtraFieldTypeArray";
                          type: string;
                          label?: string | null;
                          showTitle?: boolean | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBoolean";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueBoolean?: boolean | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeBox";
                          type: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeColor";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueColor?: string | null;
                          metadata?: {
                            __typename?: "ExtraFieldMetadata";
                            allowOverride?: {
                              __typename?: "ExtraFieldMetadataProperties";
                              defaultValue?: boolean | null;
                            } | null;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeHelp";
                          type: string;
                          label?: string | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeMedia";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | {
                          __typename?: "ExtraFieldTypeNumber";
                          type: string;
                          label?: string | null;
                          source: string;
                          defaultValueNumber?: number | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeReference";
                          type: string;
                          disabled?: boolean | null;
                          label?: string | null;
                          multiple?: boolean | null;
                          nullable?: boolean | null;
                          optionText?: string | null;
                          reference: ServiceAppCmsReferenceTypes;
                          source: string;
                          filter?: {
                            __typename?: "ExtraFieldTypeReferenceFilter";
                            type?: string | null;
                            enabled?: boolean | null;
                          } | null;
                          selectOptions?: {
                            __typename?: "ExtraFieldTypeReferenceSelectOptions";
                            optionText: string;
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeRichText";
                          type: string;
                          label?: string | null;
                          source: string;
                        }
                      | { __typename?: "ExtraFieldTypeSearch"; type: string }
                      | {
                          __typename?: "ExtraFieldTypeSelect";
                          type: string;
                          defaultChoice?: string | null;
                          defaultValue?: string | null;
                          label?: string | null;
                          source: string;
                          choices: Array<{
                            __typename?: "ExtraFieldTypeSelectChoice";
                            id: string;
                            name: string;
                          }>;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeText";
                          type: string;
                          defaultValue?: string | null;
                          disabled?: boolean | null;
                          label?: string | null;
                          source: string;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                      | {
                          __typename?: "ExtraFieldTypeTextLabel";
                          type: string;
                          initialValue?: string | null;
                          condition?: {
                            __typename?: "ExtraFieldCondition";
                            field: string;
                            value:
                              | {
                                  __typename?: "ConditionValueTypeBoolean";
                                  type: string;
                                  valueBoolean: boolean;
                                }
                              | {
                                  __typename?: "ConditionValueTypeNumber";
                                  type: string;
                                  valueNumber: number;
                                }
                              | {
                                  __typename?: "ConditionValueTypeString";
                                  type: string;
                                  valueString: string;
                                };
                          } | null;
                        }
                    >;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeColor";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueColor?: string | null;
                    metadata?: {
                      __typename?: "ExtraFieldMetadata";
                      allowOverride?: {
                        __typename?: "ExtraFieldMetadataProperties";
                        defaultValue?: boolean | null;
                      } | null;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeHelp";
                    type: string;
                    label?: string | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeMedia";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | {
                    __typename?: "ExtraFieldTypeNumber";
                    type: string;
                    label?: string | null;
                    source: string;
                    defaultValueNumber?: number | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeReference";
                    type: string;
                    disabled?: boolean | null;
                    label?: string | null;
                    multiple?: boolean | null;
                    nullable?: boolean | null;
                    optionText?: string | null;
                    reference: ServiceAppCmsReferenceTypes;
                    source: string;
                    filter?: {
                      __typename?: "ExtraFieldTypeReferenceFilter";
                      type?: string | null;
                      enabled?: boolean | null;
                    } | null;
                    selectOptions?: {
                      __typename?: "ExtraFieldTypeReferenceSelectOptions";
                      optionText: string;
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeRichText";
                    type: string;
                    label?: string | null;
                    source: string;
                  }
                | { __typename?: "ExtraFieldTypeSearch"; type: string }
                | {
                    __typename?: "ExtraFieldTypeSelect";
                    type: string;
                    defaultChoice?: string | null;
                    defaultValue?: string | null;
                    label?: string | null;
                    source: string;
                    choices: Array<{
                      __typename?: "ExtraFieldTypeSelectChoice";
                      id: string;
                      name: string;
                    }>;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeText";
                    type: string;
                    defaultValue?: string | null;
                    disabled?: boolean | null;
                    label?: string | null;
                    source: string;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
                | {
                    __typename?: "ExtraFieldTypeTextLabel";
                    type: string;
                    initialValue?: string | null;
                    condition?: {
                      __typename?: "ExtraFieldCondition";
                      field: string;
                      value:
                        | {
                            __typename?: "ConditionValueTypeBoolean";
                            type: string;
                            valueBoolean: boolean;
                          }
                        | {
                            __typename?: "ConditionValueTypeNumber";
                            type: string;
                            valueNumber: number;
                          }
                        | {
                            __typename?: "ConditionValueTypeString";
                            type: string;
                            valueString: string;
                          };
                    } | null;
                  }
              >;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeColor";
              type: string;
              label?: string | null;
              source: string;
              defaultValueColor?: string | null;
              metadata?: {
                __typename?: "ExtraFieldMetadata";
                allowOverride?: {
                  __typename?: "ExtraFieldMetadataProperties";
                  defaultValue?: boolean | null;
                } | null;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeHelp";
              type: string;
              label?: string | null;
            }
          | {
              __typename?: "ExtraFieldTypeMedia";
              type: string;
              label?: string | null;
              source: string;
            }
          | {
              __typename?: "ExtraFieldTypeNumber";
              type: string;
              label?: string | null;
              source: string;
              defaultValueNumber?: number | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeReference";
              type: string;
              disabled?: boolean | null;
              label?: string | null;
              multiple?: boolean | null;
              nullable?: boolean | null;
              optionText?: string | null;
              reference: ServiceAppCmsReferenceTypes;
              source: string;
              filter?: {
                __typename?: "ExtraFieldTypeReferenceFilter";
                type?: string | null;
                enabled?: boolean | null;
              } | null;
              selectOptions?: {
                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                optionText: string;
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeRichText";
              type: string;
              label?: string | null;
              source: string;
            }
          | { __typename?: "ExtraFieldTypeSearch"; type: string }
          | {
              __typename?: "ExtraFieldTypeSelect";
              type: string;
              defaultChoice?: string | null;
              defaultValue?: string | null;
              label?: string | null;
              source: string;
              choices: Array<{
                __typename?: "ExtraFieldTypeSelectChoice";
                id: string;
                name: string;
              }>;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeText";
              type: string;
              defaultValue?: string | null;
              disabled?: boolean | null;
              label?: string | null;
              source: string;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
          | {
              __typename?: "ExtraFieldTypeTextLabel";
              type: string;
              initialValue?: string | null;
              condition?: {
                __typename?: "ExtraFieldCondition";
                field: string;
                value:
                  | {
                      __typename?: "ConditionValueTypeBoolean";
                      type: string;
                      valueBoolean: boolean;
                    }
                  | {
                      __typename?: "ConditionValueTypeNumber";
                      type: string;
                      valueNumber: number;
                    }
                  | {
                      __typename?: "ConditionValueTypeString";
                      type: string;
                      valueString: string;
                    };
              } | null;
            }
        >;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeColor";
        type: string;
        label?: string | null;
        source: string;
        defaultValueColor?: string | null;
        metadata?: {
          __typename?: "ExtraFieldMetadata";
          allowOverride?: {
            __typename?: "ExtraFieldMetadataProperties";
            defaultValue?: boolean | null;
          } | null;
        } | null;
      }
    | { __typename?: "ExtraFieldTypeHelp"; type: string; label?: string | null }
    | {
        __typename?: "ExtraFieldTypeMedia";
        type: string;
        label?: string | null;
        source: string;
      }
    | {
        __typename?: "ExtraFieldTypeNumber";
        type: string;
        label?: string | null;
        source: string;
        defaultValueNumber?: number | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeReference";
        type: string;
        disabled?: boolean | null;
        label?: string | null;
        multiple?: boolean | null;
        nullable?: boolean | null;
        optionText?: string | null;
        reference: ServiceAppCmsReferenceTypes;
        source: string;
        filter?: {
          __typename?: "ExtraFieldTypeReferenceFilter";
          type?: string | null;
          enabled?: boolean | null;
        } | null;
        selectOptions?: {
          __typename?: "ExtraFieldTypeReferenceSelectOptions";
          optionText: string;
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeRichText";
        type: string;
        label?: string | null;
        source: string;
      }
    | { __typename?: "ExtraFieldTypeSearch"; type: string }
    | {
        __typename?: "ExtraFieldTypeSelect";
        type: string;
        defaultChoice?: string | null;
        defaultValue?: string | null;
        label?: string | null;
        source: string;
        choices: Array<{
          __typename?: "ExtraFieldTypeSelectChoice";
          id: string;
          name: string;
        }>;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeText";
        type: string;
        defaultValue?: string | null;
        disabled?: boolean | null;
        label?: string | null;
        source: string;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
    | {
        __typename?: "ExtraFieldTypeTextLabel";
        type: string;
        initialValue?: string | null;
        condition?: {
          __typename?: "ExtraFieldCondition";
          field: string;
          value:
            | {
                __typename?: "ConditionValueTypeBoolean";
                type: string;
                valueBoolean: boolean;
              }
            | {
                __typename?: "ConditionValueTypeNumber";
                type: string;
                valueNumber: number;
              }
            | {
                __typename?: "ConditionValueTypeString";
                type: string;
                valueString: string;
              };
        } | null;
      }
  > | null;
};

export type ServiceOptionPropsFragment = {
  __typename?: "ServiceOption";
  cms?: {
    __typename?: "ServiceOptionApp";
    post?: {
      __typename?: "ServiceOptionAppCmsFunction";
      showMediaInput?: boolean | null;
      qrCodeEmbeddedInFlyout?: boolean | null;
      previewMediaSource?: string | null;
      extraFields?: Array<
        | {
            __typename?: "ExtraFieldTypeArray";
            type: string;
            label?: string | null;
            showTitle?: boolean | null;
            source: string;
            extraFields: Array<
              | {
                  __typename?: "ExtraFieldTypeArray";
                  type: string;
                  label?: string | null;
                  showTitle?: boolean | null;
                  source: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                }
              | {
                  __typename?: "ExtraFieldTypeBoolean";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueBoolean?: boolean | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeBox";
                  type: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeColor";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueColor?: string | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeHelp";
                  type: string;
                  label?: string | null;
                }
              | {
                  __typename?: "ExtraFieldTypeMedia";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | {
                  __typename?: "ExtraFieldTypeNumber";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueNumber?: number | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeReference";
                  type: string;
                  disabled?: boolean | null;
                  label?: string | null;
                  multiple?: boolean | null;
                  nullable?: boolean | null;
                  optionText?: string | null;
                  reference: ServiceAppCmsReferenceTypes;
                  source: string;
                  filter?: {
                    __typename?: "ExtraFieldTypeReferenceFilter";
                    type?: string | null;
                    enabled?: boolean | null;
                  } | null;
                  selectOptions?: {
                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                    optionText: string;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeRichText";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | { __typename?: "ExtraFieldTypeSearch"; type: string }
              | {
                  __typename?: "ExtraFieldTypeSelect";
                  type: string;
                  defaultChoice?: string | null;
                  defaultValue?: string | null;
                  label?: string | null;
                  source: string;
                  choices: Array<{
                    __typename?: "ExtraFieldTypeSelectChoice";
                    id: string;
                    name: string;
                  }>;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeText";
                  type: string;
                  defaultValue?: string | null;
                  disabled?: boolean | null;
                  label?: string | null;
                  source: string;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeTextLabel";
                  type: string;
                  initialValue?: string | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
            >;
          }
        | {
            __typename?: "ExtraFieldTypeBoolean";
            type: string;
            label?: string | null;
            source: string;
            defaultValueBoolean?: boolean | null;
            metadata?: {
              __typename?: "ExtraFieldMetadata";
              allowOverride?: {
                __typename?: "ExtraFieldMetadataProperties";
                defaultValue?: boolean | null;
              } | null;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeBox";
            type: string;
            extraFields: Array<
              | {
                  __typename?: "ExtraFieldTypeArray";
                  type: string;
                  label?: string | null;
                  showTitle?: boolean | null;
                  source: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                }
              | {
                  __typename?: "ExtraFieldTypeBoolean";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueBoolean?: boolean | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeBox";
                  type: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeColor";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueColor?: string | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeHelp";
                  type: string;
                  label?: string | null;
                }
              | {
                  __typename?: "ExtraFieldTypeMedia";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | {
                  __typename?: "ExtraFieldTypeNumber";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueNumber?: number | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeReference";
                  type: string;
                  disabled?: boolean | null;
                  label?: string | null;
                  multiple?: boolean | null;
                  nullable?: boolean | null;
                  optionText?: string | null;
                  reference: ServiceAppCmsReferenceTypes;
                  source: string;
                  filter?: {
                    __typename?: "ExtraFieldTypeReferenceFilter";
                    type?: string | null;
                    enabled?: boolean | null;
                  } | null;
                  selectOptions?: {
                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                    optionText: string;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeRichText";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | { __typename?: "ExtraFieldTypeSearch"; type: string }
              | {
                  __typename?: "ExtraFieldTypeSelect";
                  type: string;
                  defaultChoice?: string | null;
                  defaultValue?: string | null;
                  label?: string | null;
                  source: string;
                  choices: Array<{
                    __typename?: "ExtraFieldTypeSelectChoice";
                    id: string;
                    name: string;
                  }>;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeText";
                  type: string;
                  defaultValue?: string | null;
                  disabled?: boolean | null;
                  label?: string | null;
                  source: string;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeTextLabel";
                  type: string;
                  initialValue?: string | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
            >;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeColor";
            type: string;
            label?: string | null;
            source: string;
            defaultValueColor?: string | null;
            metadata?: {
              __typename?: "ExtraFieldMetadata";
              allowOverride?: {
                __typename?: "ExtraFieldMetadataProperties";
                defaultValue?: boolean | null;
              } | null;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeHelp";
            type: string;
            label?: string | null;
          }
        | {
            __typename?: "ExtraFieldTypeMedia";
            type: string;
            label?: string | null;
            source: string;
          }
        | {
            __typename?: "ExtraFieldTypeNumber";
            type: string;
            label?: string | null;
            source: string;
            defaultValueNumber?: number | null;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeReference";
            type: string;
            disabled?: boolean | null;
            label?: string | null;
            multiple?: boolean | null;
            nullable?: boolean | null;
            optionText?: string | null;
            reference: ServiceAppCmsReferenceTypes;
            source: string;
            filter?: {
              __typename?: "ExtraFieldTypeReferenceFilter";
              type?: string | null;
              enabled?: boolean | null;
            } | null;
            selectOptions?: {
              __typename?: "ExtraFieldTypeReferenceSelectOptions";
              optionText: string;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeRichText";
            type: string;
            label?: string | null;
            source: string;
          }
        | { __typename?: "ExtraFieldTypeSearch"; type: string }
        | {
            __typename?: "ExtraFieldTypeSelect";
            type: string;
            defaultChoice?: string | null;
            defaultValue?: string | null;
            label?: string | null;
            source: string;
            choices: Array<{
              __typename?: "ExtraFieldTypeSelectChoice";
              id: string;
              name: string;
            }>;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeText";
            type: string;
            defaultValue?: string | null;
            disabled?: boolean | null;
            label?: string | null;
            source: string;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeTextLabel";
            type: string;
            initialValue?: string | null;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
      > | null;
    } | null;
    service?: {
      __typename?: "ServiceOptionAppCmsFunction";
      showMediaInput?: boolean | null;
      qrCodeEmbeddedInFlyout?: boolean | null;
      previewMediaSource?: string | null;
      extraFields?: Array<
        | {
            __typename?: "ExtraFieldTypeArray";
            type: string;
            label?: string | null;
            showTitle?: boolean | null;
            source: string;
            extraFields: Array<
              | {
                  __typename?: "ExtraFieldTypeArray";
                  type: string;
                  label?: string | null;
                  showTitle?: boolean | null;
                  source: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                }
              | {
                  __typename?: "ExtraFieldTypeBoolean";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueBoolean?: boolean | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeBox";
                  type: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeColor";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueColor?: string | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeHelp";
                  type: string;
                  label?: string | null;
                }
              | {
                  __typename?: "ExtraFieldTypeMedia";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | {
                  __typename?: "ExtraFieldTypeNumber";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueNumber?: number | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeReference";
                  type: string;
                  disabled?: boolean | null;
                  label?: string | null;
                  multiple?: boolean | null;
                  nullable?: boolean | null;
                  optionText?: string | null;
                  reference: ServiceAppCmsReferenceTypes;
                  source: string;
                  filter?: {
                    __typename?: "ExtraFieldTypeReferenceFilter";
                    type?: string | null;
                    enabled?: boolean | null;
                  } | null;
                  selectOptions?: {
                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                    optionText: string;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeRichText";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | { __typename?: "ExtraFieldTypeSearch"; type: string }
              | {
                  __typename?: "ExtraFieldTypeSelect";
                  type: string;
                  defaultChoice?: string | null;
                  defaultValue?: string | null;
                  label?: string | null;
                  source: string;
                  choices: Array<{
                    __typename?: "ExtraFieldTypeSelectChoice";
                    id: string;
                    name: string;
                  }>;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeText";
                  type: string;
                  defaultValue?: string | null;
                  disabled?: boolean | null;
                  label?: string | null;
                  source: string;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeTextLabel";
                  type: string;
                  initialValue?: string | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
            >;
          }
        | {
            __typename?: "ExtraFieldTypeBoolean";
            type: string;
            label?: string | null;
            source: string;
            defaultValueBoolean?: boolean | null;
            metadata?: {
              __typename?: "ExtraFieldMetadata";
              allowOverride?: {
                __typename?: "ExtraFieldMetadataProperties";
                defaultValue?: boolean | null;
              } | null;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeBox";
            type: string;
            extraFields: Array<
              | {
                  __typename?: "ExtraFieldTypeArray";
                  type: string;
                  label?: string | null;
                  showTitle?: boolean | null;
                  source: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                }
              | {
                  __typename?: "ExtraFieldTypeBoolean";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueBoolean?: boolean | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeBox";
                  type: string;
                  extraFields: Array<
                    | {
                        __typename?: "ExtraFieldTypeArray";
                        type: string;
                        label?: string | null;
                        showTitle?: boolean | null;
                        source: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBoolean";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueBoolean?: boolean | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeBox";
                        type: string;
                        extraFields: Array<
                          | {
                              __typename?: "ExtraFieldTypeArray";
                              type: string;
                              label?: string | null;
                              showTitle?: boolean | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBoolean";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueBoolean?: boolean | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeBox";
                              type: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeColor";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueColor?: string | null;
                              metadata?: {
                                __typename?: "ExtraFieldMetadata";
                                allowOverride?: {
                                  __typename?: "ExtraFieldMetadataProperties";
                                  defaultValue?: boolean | null;
                                } | null;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeHelp";
                              type: string;
                              label?: string | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeMedia";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeNumber";
                              type: string;
                              label?: string | null;
                              source: string;
                              defaultValueNumber?: number | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeReference";
                              type: string;
                              disabled?: boolean | null;
                              label?: string | null;
                              multiple?: boolean | null;
                              nullable?: boolean | null;
                              optionText?: string | null;
                              reference: ServiceAppCmsReferenceTypes;
                              source: string;
                              filter?: {
                                __typename?: "ExtraFieldTypeReferenceFilter";
                                type?: string | null;
                                enabled?: boolean | null;
                              } | null;
                              selectOptions?: {
                                __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                optionText: string;
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeRichText";
                              type: string;
                              label?: string | null;
                              source: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSearch";
                              type: string;
                            }
                          | {
                              __typename?: "ExtraFieldTypeSelect";
                              type: string;
                              defaultChoice?: string | null;
                              defaultValue?: string | null;
                              label?: string | null;
                              source: string;
                              choices: Array<{
                                __typename?: "ExtraFieldTypeSelectChoice";
                                id: string;
                                name: string;
                              }>;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeText";
                              type: string;
                              defaultValue?: string | null;
                              disabled?: boolean | null;
                              label?: string | null;
                              source: string;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                          | {
                              __typename?: "ExtraFieldTypeTextLabel";
                              type: string;
                              initialValue?: string | null;
                              condition?: {
                                __typename?: "ExtraFieldCondition";
                                field: string;
                                value:
                                  | {
                                      __typename?: "ConditionValueTypeBoolean";
                                      type: string;
                                      valueBoolean: boolean;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeNumber";
                                      type: string;
                                      valueNumber: number;
                                    }
                                  | {
                                      __typename?: "ConditionValueTypeString";
                                      type: string;
                                      valueString: string;
                                    };
                              } | null;
                            }
                        >;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeColor";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueColor?: string | null;
                        metadata?: {
                          __typename?: "ExtraFieldMetadata";
                          allowOverride?: {
                            __typename?: "ExtraFieldMetadataProperties";
                            defaultValue?: boolean | null;
                          } | null;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeHelp";
                        type: string;
                        label?: string | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeMedia";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | {
                        __typename?: "ExtraFieldTypeNumber";
                        type: string;
                        label?: string | null;
                        source: string;
                        defaultValueNumber?: number | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeReference";
                        type: string;
                        disabled?: boolean | null;
                        label?: string | null;
                        multiple?: boolean | null;
                        nullable?: boolean | null;
                        optionText?: string | null;
                        reference: ServiceAppCmsReferenceTypes;
                        source: string;
                        filter?: {
                          __typename?: "ExtraFieldTypeReferenceFilter";
                          type?: string | null;
                          enabled?: boolean | null;
                        } | null;
                        selectOptions?: {
                          __typename?: "ExtraFieldTypeReferenceSelectOptions";
                          optionText: string;
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeRichText";
                        type: string;
                        label?: string | null;
                        source: string;
                      }
                    | { __typename?: "ExtraFieldTypeSearch"; type: string }
                    | {
                        __typename?: "ExtraFieldTypeSelect";
                        type: string;
                        defaultChoice?: string | null;
                        defaultValue?: string | null;
                        label?: string | null;
                        source: string;
                        choices: Array<{
                          __typename?: "ExtraFieldTypeSelectChoice";
                          id: string;
                          name: string;
                        }>;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeText";
                        type: string;
                        defaultValue?: string | null;
                        disabled?: boolean | null;
                        label?: string | null;
                        source: string;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                    | {
                        __typename?: "ExtraFieldTypeTextLabel";
                        type: string;
                        initialValue?: string | null;
                        condition?: {
                          __typename?: "ExtraFieldCondition";
                          field: string;
                          value:
                            | {
                                __typename?: "ConditionValueTypeBoolean";
                                type: string;
                                valueBoolean: boolean;
                              }
                            | {
                                __typename?: "ConditionValueTypeNumber";
                                type: string;
                                valueNumber: number;
                              }
                            | {
                                __typename?: "ConditionValueTypeString";
                                type: string;
                                valueString: string;
                              };
                        } | null;
                      }
                  >;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeColor";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueColor?: string | null;
                  metadata?: {
                    __typename?: "ExtraFieldMetadata";
                    allowOverride?: {
                      __typename?: "ExtraFieldMetadataProperties";
                      defaultValue?: boolean | null;
                    } | null;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeHelp";
                  type: string;
                  label?: string | null;
                }
              | {
                  __typename?: "ExtraFieldTypeMedia";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | {
                  __typename?: "ExtraFieldTypeNumber";
                  type: string;
                  label?: string | null;
                  source: string;
                  defaultValueNumber?: number | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeReference";
                  type: string;
                  disabled?: boolean | null;
                  label?: string | null;
                  multiple?: boolean | null;
                  nullable?: boolean | null;
                  optionText?: string | null;
                  reference: ServiceAppCmsReferenceTypes;
                  source: string;
                  filter?: {
                    __typename?: "ExtraFieldTypeReferenceFilter";
                    type?: string | null;
                    enabled?: boolean | null;
                  } | null;
                  selectOptions?: {
                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                    optionText: string;
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeRichText";
                  type: string;
                  label?: string | null;
                  source: string;
                }
              | { __typename?: "ExtraFieldTypeSearch"; type: string }
              | {
                  __typename?: "ExtraFieldTypeSelect";
                  type: string;
                  defaultChoice?: string | null;
                  defaultValue?: string | null;
                  label?: string | null;
                  source: string;
                  choices: Array<{
                    __typename?: "ExtraFieldTypeSelectChoice";
                    id: string;
                    name: string;
                  }>;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeText";
                  type: string;
                  defaultValue?: string | null;
                  disabled?: boolean | null;
                  label?: string | null;
                  source: string;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
              | {
                  __typename?: "ExtraFieldTypeTextLabel";
                  type: string;
                  initialValue?: string | null;
                  condition?: {
                    __typename?: "ExtraFieldCondition";
                    field: string;
                    value:
                      | {
                          __typename?: "ConditionValueTypeBoolean";
                          type: string;
                          valueBoolean: boolean;
                        }
                      | {
                          __typename?: "ConditionValueTypeNumber";
                          type: string;
                          valueNumber: number;
                        }
                      | {
                          __typename?: "ConditionValueTypeString";
                          type: string;
                          valueString: string;
                        };
                  } | null;
                }
            >;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeColor";
            type: string;
            label?: string | null;
            source: string;
            defaultValueColor?: string | null;
            metadata?: {
              __typename?: "ExtraFieldMetadata";
              allowOverride?: {
                __typename?: "ExtraFieldMetadataProperties";
                defaultValue?: boolean | null;
              } | null;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeHelp";
            type: string;
            label?: string | null;
          }
        | {
            __typename?: "ExtraFieldTypeMedia";
            type: string;
            label?: string | null;
            source: string;
          }
        | {
            __typename?: "ExtraFieldTypeNumber";
            type: string;
            label?: string | null;
            source: string;
            defaultValueNumber?: number | null;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeReference";
            type: string;
            disabled?: boolean | null;
            label?: string | null;
            multiple?: boolean | null;
            nullable?: boolean | null;
            optionText?: string | null;
            reference: ServiceAppCmsReferenceTypes;
            source: string;
            filter?: {
              __typename?: "ExtraFieldTypeReferenceFilter";
              type?: string | null;
              enabled?: boolean | null;
            } | null;
            selectOptions?: {
              __typename?: "ExtraFieldTypeReferenceSelectOptions";
              optionText: string;
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeRichText";
            type: string;
            label?: string | null;
            source: string;
          }
        | { __typename?: "ExtraFieldTypeSearch"; type: string }
        | {
            __typename?: "ExtraFieldTypeSelect";
            type: string;
            defaultChoice?: string | null;
            defaultValue?: string | null;
            label?: string | null;
            source: string;
            choices: Array<{
              __typename?: "ExtraFieldTypeSelectChoice";
              id: string;
              name: string;
            }>;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeText";
            type: string;
            defaultValue?: string | null;
            disabled?: boolean | null;
            label?: string | null;
            source: string;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
        | {
            __typename?: "ExtraFieldTypeTextLabel";
            type: string;
            initialValue?: string | null;
            condition?: {
              __typename?: "ExtraFieldCondition";
              field: string;
              value:
                | {
                    __typename?: "ConditionValueTypeBoolean";
                    type: string;
                    valueBoolean: boolean;
                  }
                | {
                    __typename?: "ConditionValueTypeNumber";
                    type: string;
                    valueNumber: number;
                  }
                | {
                    __typename?: "ConditionValueTypeString";
                    type: string;
                    valueString: string;
                  };
            } | null;
          }
      > | null;
    } | null;
  } | null;
};

export type GetServiceQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetServiceQuery = {
  __typename?: "Query";
  item: {
    __typename: "Service";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    customData?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    machineName?: string | null;
    name: string;
    type: ServiceTypes;
    updatedAt?: any | null;
    options?: {
      __typename?: "ServiceOption";
      cms?: {
        __typename?: "ServiceOptionApp";
        post?: {
          __typename?: "ServiceOptionAppCmsFunction";
          showMediaInput?: boolean | null;
          qrCodeEmbeddedInFlyout?: boolean | null;
          previewMediaSource?: string | null;
          extraFields?: Array<
            | {
                __typename?: "ExtraFieldTypeArray";
                type: string;
                label?: string | null;
                showTitle?: boolean | null;
                source: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
              }
            | {
                __typename?: "ExtraFieldTypeBoolean";
                type: string;
                label?: string | null;
                source: string;
                defaultValueBoolean?: boolean | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeBox";
                type: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeColor";
                type: string;
                label?: string | null;
                source: string;
                defaultValueColor?: string | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeHelp";
                type: string;
                label?: string | null;
              }
            | {
                __typename?: "ExtraFieldTypeMedia";
                type: string;
                label?: string | null;
                source: string;
              }
            | {
                __typename?: "ExtraFieldTypeNumber";
                type: string;
                label?: string | null;
                source: string;
                defaultValueNumber?: number | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeReference";
                type: string;
                disabled?: boolean | null;
                label?: string | null;
                multiple?: boolean | null;
                nullable?: boolean | null;
                optionText?: string | null;
                reference: ServiceAppCmsReferenceTypes;
                source: string;
                filter?: {
                  __typename?: "ExtraFieldTypeReferenceFilter";
                  type?: string | null;
                  enabled?: boolean | null;
                } | null;
                selectOptions?: {
                  __typename?: "ExtraFieldTypeReferenceSelectOptions";
                  optionText: string;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeRichText";
                type: string;
                label?: string | null;
                source: string;
              }
            | { __typename?: "ExtraFieldTypeSearch"; type: string }
            | {
                __typename?: "ExtraFieldTypeSelect";
                type: string;
                defaultChoice?: string | null;
                defaultValue?: string | null;
                label?: string | null;
                source: string;
                choices: Array<{
                  __typename?: "ExtraFieldTypeSelectChoice";
                  id: string;
                  name: string;
                }>;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeText";
                type: string;
                defaultValue?: string | null;
                disabled?: boolean | null;
                label?: string | null;
                source: string;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeTextLabel";
                type: string;
                initialValue?: string | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
          > | null;
        } | null;
        service?: {
          __typename?: "ServiceOptionAppCmsFunction";
          showMediaInput?: boolean | null;
          qrCodeEmbeddedInFlyout?: boolean | null;
          previewMediaSource?: string | null;
          extraFields?: Array<
            | {
                __typename?: "ExtraFieldTypeArray";
                type: string;
                label?: string | null;
                showTitle?: boolean | null;
                source: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
              }
            | {
                __typename?: "ExtraFieldTypeBoolean";
                type: string;
                label?: string | null;
                source: string;
                defaultValueBoolean?: boolean | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeBox";
                type: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeColor";
                type: string;
                label?: string | null;
                source: string;
                defaultValueColor?: string | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeHelp";
                type: string;
                label?: string | null;
              }
            | {
                __typename?: "ExtraFieldTypeMedia";
                type: string;
                label?: string | null;
                source: string;
              }
            | {
                __typename?: "ExtraFieldTypeNumber";
                type: string;
                label?: string | null;
                source: string;
                defaultValueNumber?: number | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeReference";
                type: string;
                disabled?: boolean | null;
                label?: string | null;
                multiple?: boolean | null;
                nullable?: boolean | null;
                optionText?: string | null;
                reference: ServiceAppCmsReferenceTypes;
                source: string;
                filter?: {
                  __typename?: "ExtraFieldTypeReferenceFilter";
                  type?: string | null;
                  enabled?: boolean | null;
                } | null;
                selectOptions?: {
                  __typename?: "ExtraFieldTypeReferenceSelectOptions";
                  optionText: string;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeRichText";
                type: string;
                label?: string | null;
                source: string;
              }
            | { __typename?: "ExtraFieldTypeSearch"; type: string }
            | {
                __typename?: "ExtraFieldTypeSelect";
                type: string;
                defaultChoice?: string | null;
                defaultValue?: string | null;
                label?: string | null;
                source: string;
                choices: Array<{
                  __typename?: "ExtraFieldTypeSelectChoice";
                  id: string;
                  name: string;
                }>;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeText";
                type: string;
                defaultValue?: string | null;
                disabled?: boolean | null;
                label?: string | null;
                source: string;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeTextLabel";
                type: string;
                initialValue?: string | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
          > | null;
        } | null;
      } | null;
    } | null;
  };
};

export type GetServiceGridQueryVariables = Exact<{
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Service";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    machineName?: string | null;
    name: string;
    type: ServiceTypes;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetServiceListFullQueryVariables = Exact<{
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceListFullQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Service";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    customData?: any | null;
    deleted?: boolean | null;
    id?: string | null;
    machineName?: string | null;
    name: string;
    type: ServiceTypes;
    updatedAt?: any | null;
    options?: {
      __typename?: "ServiceOption";
      cms?: {
        __typename?: "ServiceOptionApp";
        post?: {
          __typename?: "ServiceOptionAppCmsFunction";
          showMediaInput?: boolean | null;
          qrCodeEmbeddedInFlyout?: boolean | null;
          previewMediaSource?: string | null;
          extraFields?: Array<
            | {
                __typename?: "ExtraFieldTypeArray";
                type: string;
                label?: string | null;
                showTitle?: boolean | null;
                source: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
              }
            | {
                __typename?: "ExtraFieldTypeBoolean";
                type: string;
                label?: string | null;
                source: string;
                defaultValueBoolean?: boolean | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeBox";
                type: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeColor";
                type: string;
                label?: string | null;
                source: string;
                defaultValueColor?: string | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeHelp";
                type: string;
                label?: string | null;
              }
            | {
                __typename?: "ExtraFieldTypeMedia";
                type: string;
                label?: string | null;
                source: string;
              }
            | {
                __typename?: "ExtraFieldTypeNumber";
                type: string;
                label?: string | null;
                source: string;
                defaultValueNumber?: number | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeReference";
                type: string;
                disabled?: boolean | null;
                label?: string | null;
                multiple?: boolean | null;
                nullable?: boolean | null;
                optionText?: string | null;
                reference: ServiceAppCmsReferenceTypes;
                source: string;
                filter?: {
                  __typename?: "ExtraFieldTypeReferenceFilter";
                  type?: string | null;
                  enabled?: boolean | null;
                } | null;
                selectOptions?: {
                  __typename?: "ExtraFieldTypeReferenceSelectOptions";
                  optionText: string;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeRichText";
                type: string;
                label?: string | null;
                source: string;
              }
            | { __typename?: "ExtraFieldTypeSearch"; type: string }
            | {
                __typename?: "ExtraFieldTypeSelect";
                type: string;
                defaultChoice?: string | null;
                defaultValue?: string | null;
                label?: string | null;
                source: string;
                choices: Array<{
                  __typename?: "ExtraFieldTypeSelectChoice";
                  id: string;
                  name: string;
                }>;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeText";
                type: string;
                defaultValue?: string | null;
                disabled?: boolean | null;
                label?: string | null;
                source: string;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeTextLabel";
                type: string;
                initialValue?: string | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
          > | null;
        } | null;
        service?: {
          __typename?: "ServiceOptionAppCmsFunction";
          showMediaInput?: boolean | null;
          qrCodeEmbeddedInFlyout?: boolean | null;
          previewMediaSource?: string | null;
          extraFields?: Array<
            | {
                __typename?: "ExtraFieldTypeArray";
                type: string;
                label?: string | null;
                showTitle?: boolean | null;
                source: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
              }
            | {
                __typename?: "ExtraFieldTypeBoolean";
                type: string;
                label?: string | null;
                source: string;
                defaultValueBoolean?: boolean | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeBox";
                type: string;
                extraFields: Array<
                  | {
                      __typename?: "ExtraFieldTypeArray";
                      type: string;
                      label?: string | null;
                      showTitle?: boolean | null;
                      source: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBoolean";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueBoolean?: boolean | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeBox";
                      type: string;
                      extraFields: Array<
                        | {
                            __typename?: "ExtraFieldTypeArray";
                            type: string;
                            label?: string | null;
                            showTitle?: boolean | null;
                            source: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBoolean";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueBoolean?: boolean | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeBox";
                            type: string;
                            extraFields: Array<
                              | {
                                  __typename?: "ExtraFieldTypeArray";
                                  type: string;
                                  label?: string | null;
                                  showTitle?: boolean | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBoolean";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueBoolean?: boolean | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeBox";
                                  type: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeColor";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueColor?: string | null;
                                  metadata?: {
                                    __typename?: "ExtraFieldMetadata";
                                    allowOverride?: {
                                      __typename?: "ExtraFieldMetadataProperties";
                                      defaultValue?: boolean | null;
                                    } | null;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeHelp";
                                  type: string;
                                  label?: string | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeMedia";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeNumber";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                  defaultValueNumber?: number | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeReference";
                                  type: string;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  multiple?: boolean | null;
                                  nullable?: boolean | null;
                                  optionText?: string | null;
                                  reference: ServiceAppCmsReferenceTypes;
                                  source: string;
                                  filter?: {
                                    __typename?: "ExtraFieldTypeReferenceFilter";
                                    type?: string | null;
                                    enabled?: boolean | null;
                                  } | null;
                                  selectOptions?: {
                                    __typename?: "ExtraFieldTypeReferenceSelectOptions";
                                    optionText: string;
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeRichText";
                                  type: string;
                                  label?: string | null;
                                  source: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSearch";
                                  type: string;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeSelect";
                                  type: string;
                                  defaultChoice?: string | null;
                                  defaultValue?: string | null;
                                  label?: string | null;
                                  source: string;
                                  choices: Array<{
                                    __typename?: "ExtraFieldTypeSelectChoice";
                                    id: string;
                                    name: string;
                                  }>;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeText";
                                  type: string;
                                  defaultValue?: string | null;
                                  disabled?: boolean | null;
                                  label?: string | null;
                                  source: string;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                              | {
                                  __typename?: "ExtraFieldTypeTextLabel";
                                  type: string;
                                  initialValue?: string | null;
                                  condition?: {
                                    __typename?: "ExtraFieldCondition";
                                    field: string;
                                    value:
                                      | {
                                          __typename?: "ConditionValueTypeBoolean";
                                          type: string;
                                          valueBoolean: boolean;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeNumber";
                                          type: string;
                                          valueNumber: number;
                                        }
                                      | {
                                          __typename?: "ConditionValueTypeString";
                                          type: string;
                                          valueString: string;
                                        };
                                  } | null;
                                }
                            >;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeColor";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueColor?: string | null;
                            metadata?: {
                              __typename?: "ExtraFieldMetadata";
                              allowOverride?: {
                                __typename?: "ExtraFieldMetadataProperties";
                                defaultValue?: boolean | null;
                              } | null;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeHelp";
                            type: string;
                            label?: string | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeMedia";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | {
                            __typename?: "ExtraFieldTypeNumber";
                            type: string;
                            label?: string | null;
                            source: string;
                            defaultValueNumber?: number | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeReference";
                            type: string;
                            disabled?: boolean | null;
                            label?: string | null;
                            multiple?: boolean | null;
                            nullable?: boolean | null;
                            optionText?: string | null;
                            reference: ServiceAppCmsReferenceTypes;
                            source: string;
                            filter?: {
                              __typename?: "ExtraFieldTypeReferenceFilter";
                              type?: string | null;
                              enabled?: boolean | null;
                            } | null;
                            selectOptions?: {
                              __typename?: "ExtraFieldTypeReferenceSelectOptions";
                              optionText: string;
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeRichText";
                            type: string;
                            label?: string | null;
                            source: string;
                          }
                        | { __typename?: "ExtraFieldTypeSearch"; type: string }
                        | {
                            __typename?: "ExtraFieldTypeSelect";
                            type: string;
                            defaultChoice?: string | null;
                            defaultValue?: string | null;
                            label?: string | null;
                            source: string;
                            choices: Array<{
                              __typename?: "ExtraFieldTypeSelectChoice";
                              id: string;
                              name: string;
                            }>;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeText";
                            type: string;
                            defaultValue?: string | null;
                            disabled?: boolean | null;
                            label?: string | null;
                            source: string;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                        | {
                            __typename?: "ExtraFieldTypeTextLabel";
                            type: string;
                            initialValue?: string | null;
                            condition?: {
                              __typename?: "ExtraFieldCondition";
                              field: string;
                              value:
                                | {
                                    __typename?: "ConditionValueTypeBoolean";
                                    type: string;
                                    valueBoolean: boolean;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeNumber";
                                    type: string;
                                    valueNumber: number;
                                  }
                                | {
                                    __typename?: "ConditionValueTypeString";
                                    type: string;
                                    valueString: string;
                                  };
                            } | null;
                          }
                      >;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeColor";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueColor?: string | null;
                      metadata?: {
                        __typename?: "ExtraFieldMetadata";
                        allowOverride?: {
                          __typename?: "ExtraFieldMetadataProperties";
                          defaultValue?: boolean | null;
                        } | null;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeHelp";
                      type: string;
                      label?: string | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeMedia";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | {
                      __typename?: "ExtraFieldTypeNumber";
                      type: string;
                      label?: string | null;
                      source: string;
                      defaultValueNumber?: number | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeReference";
                      type: string;
                      disabled?: boolean | null;
                      label?: string | null;
                      multiple?: boolean | null;
                      nullable?: boolean | null;
                      optionText?: string | null;
                      reference: ServiceAppCmsReferenceTypes;
                      source: string;
                      filter?: {
                        __typename?: "ExtraFieldTypeReferenceFilter";
                        type?: string | null;
                        enabled?: boolean | null;
                      } | null;
                      selectOptions?: {
                        __typename?: "ExtraFieldTypeReferenceSelectOptions";
                        optionText: string;
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeRichText";
                      type: string;
                      label?: string | null;
                      source: string;
                    }
                  | { __typename?: "ExtraFieldTypeSearch"; type: string }
                  | {
                      __typename?: "ExtraFieldTypeSelect";
                      type: string;
                      defaultChoice?: string | null;
                      defaultValue?: string | null;
                      label?: string | null;
                      source: string;
                      choices: Array<{
                        __typename?: "ExtraFieldTypeSelectChoice";
                        id: string;
                        name: string;
                      }>;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeText";
                      type: string;
                      defaultValue?: string | null;
                      disabled?: boolean | null;
                      label?: string | null;
                      source: string;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                  | {
                      __typename?: "ExtraFieldTypeTextLabel";
                      type: string;
                      initialValue?: string | null;
                      condition?: {
                        __typename?: "ExtraFieldCondition";
                        field: string;
                        value:
                          | {
                              __typename?: "ConditionValueTypeBoolean";
                              type: string;
                              valueBoolean: boolean;
                            }
                          | {
                              __typename?: "ConditionValueTypeNumber";
                              type: string;
                              valueNumber: number;
                            }
                          | {
                              __typename?: "ConditionValueTypeString";
                              type: string;
                              valueString: string;
                            };
                      } | null;
                    }
                >;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeColor";
                type: string;
                label?: string | null;
                source: string;
                defaultValueColor?: string | null;
                metadata?: {
                  __typename?: "ExtraFieldMetadata";
                  allowOverride?: {
                    __typename?: "ExtraFieldMetadataProperties";
                    defaultValue?: boolean | null;
                  } | null;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeHelp";
                type: string;
                label?: string | null;
              }
            | {
                __typename?: "ExtraFieldTypeMedia";
                type: string;
                label?: string | null;
                source: string;
              }
            | {
                __typename?: "ExtraFieldTypeNumber";
                type: string;
                label?: string | null;
                source: string;
                defaultValueNumber?: number | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeReference";
                type: string;
                disabled?: boolean | null;
                label?: string | null;
                multiple?: boolean | null;
                nullable?: boolean | null;
                optionText?: string | null;
                reference: ServiceAppCmsReferenceTypes;
                source: string;
                filter?: {
                  __typename?: "ExtraFieldTypeReferenceFilter";
                  type?: string | null;
                  enabled?: boolean | null;
                } | null;
                selectOptions?: {
                  __typename?: "ExtraFieldTypeReferenceSelectOptions";
                  optionText: string;
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeRichText";
                type: string;
                label?: string | null;
                source: string;
              }
            | { __typename?: "ExtraFieldTypeSearch"; type: string }
            | {
                __typename?: "ExtraFieldTypeSelect";
                type: string;
                defaultChoice?: string | null;
                defaultValue?: string | null;
                label?: string | null;
                source: string;
                choices: Array<{
                  __typename?: "ExtraFieldTypeSelectChoice";
                  id: string;
                  name: string;
                }>;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeText";
                type: string;
                defaultValue?: string | null;
                disabled?: boolean | null;
                label?: string | null;
                source: string;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
            | {
                __typename?: "ExtraFieldTypeTextLabel";
                type: string;
                initialValue?: string | null;
                condition?: {
                  __typename?: "ExtraFieldCondition";
                  field: string;
                  value:
                    | {
                        __typename?: "ConditionValueTypeBoolean";
                        type: string;
                        valueBoolean: boolean;
                      }
                    | {
                        __typename?: "ConditionValueTypeNumber";
                        type: string;
                        valueNumber: number;
                      }
                    | {
                        __typename?: "ConditionValueTypeString";
                        type: string;
                        valueString: string;
                      };
                } | null;
              }
          > | null;
        } | null;
      } | null;
    } | null;
  }>;
};

export type GetServiceListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceListNameIdQuery = {
  __typename?: "Query";
  items: Array<{ __typename?: "Service"; id?: string | null; name: string }>;
};

export type GetManagementServiceListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<ServiceQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetManagementServiceListNameIdQuery = {
  __typename?: "Query";
  items: Array<{ __typename?: "Service"; id?: string | null; name: string }>;
};

export type GetTagQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetTagQuery = {
  __typename?: "Query";
  item: {
    __typename: "Tag";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    icon?: string | null;
    iconType?: IconType | null;
    id?: string | null;
    mediaIcon?: string | null;
    organization: string;
    title?: string | null;
    updatedAt?: any | null;
  };
};

export type GetTagGridQueryVariables = Exact<{
  filter?: InputMaybe<TagQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTagGridQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Tag";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    icon?: string | null;
    id?: string | null;
    organization: string;
    title?: string | null;
    updatedAt?: any | null;
  }>;
  total: { __typename: "ListMetadata"; count: number };
};

export type GetTagListFullQueryVariables = Exact<{
  filter?: InputMaybe<TagQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTagListFullQuery = {
  __typename?: "Query";
  items: Array<{
    __typename: "Tag";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    icon?: string | null;
    iconType?: IconType | null;
    id?: string | null;
    mediaIcon?: string | null;
    organization: string;
    title?: string | null;
    updatedAt?: any | null;
  }>;
};

export type GetTagListNameIdQueryVariables = Exact<{
  filter?: InputMaybe<TagQueryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  sortField?: InputMaybe<Scalars["String"]["input"]>;
  sortOrder?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTagListNameIdQuery = {
  __typename?: "Query";
  items: Array<{
    __typename?: "Tag";
    id?: string | null;
    title?: string | null;
  }>;
};

export type CreateTagMutationVariables = Exact<{
  title: Scalars["String"]["input"];
  iconType: IconType;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  mediaIcon?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CreateTagMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Tag";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    icon?: string | null;
    iconType?: IconType | null;
    id?: string | null;
    mediaIcon?: string | null;
    organization: string;
    title?: string | null;
    updatedAt?: any | null;
  };
};

export type DeleteTagMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteTagMutation = { __typename?: "Mutation"; data: boolean };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  iconType: IconType;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  mediaIcon?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type UpdateTagMutation = {
  __typename?: "Mutation";
  data: {
    __typename: "Tag";
    _id?: string | null;
    _version?: number | null;
    createdAt?: any | null;
    deleted?: boolean | null;
    icon?: string | null;
    iconType?: IconType | null;
    id?: string | null;
    mediaIcon?: string | null;
    organization: string;
    title?: string | null;
    updatedAt?: any | null;
  };
};

export type ValidateGqlModelMutationVariables = Exact<{
  action: Scalars["String"]["input"];
  data: Scalars["JSONObject"]["input"];
}>;

export type ValidateGqlModelMutation = {
  __typename?: "Mutation";
  data: { __typename?: "ValidationModel"; errors?: Array<any> | null };
};

export const AnimationOptionFragmentFragmentDoc = gql`
  fragment AnimationOptionFragment on AnimationOption {
    ... on AnimationOptionFade {
      type
      duration
    }
    ... on AnimationOptionFlip {
      type
      direction
      duration
    }
    ... on AnimationOptionWipe {
      type
      duration
      function
    }
  }
`;
export const ActionPayloadPropsFragmentDoc = gql`
  fragment ActionPayloadProps on ActionPayload {
    ... on ActionPayloadPostEnabled {
      type
      enabled
      post
    }
    ... on ActionPayloadLocationProfileChanged {
      type
      location
      profile
    }
  }
`;
export const ConditionValueTypePropsStaticFragmentDoc = gql`
  fragment ConditionValueTypePropsStatic on ConditionValueType {
    ... on ConditionValueTypeBoolean {
      type
      valueBoolean
    }
    ... on ConditionValueTypeNumber {
      type
      valueNumber
    }
    ... on ConditionValueTypeString {
      type
      valueString
    }
  }
`;
export const ExtraFieldTypePropsStaticFragmentDoc = gql`
  fragment ExtraFieldTypePropsStatic on ExtraFieldType {
    ... on ExtraFieldTypeBoolean {
      type
      defaultValueBoolean: defaultValue
      label
      metadata {
        allowOverride {
          defaultValue
        }
      }
      source
    }
    ... on ExtraFieldTypeColor {
      type
      defaultValueColor: defaultValue
      metadata {
        allowOverride {
          defaultValue
        }
      }
      label
      source
    }
    ... on ExtraFieldTypeHelp {
      type
      label
    }
    ... on ExtraFieldTypeMedia {
      type
      label
      source
    }
    ... on ExtraFieldTypeNumber {
      type
      condition {
        field
        value {
          ...ConditionValueTypePropsStatic
        }
      }
      defaultValueNumber: defaultValue
      label
      source
    }
    ... on ExtraFieldTypeReference {
      type
      disabled
      filter {
        type
        enabled
      }
      label
      multiple
      nullable
      optionText
      reference
      selectOptions {
        optionText
      }
      source
    }
    ... on ExtraFieldTypeRichText {
      type
      label
      source
    }
    ... on ExtraFieldTypeSearch {
      type
    }
    ... on ExtraFieldTypeSelect {
      type
      choices {
        id
        name
      }
      condition {
        field
        value {
          ...ConditionValueTypePropsStatic
        }
      }
      defaultChoice
      defaultValue
      label
      source
    }
    ... on ExtraFieldTypeText {
      type
      condition {
        field
        value {
          ...ConditionValueTypePropsStatic
        }
      }
      defaultValue
      disabled
      label
      source
    }
    ... on ExtraFieldTypeTextLabel {
      type
      condition {
        field
        value {
          ...ConditionValueTypePropsStatic
        }
      }
      initialValue
    }
  }
  ${ConditionValueTypePropsStaticFragmentDoc}
`;
export const ExtraFieldTypeArrayPropsStaticFragmentDoc = gql`
  fragment ExtraFieldTypeArrayPropsStatic on ExtraFieldTypeArray {
    type
    label
    showTitle
    source
  }
`;
export const ExtraFieldTypeBoxPropsStaticFragmentDoc = gql`
  fragment ExtraFieldTypeBoxPropsStatic on ExtraFieldTypeBox {
    type
    condition {
      field
      value {
        ...ConditionValueTypePropsStatic
      }
    }
  }
  ${ConditionValueTypePropsStaticFragmentDoc}
`;
export const ExtraFieldTypePropsRecursiveFragmentDoc = gql`
  fragment ExtraFieldTypePropsRecursive on ExtraFieldType {
    ...ExtraFieldTypePropsStatic
    ... on ExtraFieldTypeArray {
      ...ExtraFieldTypeArrayPropsStatic
      extraFields {
        ...ExtraFieldTypePropsStatic
        ... on ExtraFieldTypeArray {
          ...ExtraFieldTypeArrayPropsStatic
          extraFields {
            ...ExtraFieldTypePropsStatic
            ... on ExtraFieldTypeArray {
              ...ExtraFieldTypeArrayPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
            ... on ExtraFieldTypeBox {
              ...ExtraFieldTypeBoxPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
          }
        }
        ... on ExtraFieldTypeBox {
          ...ExtraFieldTypeBoxPropsStatic
          extraFields {
            ...ExtraFieldTypePropsStatic
            ... on ExtraFieldTypeArray {
              ...ExtraFieldTypeArrayPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
            ... on ExtraFieldTypeBox {
              ...ExtraFieldTypeBoxPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
          }
        }
      }
    }
    ... on ExtraFieldTypeBox {
      ...ExtraFieldTypeBoxPropsStatic
      extraFields {
        ...ExtraFieldTypePropsStatic
        ... on ExtraFieldTypeArray {
          ...ExtraFieldTypeArrayPropsStatic
          extraFields {
            ...ExtraFieldTypePropsStatic
            ... on ExtraFieldTypeArray {
              ...ExtraFieldTypeArrayPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
            ... on ExtraFieldTypeBox {
              ...ExtraFieldTypeBoxPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
          }
        }
        ... on ExtraFieldTypeBox {
          ...ExtraFieldTypeBoxPropsStatic
          extraFields {
            ...ExtraFieldTypePropsStatic
            ... on ExtraFieldTypeArray {
              ...ExtraFieldTypeArrayPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
            ... on ExtraFieldTypeBox {
              ...ExtraFieldTypeBoxPropsStatic
              extraFields {
                ...ExtraFieldTypePropsStatic
                ... on ExtraFieldTypeArray {
                  ...ExtraFieldTypeArrayPropsStatic
                }
                ... on ExtraFieldTypeBox {
                  ...ExtraFieldTypeBoxPropsStatic
                }
              }
            }
          }
        }
      }
    }
  }
  ${ExtraFieldTypePropsStaticFragmentDoc}
  ${ExtraFieldTypeArrayPropsStaticFragmentDoc}
  ${ExtraFieldTypeBoxPropsStaticFragmentDoc}
`;
export const ServiceOptionAppCmsFunctionPropsFragmentDoc = gql`
  fragment ServiceOptionAppCmsFunctionProps on ServiceOptionAppCmsFunction {
    showMediaInput
    qrCodeEmbeddedInFlyout
    previewMediaSource
    extraFields {
      ...ExtraFieldTypePropsRecursive
    }
  }
  ${ExtraFieldTypePropsRecursiveFragmentDoc}
`;
export const ServiceOptionPropsFragmentDoc = gql`
  fragment ServiceOptionProps on ServiceOption {
    cms {
      post {
        ...ServiceOptionAppCmsFunctionProps
      }
      service {
        ...ServiceOptionAppCmsFunctionProps
      }
    }
  }
  ${ServiceOptionAppCmsFunctionPropsFragmentDoc}
`;
export const GetCustomerDocument = gql`
  query GetCustomer($id: String!) {
    item: Customer(id: $id) {
      _id
      _version
      auth0 {
        organizationId
      }
      createdAt
      deleted
      id
      key
      name
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomerQuery,
    GetCustomerQueryVariables
  > &
    (
      | { variables: GetCustomerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(
    GetCustomerDocument,
    options,
  );
}
export function useGetCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerQuery,
    GetCustomerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(
    GetCustomerDocument,
    options,
  );
}
export function useGetCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerQuery,
        GetCustomerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(
    GetCustomerDocument,
    options,
  );
}
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<
  typeof useGetCustomerLazyQuery
>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerSuspenseQuery
>;
export type GetCustomerQueryResult = Apollo.QueryResult<
  GetCustomerQuery,
  GetCustomerQueryVariables
>;
export const GetCustomerGridDocument = gql`
  query GetCustomerGrid(
    $filter: CustomerFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allCustomers(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      id
      key
      name
      updatedAt
      __typename
    }
    total: _allCustomersMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetCustomerGridQuery__
 *
 * To run a query within a React component, call `useGetCustomerGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetCustomerGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerGridQuery,
    GetCustomerGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerGridQuery, GetCustomerGridQueryVariables>(
    GetCustomerGridDocument,
    options,
  );
}
export function useGetCustomerGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerGridQuery,
    GetCustomerGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerGridQuery,
    GetCustomerGridQueryVariables
  >(GetCustomerGridDocument, options);
}
export function useGetCustomerGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerGridQuery,
        GetCustomerGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerGridQuery,
    GetCustomerGridQueryVariables
  >(GetCustomerGridDocument, options);
}
export type GetCustomerGridQueryHookResult = ReturnType<
  typeof useGetCustomerGridQuery
>;
export type GetCustomerGridLazyQueryHookResult = ReturnType<
  typeof useGetCustomerGridLazyQuery
>;
export type GetCustomerGridSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerGridSuspenseQuery
>;
export type GetCustomerGridQueryResult = Apollo.QueryResult<
  GetCustomerGridQuery,
  GetCustomerGridQueryVariables
>;
export const GetCustomerListNameIdDocument = gql`
  query GetCustomerListNameId(
    $filter: CustomerFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allCustomers(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetCustomerListNameIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetCustomerListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomerListNameIdQuery,
    GetCustomerListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCustomerListNameIdQuery,
    GetCustomerListNameIdQueryVariables
  >(GetCustomerListNameIdDocument, options);
}
export function useGetCustomerListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomerListNameIdQuery,
    GetCustomerListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomerListNameIdQuery,
    GetCustomerListNameIdQueryVariables
  >(GetCustomerListNameIdDocument, options);
}
export function useGetCustomerListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomerListNameIdQuery,
        GetCustomerListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCustomerListNameIdQuery,
    GetCustomerListNameIdQueryVariables
  >(GetCustomerListNameIdDocument, options);
}
export type GetCustomerListNameIdQueryHookResult = ReturnType<
  typeof useGetCustomerListNameIdQuery
>;
export type GetCustomerListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetCustomerListNameIdLazyQuery
>;
export type GetCustomerListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerListNameIdSuspenseQuery
>;
export type GetCustomerListNameIdQueryResult = Apollo.QueryResult<
  GetCustomerListNameIdQuery,
  GetCustomerListNameIdQueryVariables
>;
export const CreateCustomerDocument = gql`
  mutation CreateCustomer(
    $activatedAnalytics: CustomerAnalyticsConfigInput
    $name: String!
  ) {
    data: createCustomer(activatedAnalytics: $activatedAnalytics, name: $name) {
      _id
      _version
      auth0 {
        organizationId
      }
      createdAt
      deleted
      id
      key
      name
      updatedAt
      __typename
    }
  }
`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      activatedAnalytics: // value for 'activatedAnalytics'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >(CreateCustomerDocument, options);
}
export type CreateCustomerMutationHookResult = ReturnType<
  typeof useCreateCustomerMutation
>;
export type CreateCustomerMutationResult =
  Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;
export const DeleteCustomerDocument = gql`
  mutation DeleteCustomer($id: String!) {
    data: deleteCustomer(id: $id)
  }
`;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<
  DeleteCustomerMutation,
  DeleteCustomerMutationVariables
>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomerMutation,
    DeleteCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCustomerMutation,
    DeleteCustomerMutationVariables
  >(DeleteCustomerDocument, options);
}
export type DeleteCustomerMutationHookResult = ReturnType<
  typeof useDeleteCustomerMutation
>;
export type DeleteCustomerMutationResult =
  Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomerMutation,
  DeleteCustomerMutationVariables
>;
export const UpdateCustomerDocument = gql`
  mutation UpdateCustomer(
    $id: String!
    $activatedAnalytics: CustomerAnalyticsConfigInput
    $name: String!
  ) {
    data: updateCustomer(
      id: $id
      activatedAnalytics: $activatedAnalytics
      name: $name
    ) {
      _id
      _version
      auth0 {
        organizationId
      }
      createdAt
      deleted
      id
      key
      name
      updatedAt
      __typename
    }
  }
`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      activatedAnalytics: // value for 'activatedAnalytics'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UpdateCustomerDocument, options);
}
export type UpdateCustomerMutationHookResult = ReturnType<
  typeof useUpdateCustomerMutation
>;
export type UpdateCustomerMutationResult =
  Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export const GetDeviceDocument = gql`
  query GetDevice($id: String!) {
    item: Device(id: $id) {
      _id
      _version
      assetTag
      building
      config {
        analytics
        openDevToolsOnStart
        menu
      }
      createdAt
      customer
      deleted
      id
      license
      licenseVersion
      location
      name
      organization
      room
      status
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetDeviceQuery__
 *
 * To run a query within a React component, call `useGetDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeviceQuery,
    GetDeviceQueryVariables
  > &
    (
      | { variables: GetDeviceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceQuery, GetDeviceQueryVariables>(
    GetDeviceDocument,
    options,
  );
}
export function useGetDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceQuery,
    GetDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceQuery, GetDeviceQueryVariables>(
    GetDeviceDocument,
    options,
  );
}
export function useGetDeviceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDeviceQuery, GetDeviceQueryVariables>(
    GetDeviceDocument,
    options,
  );
}
export type GetDeviceQueryHookResult = ReturnType<typeof useGetDeviceQuery>;
export type GetDeviceLazyQueryHookResult = ReturnType<
  typeof useGetDeviceLazyQuery
>;
export type GetDeviceSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceSuspenseQuery
>;
export type GetDeviceQueryResult = Apollo.QueryResult<
  GetDeviceQuery,
  GetDeviceQueryVariables
>;
export const GetDeviceGridDocument = gql`
  query GetDeviceGrid(
    $filter: DeviceFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allDevices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      assetTag
      building
      config {
        analytics
        openDevToolsOnStart
        menu
      }
      customer
      createdAt
      deleted
      id
      location
      name
      organization
      room
      status
      updatedAt
      __typename
    }
    total: _allDevicesMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetDeviceGridQuery__
 *
 * To run a query within a React component, call `useGetDeviceGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetDeviceGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeviceGridQuery,
    GetDeviceGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceGridQuery, GetDeviceGridQueryVariables>(
    GetDeviceGridDocument,
    options,
  );
}
export function useGetDeviceGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceGridQuery,
    GetDeviceGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceGridQuery, GetDeviceGridQueryVariables>(
    GetDeviceGridDocument,
    options,
  );
}
export function useGetDeviceGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeviceGridQuery,
        GetDeviceGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceGridQuery,
    GetDeviceGridQueryVariables
  >(GetDeviceGridDocument, options);
}
export type GetDeviceGridQueryHookResult = ReturnType<
  typeof useGetDeviceGridQuery
>;
export type GetDeviceGridLazyQueryHookResult = ReturnType<
  typeof useGetDeviceGridLazyQuery
>;
export type GetDeviceGridSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceGridSuspenseQuery
>;
export type GetDeviceGridQueryResult = Apollo.QueryResult<
  GetDeviceGridQuery,
  GetDeviceGridQueryVariables
>;
export const GetDeviceListNameIdDocument = gql`
  query GetDeviceListNameId(
    $filter: DeviceFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allDevices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetDeviceListNameIdQuery__
 *
 * To run a query within a React component, call `useGetDeviceListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetDeviceListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeviceListNameIdQuery,
    GetDeviceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeviceListNameIdQuery,
    GetDeviceListNameIdQueryVariables
  >(GetDeviceListNameIdDocument, options);
}
export function useGetDeviceListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceListNameIdQuery,
    GetDeviceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeviceListNameIdQuery,
    GetDeviceListNameIdQueryVariables
  >(GetDeviceListNameIdDocument, options);
}
export function useGetDeviceListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDeviceListNameIdQuery,
        GetDeviceListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceListNameIdQuery,
    GetDeviceListNameIdQueryVariables
  >(GetDeviceListNameIdDocument, options);
}
export type GetDeviceListNameIdQueryHookResult = ReturnType<
  typeof useGetDeviceListNameIdQuery
>;
export type GetDeviceListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetDeviceListNameIdLazyQuery
>;
export type GetDeviceListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceListNameIdSuspenseQuery
>;
export type GetDeviceListNameIdQueryResult = Apollo.QueryResult<
  GetDeviceListNameIdQuery,
  GetDeviceListNameIdQueryVariables
>;
export const CreateDeviceDocument = gql`
  mutation CreateDevice(
    $assetTag: String!
    $building: String
    $config: DeviceActivationConfigInput
    $customer: ID!
    $location: ID
    $name: String
    $room: String
    $settings: [JSONObject!]
    $status: DeviceStatus!
  ) {
    data: createDevice(
      assetTag: $assetTag
      building: $building
      config: $config
      customer: $customer
      location: $location
      name: $name
      room: $room
      settings: $settings
      status: $status
    ) {
      _id
      _version
      assetTag
      building
      config {
        analytics
        openDevToolsOnStart
        menu
      }
      createdAt
      customer
      deleted
      id
      license
      licenseVersion
      location
      name
      organization
      room
      status
      updatedAt
      __typename
    }
  }
`;
export type CreateDeviceMutationFn = Apollo.MutationFunction<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      assetTag: // value for 'assetTag'
 *      building: // value for 'building'
 *      config: // value for 'config'
 *      customer: // value for 'customer'
 *      location: // value for 'location'
 *      name: // value for 'name'
 *      room: // value for 'room'
 *      settings: // value for 'settings'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCreateDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeviceMutation,
    CreateDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeviceMutation,
    CreateDeviceMutationVariables
  >(CreateDeviceDocument, options);
}
export type CreateDeviceMutationHookResult = ReturnType<
  typeof useCreateDeviceMutation
>;
export type CreateDeviceMutationResult =
  Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<
  CreateDeviceMutation,
  CreateDeviceMutationVariables
>;
export const DeleteDeviceDocument = gql`
  mutation DeleteDevice($id: String!) {
    data: deleteDevice(id: $id)
  }
`;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDeviceMutation,
    DeleteDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDeviceMutation,
    DeleteDeviceMutationVariables
  >(DeleteDeviceDocument, options);
}
export type DeleteDeviceMutationHookResult = ReturnType<
  typeof useDeleteDeviceMutation
>;
export type DeleteDeviceMutationResult =
  Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;
export const RegenerateDeviceLicenseDocument = gql`
  mutation RegenerateDeviceLicense($id: String!) {
    data: regenerateDeviceLicense(id: $id) {
      _id
      _version
      assetTag
      building
      config {
        analytics
        openDevToolsOnStart
        menu
      }
      createdAt
      customer
      deleted
      id
      license
      licenseVersion
      location
      name
      organization
      room
      status
      updatedAt
      __typename
    }
  }
`;
export type RegenerateDeviceLicenseMutationFn = Apollo.MutationFunction<
  RegenerateDeviceLicenseMutation,
  RegenerateDeviceLicenseMutationVariables
>;

/**
 * __useRegenerateDeviceLicenseMutation__
 *
 * To run a mutation, you first call `useRegenerateDeviceLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateDeviceLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateDeviceLicenseMutation, { data, loading, error }] = useRegenerateDeviceLicenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateDeviceLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegenerateDeviceLicenseMutation,
    RegenerateDeviceLicenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegenerateDeviceLicenseMutation,
    RegenerateDeviceLicenseMutationVariables
  >(RegenerateDeviceLicenseDocument, options);
}
export type RegenerateDeviceLicenseMutationHookResult = ReturnType<
  typeof useRegenerateDeviceLicenseMutation
>;
export type RegenerateDeviceLicenseMutationResult =
  Apollo.MutationResult<RegenerateDeviceLicenseMutation>;
export type RegenerateDeviceLicenseMutationOptions = Apollo.BaseMutationOptions<
  RegenerateDeviceLicenseMutation,
  RegenerateDeviceLicenseMutationVariables
>;
export const UpdateDeviceDocument = gql`
  mutation UpdateDevice(
    $id: String!
    $assetTag: String!
    $building: String
    $config: DeviceActivationConfigInput
    $customer: ID!
    $location: ID
    $name: String
    $room: String
    $settings: [JSONObject!]
    $status: DeviceStatus!
  ) {
    data: updateDevice(
      id: $id
      assetTag: $assetTag
      building: $building
      config: $config
      customer: $customer
      location: $location
      name: $name
      room: $room
      settings: $settings
      status: $status
    ) {
      _id
      _version
      assetTag
      building
      config {
        analytics
        openDevToolsOnStart
        menu
      }
      createdAt
      customer
      deleted
      id
      license
      licenseVersion
      location
      name
      organization
      room
      status
      updatedAt
      __typename
    }
  }
`;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables
>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assetTag: // value for 'assetTag'
 *      building: // value for 'building'
 *      config: // value for 'config'
 *      customer: // value for 'customer'
 *      location: // value for 'location'
 *      name: // value for 'name'
 *      room: // value for 'room'
 *      settings: // value for 'settings'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDeviceMutation,
    UpdateDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDeviceMutation,
    UpdateDeviceMutationVariables
  >(UpdateDeviceDocument, options);
}
export type UpdateDeviceMutationHookResult = ReturnType<
  typeof useUpdateDeviceMutation
>;
export type UpdateDeviceMutationResult =
  Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<
  UpdateDeviceMutation,
  UpdateDeviceMutationVariables
>;
export const GetLayoutDocument = gql`
  query GetLayout($id: String!) {
    item: Layout(id: $id) {
      _id
      _version
      id
      animation {
        enabled
        option {
          ...AnimationOptionFragment
        }
      }
      borderRadius
      content {
        tileContentUpdatePct
        tileContentUpdateFrequency
        staleFlyoutTimeout
      }
      custom {
        width
        height
        positions {
          x
          y
          width
          height
        }
      }
      name
      organization
      padding
      template
      tileCount
      __typename
    }
  }
  ${AnimationOptionFragmentFragmentDoc}
`;

/**
 * __useGetLayoutQuery__
 *
 * To run a query within a React component, call `useGetLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLayoutQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLayoutQuery,
    GetLayoutQueryVariables
  > &
    (
      | { variables: GetLayoutQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLayoutQuery, GetLayoutQueryVariables>(
    GetLayoutDocument,
    options,
  );
}
export function useGetLayoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLayoutQuery,
    GetLayoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLayoutQuery, GetLayoutQueryVariables>(
    GetLayoutDocument,
    options,
  );
}
export function useGetLayoutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLayoutQuery, GetLayoutQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLayoutQuery, GetLayoutQueryVariables>(
    GetLayoutDocument,
    options,
  );
}
export type GetLayoutQueryHookResult = ReturnType<typeof useGetLayoutQuery>;
export type GetLayoutLazyQueryHookResult = ReturnType<
  typeof useGetLayoutLazyQuery
>;
export type GetLayoutSuspenseQueryHookResult = ReturnType<
  typeof useGetLayoutSuspenseQuery
>;
export type GetLayoutQueryResult = Apollo.QueryResult<
  GetLayoutQuery,
  GetLayoutQueryVariables
>;
export const GetLayoutGridDocument = gql`
  query GetLayoutGrid(
    $filter: LayoutQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allLayouts(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      id
      name
      organization
      template
      updatedAt
      __typename
    }
    total: _allLayoutsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetLayoutGridQuery__
 *
 * To run a query within a React component, call `useGetLayoutGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayoutGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayoutGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetLayoutGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLayoutGridQuery,
    GetLayoutGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLayoutGridQuery, GetLayoutGridQueryVariables>(
    GetLayoutGridDocument,
    options,
  );
}
export function useGetLayoutGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLayoutGridQuery,
    GetLayoutGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLayoutGridQuery, GetLayoutGridQueryVariables>(
    GetLayoutGridDocument,
    options,
  );
}
export function useGetLayoutGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLayoutGridQuery,
        GetLayoutGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLayoutGridQuery,
    GetLayoutGridQueryVariables
  >(GetLayoutGridDocument, options);
}
export type GetLayoutGridQueryHookResult = ReturnType<
  typeof useGetLayoutGridQuery
>;
export type GetLayoutGridLazyQueryHookResult = ReturnType<
  typeof useGetLayoutGridLazyQuery
>;
export type GetLayoutGridSuspenseQueryHookResult = ReturnType<
  typeof useGetLayoutGridSuspenseQuery
>;
export type GetLayoutGridQueryResult = Apollo.QueryResult<
  GetLayoutGridQuery,
  GetLayoutGridQueryVariables
>;
export const GetLayoutListNameIdDocument = gql`
  query GetLayoutListNameId(
    $filter: LayoutQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allLayouts(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetLayoutListNameIdQuery__
 *
 * To run a query within a React component, call `useGetLayoutListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayoutListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayoutListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetLayoutListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLayoutListNameIdQuery,
    GetLayoutListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLayoutListNameIdQuery,
    GetLayoutListNameIdQueryVariables
  >(GetLayoutListNameIdDocument, options);
}
export function useGetLayoutListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLayoutListNameIdQuery,
    GetLayoutListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLayoutListNameIdQuery,
    GetLayoutListNameIdQueryVariables
  >(GetLayoutListNameIdDocument, options);
}
export function useGetLayoutListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLayoutListNameIdQuery,
        GetLayoutListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLayoutListNameIdQuery,
    GetLayoutListNameIdQueryVariables
  >(GetLayoutListNameIdDocument, options);
}
export type GetLayoutListNameIdQueryHookResult = ReturnType<
  typeof useGetLayoutListNameIdQuery
>;
export type GetLayoutListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetLayoutListNameIdLazyQuery
>;
export type GetLayoutListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetLayoutListNameIdSuspenseQuery
>;
export type GetLayoutListNameIdQueryResult = Apollo.QueryResult<
  GetLayoutListNameIdQuery,
  GetLayoutListNameIdQueryVariables
>;
export const CreateLayoutDocument = gql`
  mutation CreateLayout(
    $animation: AnimationInput!
    $borderRadius: Float!
    $content: ContentUpdateOptionsInput!
    $custom: LayoutCustomModelInput
    $name: String!
    $padding: Float!
    $template: String!
    $tileCount: Float!
  ) {
    data: createLayout(
      animation: $animation
      borderRadius: $borderRadius
      content: $content
      custom: $custom
      name: $name
      padding: $padding
      template: $template
      tileCount: $tileCount
    ) {
      _id
      _version
      id
      animation {
        enabled
        option {
          ...AnimationOptionFragment
        }
      }
      borderRadius
      content {
        tileContentUpdatePct
        tileContentUpdateFrequency
        staleFlyoutTimeout
      }
      custom {
        width
        height
        positions {
          x
          y
          width
          height
        }
      }
      name
      organization
      padding
      template
      tileCount
      __typename
    }
  }
  ${AnimationOptionFragmentFragmentDoc}
`;
export type CreateLayoutMutationFn = Apollo.MutationFunction<
  CreateLayoutMutation,
  CreateLayoutMutationVariables
>;

/**
 * __useCreateLayoutMutation__
 *
 * To run a mutation, you first call `useCreateLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLayoutMutation, { data, loading, error }] = useCreateLayoutMutation({
 *   variables: {
 *      animation: // value for 'animation'
 *      borderRadius: // value for 'borderRadius'
 *      content: // value for 'content'
 *      custom: // value for 'custom'
 *      name: // value for 'name'
 *      padding: // value for 'padding'
 *      template: // value for 'template'
 *      tileCount: // value for 'tileCount'
 *   },
 * });
 */
export function useCreateLayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLayoutMutation,
    CreateLayoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLayoutMutation,
    CreateLayoutMutationVariables
  >(CreateLayoutDocument, options);
}
export type CreateLayoutMutationHookResult = ReturnType<
  typeof useCreateLayoutMutation
>;
export type CreateLayoutMutationResult =
  Apollo.MutationResult<CreateLayoutMutation>;
export type CreateLayoutMutationOptions = Apollo.BaseMutationOptions<
  CreateLayoutMutation,
  CreateLayoutMutationVariables
>;
export const DeleteLayoutDocument = gql`
  mutation DeleteLayout($id: String!) {
    data: deleteLayout(id: $id)
  }
`;
export type DeleteLayoutMutationFn = Apollo.MutationFunction<
  DeleteLayoutMutation,
  DeleteLayoutMutationVariables
>;

/**
 * __useDeleteLayoutMutation__
 *
 * To run a mutation, you first call `useDeleteLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLayoutMutation, { data, loading, error }] = useDeleteLayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLayoutMutation,
    DeleteLayoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLayoutMutation,
    DeleteLayoutMutationVariables
  >(DeleteLayoutDocument, options);
}
export type DeleteLayoutMutationHookResult = ReturnType<
  typeof useDeleteLayoutMutation
>;
export type DeleteLayoutMutationResult =
  Apollo.MutationResult<DeleteLayoutMutation>;
export type DeleteLayoutMutationOptions = Apollo.BaseMutationOptions<
  DeleteLayoutMutation,
  DeleteLayoutMutationVariables
>;
export const UpdateLayoutDocument = gql`
  mutation UpdateLayout(
    $id: String!
    $animation: AnimationInput!
    $borderRadius: Float!
    $content: ContentUpdateOptionsInput!
    $custom: LayoutCustomModelInput
    $name: String!
    $padding: Float!
    $template: String!
    $tileCount: Float!
  ) {
    data: updateLayout(
      id: $id
      animation: $animation
      borderRadius: $borderRadius
      content: $content
      custom: $custom
      name: $name
      padding: $padding
      template: $template
      tileCount: $tileCount
    ) {
      _id
      _version
      id
      animation {
        enabled
        option {
          ...AnimationOptionFragment
        }
      }
      borderRadius
      content {
        tileContentUpdatePct
        tileContentUpdateFrequency
        staleFlyoutTimeout
      }
      custom {
        width
        height
        positions {
          x
          y
          width
          height
        }
      }
      name
      organization
      padding
      template
      tileCount
      __typename
    }
  }
  ${AnimationOptionFragmentFragmentDoc}
`;
export type UpdateLayoutMutationFn = Apollo.MutationFunction<
  UpdateLayoutMutation,
  UpdateLayoutMutationVariables
>;

/**
 * __useUpdateLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLayoutMutation, { data, loading, error }] = useUpdateLayoutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      animation: // value for 'animation'
 *      borderRadius: // value for 'borderRadius'
 *      content: // value for 'content'
 *      custom: // value for 'custom'
 *      name: // value for 'name'
 *      padding: // value for 'padding'
 *      template: // value for 'template'
 *      tileCount: // value for 'tileCount'
 *   },
 * });
 */
export function useUpdateLayoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLayoutMutation,
    UpdateLayoutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLayoutMutation,
    UpdateLayoutMutationVariables
  >(UpdateLayoutDocument, options);
}
export type UpdateLayoutMutationHookResult = ReturnType<
  typeof useUpdateLayoutMutation
>;
export type UpdateLayoutMutationResult =
  Apollo.MutationResult<UpdateLayoutMutation>;
export type UpdateLayoutMutationOptions = Apollo.BaseMutationOptions<
  UpdateLayoutMutation,
  UpdateLayoutMutationVariables
>;
export const GetLocationDocument = gql`
  query GetLocation($id: String!) {
    item: Location(id: $id) {
      _id
      _version
      createdAt
      deleted
      device {
        appMenu {
          positions
          show
        }
        screens {
          fullscreen
          overscan {
            bottom
            left
            right
            top
          }
          screenOffset {
            x
            y
          }
          videoSource {
            enabled
            showCloseButton
            x
            y
            width
            height
          }
        }
      }
      id
      name
      organization
      profile
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationQuery,
    GetLocationQueryVariables
  > &
    (
      | { variables: GetLocationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(
    GetLocationDocument,
    options,
  );
}
export function useGetLocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationQuery,
    GetLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(
    GetLocationDocument,
    options,
  );
}
export function useGetLocationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLocationQuery,
        GetLocationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLocationQuery, GetLocationQueryVariables>(
    GetLocationDocument,
    options,
  );
}
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<
  typeof useGetLocationLazyQuery
>;
export type GetLocationSuspenseQueryHookResult = ReturnType<
  typeof useGetLocationSuspenseQuery
>;
export type GetLocationQueryResult = Apollo.QueryResult<
  GetLocationQuery,
  GetLocationQueryVariables
>;
export const GetLocationGridDocument = gql`
  query GetLocationGrid(
    $filter: LocationFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allLocations(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      id
      name
      organization
      profile
      updatedAt
      __typename
    }
    total: _allLocationsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetLocationGridQuery__
 *
 * To run a query within a React component, call `useGetLocationGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetLocationGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLocationGridQuery,
    GetLocationGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocationGridQuery, GetLocationGridQueryVariables>(
    GetLocationGridDocument,
    options,
  );
}
export function useGetLocationGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationGridQuery,
    GetLocationGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationGridQuery,
    GetLocationGridQueryVariables
  >(GetLocationGridDocument, options);
}
export function useGetLocationGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLocationGridQuery,
        GetLocationGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLocationGridQuery,
    GetLocationGridQueryVariables
  >(GetLocationGridDocument, options);
}
export type GetLocationGridQueryHookResult = ReturnType<
  typeof useGetLocationGridQuery
>;
export type GetLocationGridLazyQueryHookResult = ReturnType<
  typeof useGetLocationGridLazyQuery
>;
export type GetLocationGridSuspenseQueryHookResult = ReturnType<
  typeof useGetLocationGridSuspenseQuery
>;
export type GetLocationGridQueryResult = Apollo.QueryResult<
  GetLocationGridQuery,
  GetLocationGridQueryVariables
>;
export const GetLocationListNameIdDocument = gql`
  query GetLocationListNameId(
    $filter: LocationFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allLocations(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetLocationListNameIdQuery__
 *
 * To run a query within a React component, call `useGetLocationListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetLocationListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLocationListNameIdQuery,
    GetLocationListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLocationListNameIdQuery,
    GetLocationListNameIdQueryVariables
  >(GetLocationListNameIdDocument, options);
}
export function useGetLocationListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationListNameIdQuery,
    GetLocationListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationListNameIdQuery,
    GetLocationListNameIdQueryVariables
  >(GetLocationListNameIdDocument, options);
}
export function useGetLocationListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLocationListNameIdQuery,
        GetLocationListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLocationListNameIdQuery,
    GetLocationListNameIdQueryVariables
  >(GetLocationListNameIdDocument, options);
}
export type GetLocationListNameIdQueryHookResult = ReturnType<
  typeof useGetLocationListNameIdQuery
>;
export type GetLocationListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetLocationListNameIdLazyQuery
>;
export type GetLocationListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetLocationListNameIdSuspenseQuery
>;
export type GetLocationListNameIdQueryResult = Apollo.QueryResult<
  GetLocationListNameIdQuery,
  GetLocationListNameIdQueryVariables
>;
export const CreateLocationDocument = gql`
  mutation CreateLocation(
    $device: LocationDeviceInput
    $name: String!
    $profile: ID
  ) {
    data: createLocation(device: $device, name: $name, profile: $profile) {
      _id
      _version
      createdAt
      deleted
      device {
        appMenu {
          positions
          show
        }
        screens {
          fullscreen
          overscan {
            bottom
            left
            right
            top
          }
          screenOffset {
            x
            y
          }
          videoSource {
            enabled
            showCloseButton
            x
            y
            width
            height
          }
        }
      }
      id
      name
      organization
      profile
      updatedAt
      __typename
    }
  }
`;
export type CreateLocationMutationFn = Apollo.MutationFunction<
  CreateLocationMutation,
  CreateLocationMutationVariables
>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      device: // value for 'device'
 *      name: // value for 'name'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useCreateLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLocationMutation,
    CreateLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLocationMutation,
    CreateLocationMutationVariables
  >(CreateLocationDocument, options);
}
export type CreateLocationMutationHookResult = ReturnType<
  typeof useCreateLocationMutation
>;
export type CreateLocationMutationResult =
  Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<
  CreateLocationMutation,
  CreateLocationMutationVariables
>;
export const DeleteLocationDocument = gql`
  mutation DeleteLocation($id: String!) {
    data: deleteLocation(id: $id)
  }
`;
export type DeleteLocationMutationFn = Apollo.MutationFunction<
  DeleteLocationMutation,
  DeleteLocationMutationVariables
>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLocationMutation,
    DeleteLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLocationMutation,
    DeleteLocationMutationVariables
  >(DeleteLocationDocument, options);
}
export type DeleteLocationMutationHookResult = ReturnType<
  typeof useDeleteLocationMutation
>;
export type DeleteLocationMutationResult =
  Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<
  DeleteLocationMutation,
  DeleteLocationMutationVariables
>;
export const UpdateLocationDocument = gql`
  mutation UpdateLocation(
    $id: String!
    $device: LocationDeviceInput
    $name: String!
    $profile: ID
  ) {
    data: updateLocation(
      id: $id
      device: $device
      name: $name
      profile: $profile
    ) {
      _id
      _version
      createdAt
      deleted
      device {
        appMenu {
          positions
          show
        }
        screens {
          fullscreen
          overscan {
            bottom
            left
            right
            top
          }
          screenOffset {
            x
            y
          }
          videoSource {
            enabled
            showCloseButton
            x
            y
            width
            height
          }
        }
      }
      id
      name
      organization
      profile
      updatedAt
      __typename
    }
  }
`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<
  UpdateLocationMutation,
  UpdateLocationMutationVariables
>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      device: // value for 'device'
 *      name: // value for 'name'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocationMutation,
    UpdateLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLocationMutation,
    UpdateLocationMutationVariables
  >(UpdateLocationDocument, options);
}
export type UpdateLocationMutationHookResult = ReturnType<
  typeof useUpdateLocationMutation
>;
export type UpdateLocationMutationResult =
  Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocationMutation,
  UpdateLocationMutationVariables
>;
export const GetMediaDocument = gql`
  query GetMedia($id: String!) {
    item: Media(id: $id) {
      _id
      _version
      createdAt
      deleted
      file
      id
      isDir
      lottie {
        data
        speed
      }
      name
      organization
      parent
      root
      size
      type
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetMediaQuery__
 *
 * To run a query within a React component, call `useGetMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMediaQuery(
  baseOptions: Apollo.QueryHookOptions<GetMediaQuery, GetMediaQueryVariables> &
    ({ variables: GetMediaQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMediaQuery, GetMediaQueryVariables>(
    GetMediaDocument,
    options,
  );
}
export function useGetMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMediaQuery,
    GetMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMediaQuery, GetMediaQueryVariables>(
    GetMediaDocument,
    options,
  );
}
export function useGetMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMediaQuery, GetMediaQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMediaQuery, GetMediaQueryVariables>(
    GetMediaDocument,
    options,
  );
}
export type GetMediaQueryHookResult = ReturnType<typeof useGetMediaQuery>;
export type GetMediaLazyQueryHookResult = ReturnType<
  typeof useGetMediaLazyQuery
>;
export type GetMediaSuspenseQueryHookResult = ReturnType<
  typeof useGetMediaSuspenseQuery
>;
export type GetMediaQueryResult = Apollo.QueryResult<
  GetMediaQuery,
  GetMediaQueryVariables
>;
export const GetMediaGridDocument = gql`
  query GetMediaGrid(
    $filter: MediaQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allMedia(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      file
      id
      isDir
      name
      organization
      parent
      root
      size
      type
      updatedAt
      __typename
    }
    total: _allMediaMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetMediaGridQuery__
 *
 * To run a query within a React component, call `useGetMediaGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetMediaGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMediaGridQuery,
    GetMediaGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMediaGridQuery, GetMediaGridQueryVariables>(
    GetMediaGridDocument,
    options,
  );
}
export function useGetMediaGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMediaGridQuery,
    GetMediaGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMediaGridQuery, GetMediaGridQueryVariables>(
    GetMediaGridDocument,
    options,
  );
}
export function useGetMediaGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMediaGridQuery,
        GetMediaGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMediaGridQuery, GetMediaGridQueryVariables>(
    GetMediaGridDocument,
    options,
  );
}
export type GetMediaGridQueryHookResult = ReturnType<
  typeof useGetMediaGridQuery
>;
export type GetMediaGridLazyQueryHookResult = ReturnType<
  typeof useGetMediaGridLazyQuery
>;
export type GetMediaGridSuspenseQueryHookResult = ReturnType<
  typeof useGetMediaGridSuspenseQuery
>;
export type GetMediaGridQueryResult = Apollo.QueryResult<
  GetMediaGridQuery,
  GetMediaGridQueryVariables
>;
export const GetMediaDownloadUrlDocument = gql`
  query GetMediaDownloadUrl($fileName: String!) {
    item: getMediaDownloadUrl(fileName: $fileName) {
      fileName
      url
      __typename
    }
  }
`;

/**
 * __useGetMediaDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetMediaDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaDownloadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetMediaDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMediaDownloadUrlQuery,
    GetMediaDownloadUrlQueryVariables
  > &
    (
      | { variables: GetMediaDownloadUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMediaDownloadUrlQuery,
    GetMediaDownloadUrlQueryVariables
  >(GetMediaDownloadUrlDocument, options);
}
export function useGetMediaDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMediaDownloadUrlQuery,
    GetMediaDownloadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMediaDownloadUrlQuery,
    GetMediaDownloadUrlQueryVariables
  >(GetMediaDownloadUrlDocument, options);
}
export function useGetMediaDownloadUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMediaDownloadUrlQuery,
        GetMediaDownloadUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMediaDownloadUrlQuery,
    GetMediaDownloadUrlQueryVariables
  >(GetMediaDownloadUrlDocument, options);
}
export type GetMediaDownloadUrlQueryHookResult = ReturnType<
  typeof useGetMediaDownloadUrlQuery
>;
export type GetMediaDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useGetMediaDownloadUrlLazyQuery
>;
export type GetMediaDownloadUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetMediaDownloadUrlSuspenseQuery
>;
export type GetMediaDownloadUrlQueryResult = Apollo.QueryResult<
  GetMediaDownloadUrlQuery,
  GetMediaDownloadUrlQueryVariables
>;
export const GetMediaUploadUrlDocument = gql`
  query GetMediaUploadUrl($fileName: String!) {
    item: getMediaUploadUrl(fileName: $fileName) {
      fileName
      url
      __typename
    }
  }
`;

/**
 * __useGetMediaUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetMediaUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetMediaUploadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMediaUploadUrlQuery,
    GetMediaUploadUrlQueryVariables
  > &
    (
      | { variables: GetMediaUploadUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMediaUploadUrlQuery,
    GetMediaUploadUrlQueryVariables
  >(GetMediaUploadUrlDocument, options);
}
export function useGetMediaUploadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMediaUploadUrlQuery,
    GetMediaUploadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMediaUploadUrlQuery,
    GetMediaUploadUrlQueryVariables
  >(GetMediaUploadUrlDocument, options);
}
export function useGetMediaUploadUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMediaUploadUrlQuery,
        GetMediaUploadUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMediaUploadUrlQuery,
    GetMediaUploadUrlQueryVariables
  >(GetMediaUploadUrlDocument, options);
}
export type GetMediaUploadUrlQueryHookResult = ReturnType<
  typeof useGetMediaUploadUrlQuery
>;
export type GetMediaUploadUrlLazyQueryHookResult = ReturnType<
  typeof useGetMediaUploadUrlLazyQuery
>;
export type GetMediaUploadUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetMediaUploadUrlSuspenseQuery
>;
export type GetMediaUploadUrlQueryResult = Apollo.QueryResult<
  GetMediaUploadUrlQuery,
  GetMediaUploadUrlQueryVariables
>;
export const CreateMediaDocument = gql`
  mutation CreateMedia(
    $name: String
    $isDir: Boolean
    $parent: ID
    $size: Float
    $type: String
    $file: String
    $lottie: MediaLottieAsset
    $customData: JSONObject
  ) {
    data: createMedia(
      name: $name
      isDir: $isDir
      parent: $parent
      size: $size
      type: $type
      file: $file
      lottie: $lottie
      customData: $customData
    ) {
      _id
      _version
      createdAt
      customData
      deleted
      file
      id
      isDir
      lottie {
        data
        speed
        __typename
      }
      name
      organization
      parent
      root
      size
      type
      updatedAt
      __typename
    }
  }
`;
export type CreateMediaMutationFn = Apollo.MutationFunction<
  CreateMediaMutation,
  CreateMediaMutationVariables
>;

/**
 * __useCreateMediaMutation__
 *
 * To run a mutation, you first call `useCreateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaMutation, { data, loading, error }] = useCreateMediaMutation({
 *   variables: {
 *      name: // value for 'name'
 *      isDir: // value for 'isDir'
 *      parent: // value for 'parent'
 *      size: // value for 'size'
 *      type: // value for 'type'
 *      file: // value for 'file'
 *      lottie: // value for 'lottie'
 *      customData: // value for 'customData'
 *   },
 * });
 */
export function useCreateMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMediaMutation,
    CreateMediaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMediaMutation, CreateMediaMutationVariables>(
    CreateMediaDocument,
    options,
  );
}
export type CreateMediaMutationHookResult = ReturnType<
  typeof useCreateMediaMutation
>;
export type CreateMediaMutationResult =
  Apollo.MutationResult<CreateMediaMutation>;
export type CreateMediaMutationOptions = Apollo.BaseMutationOptions<
  CreateMediaMutation,
  CreateMediaMutationVariables
>;
export const DeleteMediaDocument = gql`
  mutation DeleteMedia($id: String!) {
    data: deleteMedia(id: $id)
  }
`;
export type DeleteMediaMutationFn = Apollo.MutationFunction<
  DeleteMediaMutation,
  DeleteMediaMutationVariables
>;

/**
 * __useDeleteMediaMutation__
 *
 * To run a mutation, you first call `useDeleteMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMediaMutation, { data, loading, error }] = useDeleteMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMediaMutation,
    DeleteMediaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMediaMutation, DeleteMediaMutationVariables>(
    DeleteMediaDocument,
    options,
  );
}
export type DeleteMediaMutationHookResult = ReturnType<
  typeof useDeleteMediaMutation
>;
export type DeleteMediaMutationResult =
  Apollo.MutationResult<DeleteMediaMutation>;
export type DeleteMediaMutationOptions = Apollo.BaseMutationOptions<
  DeleteMediaMutation,
  DeleteMediaMutationVariables
>;
export const UpdateMediaDocument = gql`
  mutation UpdateMedia(
    $id: String!
    $name: String
    $isDir: Boolean
    $parent: ID
    $size: Float
    $type: String
    $file: String
    $lottie: MediaLottieAsset
    $customData: JSONObject
  ) {
    data: updateMedia(
      id: $id
      name: $name
      isDir: $isDir
      parent: $parent
      size: $size
      type: $type
      file: $file
      lottie: $lottie
      customData: $customData
    ) {
      _id
      _version
      createdAt
      customData
      deleted
      file
      id
      isDir
      lottie {
        data
        speed
        __typename
      }
      name
      organization
      parent
      root
      size
      type
      updatedAt
      __typename
    }
  }
`;
export type UpdateMediaMutationFn = Apollo.MutationFunction<
  UpdateMediaMutation,
  UpdateMediaMutationVariables
>;

/**
 * __useUpdateMediaMutation__
 *
 * To run a mutation, you first call `useUpdateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaMutation, { data, loading, error }] = useUpdateMediaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      isDir: // value for 'isDir'
 *      parent: // value for 'parent'
 *      size: // value for 'size'
 *      type: // value for 'type'
 *      file: // value for 'file'
 *      lottie: // value for 'lottie'
 *      customData: // value for 'customData'
 *   },
 * });
 */
export function useUpdateMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMediaMutation,
    UpdateMediaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMediaMutation, UpdateMediaMutationVariables>(
    UpdateMediaDocument,
    options,
  );
}
export type UpdateMediaMutationHookResult = ReturnType<
  typeof useUpdateMediaMutation
>;
export type UpdateMediaMutationResult =
  Apollo.MutationResult<UpdateMediaMutation>;
export type UpdateMediaMutationOptions = Apollo.BaseMutationOptions<
  UpdateMediaMutation,
  UpdateMediaMutationVariables
>;
export const GetOrganizationListNameIdDocument = gql`
  query GetOrganizationListNameId(
    $orgIds: [String!]
    $filter: OrganizationFilter
  ) {
    items: getOrganizations(orgIds: $orgIds, filter: $filter) {
      id
      name
      orgId
    }
  }
`;

/**
 * __useGetOrganizationListNameIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationListNameIdQuery({
 *   variables: {
 *      orgIds: // value for 'orgIds'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationListNameIdQuery,
    GetOrganizationListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationListNameIdQuery,
    GetOrganizationListNameIdQueryVariables
  >(GetOrganizationListNameIdDocument, options);
}
export function useGetOrganizationListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationListNameIdQuery,
    GetOrganizationListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationListNameIdQuery,
    GetOrganizationListNameIdQueryVariables
  >(GetOrganizationListNameIdDocument, options);
}
export function useGetOrganizationListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOrganizationListNameIdQuery,
        GetOrganizationListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationListNameIdQuery,
    GetOrganizationListNameIdQueryVariables
  >(GetOrganizationListNameIdDocument, options);
}
export type GetOrganizationListNameIdQueryHookResult = ReturnType<
  typeof useGetOrganizationListNameIdQuery
>;
export type GetOrganizationListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationListNameIdLazyQuery
>;
export type GetOrganizationListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetOrganizationListNameIdSuspenseQuery
>;
export type GetOrganizationListNameIdQueryResult = Apollo.QueryResult<
  GetOrganizationListNameIdQuery,
  GetOrganizationListNameIdQueryVariables
>;
export const GetPostDocument = gql`
  query GetPost($id: String!) {
    item: Post(id: $id) {
      _id
      _version
      customData
      deleted
      enabled
      flyoutPosition {
        x
        y
        width
        height
      }
      flyoutShowCloseButton
      flyoutScale
      flyoutType
      hideFromSearch
      id
      organization
      qrCodeLink
      qrCodeLinkByLocationProfile {
        location
        profile
        qrCodeLink
      }
      qrCodeLocation {
        type
        size
        x
        y
        width
        height
      }
      qrCodeLocationPercent {
        x
        y
        width
        height
      }
      qrCodeStyle {
        backdropColor
        boxShape
        boxColor
        borderEnabled
        borderColor
        textColor
        textSize
        textHidden
        qrColor
        qrBackgroundColor
        qrSize
        qrAlignHorizontal
        qrAlignVertical
        textAlignHorizontal
        textAlignVertical
      }
      qrCodeText
      relatedPostAsset
      relatedPosts
      staleFlyoutTimeout
      tags
      tileAssets {
        customData
        layout
        media
        qrLinkPrefix
        tileBackingImage
        tileType
      }
      title
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPostQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostQuery, GetPostQueryVariables> &
    ({ variables: GetPostQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostQuery, GetPostQueryVariables>(
    GetPostDocument,
    options,
  );
}
export function useGetPostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPostQuery,
    GetPostQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostQuery, GetPostQueryVariables>(
    GetPostDocument,
    options,
  );
}
export function useGetPostSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPostQuery, GetPostQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPostQuery, GetPostQueryVariables>(
    GetPostDocument,
    options,
  );
}
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostSuspenseQueryHookResult = ReturnType<
  typeof useGetPostSuspenseQuery
>;
export type GetPostQueryResult = Apollo.QueryResult<
  GetPostQuery,
  GetPostQueryVariables
>;
export const GetPostGridDocument = gql`
  query GetPostGrid(
    $filter: PostFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allPosts(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      enabled
      flyoutType
      id
      organization
      tags
      title
      updatedAt
      __typename
    }
    total: _allPostsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetPostGridQuery__
 *
 * To run a query within a React component, call `useGetPostGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetPostGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPostGridQuery,
    GetPostGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostGridQuery, GetPostGridQueryVariables>(
    GetPostGridDocument,
    options,
  );
}
export function useGetPostGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPostGridQuery,
    GetPostGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostGridQuery, GetPostGridQueryVariables>(
    GetPostGridDocument,
    options,
  );
}
export function useGetPostGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPostGridQuery,
        GetPostGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPostGridQuery, GetPostGridQueryVariables>(
    GetPostGridDocument,
    options,
  );
}
export type GetPostGridQueryHookResult = ReturnType<typeof useGetPostGridQuery>;
export type GetPostGridLazyQueryHookResult = ReturnType<
  typeof useGetPostGridLazyQuery
>;
export type GetPostGridSuspenseQueryHookResult = ReturnType<
  typeof useGetPostGridSuspenseQuery
>;
export type GetPostGridQueryResult = Apollo.QueryResult<
  GetPostGridQuery,
  GetPostGridQueryVariables
>;
export const GetPostListFullDocument = gql`
  query GetPostListFull(
    $filter: PostFilter
    $page: Int
    $perPage: Int
    $sample: Boolean
    $sortField: String
    $sortOrder: String
  ) {
    items: allPosts(
      filter: $filter
      page: $page
      perPage: $perPage
      sample: $sample
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      customData
      deleted
      enabled
      flyoutPosition {
        x
        y
        width
        height
      }
      flyoutShowCloseButton
      flyoutScale
      flyoutType
      hideFromSearch
      id
      organization
      qrCodeLink
      qrCodeLinkByLocationProfile {
        location
        profile
        qrCodeLink
      }
      qrCodeLocation {
        type
        size
        x
        y
        width
        height
      }
      qrCodeLocationPercent {
        x
        y
        width
        height
      }
      qrCodeStyle {
        backdropColor
        boxShape
        boxColor
        borderEnabled
        borderColor
        textColor
        textSize
        textHidden
        qrColor
        qrBackgroundColor
        qrSize
        qrAlignHorizontal
        qrAlignVertical
        textAlignHorizontal
        textAlignVertical
      }
      qrCodeText
      relatedPostAsset
      relatedPosts
      staleFlyoutTimeout
      tags
      tileAssets {
        customData
        layout
        media
        qrLinkPrefix
        tileBackingImage
        tileType
      }
      title
      updatedAt
      __typename
    }
    total: _allPostsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetPostListFullQuery__
 *
 * To run a query within a React component, call `useGetPostListFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostListFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostListFullQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sample: // value for 'sample'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetPostListFullQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPostListFullQuery,
    GetPostListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostListFullQuery, GetPostListFullQueryVariables>(
    GetPostListFullDocument,
    options,
  );
}
export function useGetPostListFullLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPostListFullQuery,
    GetPostListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPostListFullQuery,
    GetPostListFullQueryVariables
  >(GetPostListFullDocument, options);
}
export function useGetPostListFullSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPostListFullQuery,
        GetPostListFullQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPostListFullQuery,
    GetPostListFullQueryVariables
  >(GetPostListFullDocument, options);
}
export type GetPostListFullQueryHookResult = ReturnType<
  typeof useGetPostListFullQuery
>;
export type GetPostListFullLazyQueryHookResult = ReturnType<
  typeof useGetPostListFullLazyQuery
>;
export type GetPostListFullSuspenseQueryHookResult = ReturnType<
  typeof useGetPostListFullSuspenseQuery
>;
export type GetPostListFullQueryResult = Apollo.QueryResult<
  GetPostListFullQuery,
  GetPostListFullQueryVariables
>;
export const GetPostListNameIdDocument = gql`
  query GetPostListNameId(
    $filter: PostFilter
    $page: Int
    $perPage: Int
    $sample: Boolean
    $sortField: String
    $sortOrder: String
  ) {
    items: allPosts(
      filter: $filter
      page: $page
      perPage: $perPage
      sample: $sample
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      title
    }
    total: _allPostsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
    }
  }
`;

/**
 * __useGetPostListNameIdQuery__
 *
 * To run a query within a React component, call `useGetPostListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sample: // value for 'sample'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetPostListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPostListNameIdQuery,
    GetPostListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPostListNameIdQuery,
    GetPostListNameIdQueryVariables
  >(GetPostListNameIdDocument, options);
}
export function useGetPostListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPostListNameIdQuery,
    GetPostListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPostListNameIdQuery,
    GetPostListNameIdQueryVariables
  >(GetPostListNameIdDocument, options);
}
export function useGetPostListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPostListNameIdQuery,
        GetPostListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPostListNameIdQuery,
    GetPostListNameIdQueryVariables
  >(GetPostListNameIdDocument, options);
}
export type GetPostListNameIdQueryHookResult = ReturnType<
  typeof useGetPostListNameIdQuery
>;
export type GetPostListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetPostListNameIdLazyQuery
>;
export type GetPostListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetPostListNameIdSuspenseQuery
>;
export type GetPostListNameIdQueryResult = Apollo.QueryResult<
  GetPostListNameIdQuery,
  GetPostListNameIdQueryVariables
>;
export const CreatePostDocument = gql`
  mutation CreatePost(
    $customData: JSONObject
    $enabled: Boolean!
    $flyoutPosition: PostFlyoutPositionModelInput
    $flyoutShowCloseButton: Boolean
    $flyoutScale: Float
    $flyoutType: ID
    $hideFromSearch: Boolean
    $qrCodeLink: String
    $qrCodeLinkByLocationProfile: [PostQrCodeByProfileInput!]
    $qrCodeLocation: PostQrCodeLocationInput
    $qrCodeLocationPercent: PostQrCodeLocationPercentInput
    $qrCodeStyle: PostQrCodeStyleInput
    $qrCodeText: String
    $relatedPostAsset: ID
    $relatedPosts: [ID!]
    $staleFlyoutTimeout: Float
    $tags: [ID!]
    $tileAssets: [PostTileAssetInput!]
    $title: String
  ) {
    data: createPost(
      customData: $customData
      enabled: $enabled
      flyoutPosition: $flyoutPosition
      flyoutShowCloseButton: $flyoutShowCloseButton
      flyoutScale: $flyoutScale
      flyoutType: $flyoutType
      hideFromSearch: $hideFromSearch
      qrCodeLink: $qrCodeLink
      qrCodeLinkByLocationProfile: $qrCodeLinkByLocationProfile
      qrCodeLocation: $qrCodeLocation
      qrCodeLocationPercent: $qrCodeLocationPercent
      qrCodeStyle: $qrCodeStyle
      qrCodeText: $qrCodeText
      relatedPostAsset: $relatedPostAsset
      relatedPosts: $relatedPosts
      staleFlyoutTimeout: $staleFlyoutTimeout
      tags: $tags
      tileAssets: $tileAssets
      title: $title
    ) {
      _id
      _version
      customData
      deleted
      enabled
      flyoutPosition {
        x
        y
        width
        height
      }
      flyoutShowCloseButton
      flyoutScale
      flyoutType
      hideFromSearch
      id
      organization
      qrCodeLink
      qrCodeLinkByLocationProfile {
        location
        profile
        qrCodeLink
      }
      qrCodeLocation {
        type
        size
        x
        y
        width
        height
      }
      qrCodeLocationPercent {
        x
        y
        width
        height
      }
      qrCodeStyle {
        backdropColor
        boxShape
        boxColor
        borderEnabled
        borderColor
        textColor
        textSize
        textHidden
        qrColor
        qrBackgroundColor
        qrSize
        qrAlignHorizontal
        qrAlignVertical
        textAlignHorizontal
        textAlignVertical
      }
      qrCodeText
      relatedPostAsset
      relatedPosts
      staleFlyoutTimeout
      tags
      tileAssets {
        customData
        layout
        media
        qrLinkPrefix
        tileBackingImage
        tileType
      }
      title
      updatedAt
      __typename
    }
  }
`;
export type CreatePostMutationFn = Apollo.MutationFunction<
  CreatePostMutation,
  CreatePostMutationVariables
>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      customData: // value for 'customData'
 *      enabled: // value for 'enabled'
 *      flyoutPosition: // value for 'flyoutPosition'
 *      flyoutShowCloseButton: // value for 'flyoutShowCloseButton'
 *      flyoutScale: // value for 'flyoutScale'
 *      flyoutType: // value for 'flyoutType'
 *      hideFromSearch: // value for 'hideFromSearch'
 *      qrCodeLink: // value for 'qrCodeLink'
 *      qrCodeLinkByLocationProfile: // value for 'qrCodeLinkByLocationProfile'
 *      qrCodeLocation: // value for 'qrCodeLocation'
 *      qrCodeLocationPercent: // value for 'qrCodeLocationPercent'
 *      qrCodeStyle: // value for 'qrCodeStyle'
 *      qrCodeText: // value for 'qrCodeText'
 *      relatedPostAsset: // value for 'relatedPostAsset'
 *      relatedPosts: // value for 'relatedPosts'
 *      staleFlyoutTimeout: // value for 'staleFlyoutTimeout'
 *      tags: // value for 'tags'
 *      tileAssets: // value for 'tileAssets'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePostMutation,
    CreatePostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(
    CreatePostDocument,
    options,
  );
}
export type CreatePostMutationHookResult = ReturnType<
  typeof useCreatePostMutation
>;
export type CreatePostMutationResult =
  Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<
  CreatePostMutation,
  CreatePostMutationVariables
>;
export const DeletePostDocument = gql`
  mutation DeletePost($id: String!) {
    data: deletePost(id: $id)
  }
`;
export type DeletePostMutationFn = Apollo.MutationFunction<
  DeletePostMutation,
  DeletePostMutationVariables
>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePostMutation,
    DeletePostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(
    DeletePostDocument,
    options,
  );
}
export type DeletePostMutationHookResult = ReturnType<
  typeof useDeletePostMutation
>;
export type DeletePostMutationResult =
  Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<
  DeletePostMutation,
  DeletePostMutationVariables
>;
export const EnablePostDocument = gql`
  mutation EnablePost($enabled: Boolean!, $id: String!) {
    data: enablePost(enabled: $enabled, id: $id) {
      _id
      _version
      enabled
      id
      updatedAt
      __typename
    }
  }
`;
export type EnablePostMutationFn = Apollo.MutationFunction<
  EnablePostMutation,
  EnablePostMutationVariables
>;

/**
 * __useEnablePostMutation__
 *
 * To run a mutation, you first call `useEnablePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnablePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enablePostMutation, { data, loading, error }] = useEnablePostMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnablePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnablePostMutation,
    EnablePostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EnablePostMutation, EnablePostMutationVariables>(
    EnablePostDocument,
    options,
  );
}
export type EnablePostMutationHookResult = ReturnType<
  typeof useEnablePostMutation
>;
export type EnablePostMutationResult =
  Apollo.MutationResult<EnablePostMutation>;
export type EnablePostMutationOptions = Apollo.BaseMutationOptions<
  EnablePostMutation,
  EnablePostMutationVariables
>;
export const UpdatePostDocument = gql`
  mutation UpdatePost(
    $id: String!
    $customData: JSONObject
    $enabled: Boolean!
    $flyoutPosition: PostFlyoutPositionModelInput
    $flyoutShowCloseButton: Boolean
    $flyoutScale: Float
    $flyoutType: ID
    $hideFromSearch: Boolean
    $qrCodeLink: String
    $qrCodeLinkByLocationProfile: [PostQrCodeByProfileInput!]
    $qrCodeLocation: PostQrCodeLocationInput
    $qrCodeLocationPercent: PostQrCodeLocationPercentInput
    $qrCodeStyle: PostQrCodeStyleInput
    $qrCodeText: String
    $relatedPostAsset: ID
    $relatedPosts: [ID!]
    $staleFlyoutTimeout: Float
    $tags: [ID!]
    $tileAssets: [PostTileAssetInput!]
    $title: String
  ) {
    data: updatePost(
      id: $id
      customData: $customData
      enabled: $enabled
      flyoutPosition: $flyoutPosition
      flyoutShowCloseButton: $flyoutShowCloseButton
      flyoutScale: $flyoutScale
      flyoutType: $flyoutType
      hideFromSearch: $hideFromSearch
      qrCodeLink: $qrCodeLink
      qrCodeLinkByLocationProfile: $qrCodeLinkByLocationProfile
      qrCodeLocation: $qrCodeLocation
      qrCodeLocationPercent: $qrCodeLocationPercent
      qrCodeStyle: $qrCodeStyle
      qrCodeText: $qrCodeText
      relatedPostAsset: $relatedPostAsset
      relatedPosts: $relatedPosts
      staleFlyoutTimeout: $staleFlyoutTimeout
      tags: $tags
      tileAssets: $tileAssets
      title: $title
    ) {
      _id
      _version
      customData
      deleted
      enabled
      flyoutPosition {
        x
        y
        width
        height
      }
      flyoutShowCloseButton
      flyoutScale
      flyoutType
      hideFromSearch
      id
      organization
      qrCodeLink
      qrCodeLinkByLocationProfile {
        location
        profile
        qrCodeLink
      }
      qrCodeLocation {
        type
        size
        x
        y
        width
        height
      }
      qrCodeLocationPercent {
        x
        y
        width
        height
      }
      qrCodeStyle {
        backdropColor
        boxShape
        boxColor
        borderEnabled
        borderColor
        textColor
        textSize
        textHidden
        qrColor
        qrBackgroundColor
        qrSize
        qrAlignHorizontal
        qrAlignVertical
        textAlignHorizontal
        textAlignVertical
      }
      qrCodeText
      relatedPostAsset
      relatedPosts
      staleFlyoutTimeout
      tags
      tileAssets {
        customData
        layout
        media
        qrLinkPrefix
        tileBackingImage
        tileType
      }
      title
      updatedAt
      __typename
    }
  }
`;
export type UpdatePostMutationFn = Apollo.MutationFunction<
  UpdatePostMutation,
  UpdatePostMutationVariables
>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customData: // value for 'customData'
 *      enabled: // value for 'enabled'
 *      flyoutPosition: // value for 'flyoutPosition'
 *      flyoutShowCloseButton: // value for 'flyoutShowCloseButton'
 *      flyoutScale: // value for 'flyoutScale'
 *      flyoutType: // value for 'flyoutType'
 *      hideFromSearch: // value for 'hideFromSearch'
 *      qrCodeLink: // value for 'qrCodeLink'
 *      qrCodeLinkByLocationProfile: // value for 'qrCodeLinkByLocationProfile'
 *      qrCodeLocation: // value for 'qrCodeLocation'
 *      qrCodeLocationPercent: // value for 'qrCodeLocationPercent'
 *      qrCodeStyle: // value for 'qrCodeStyle'
 *      qrCodeText: // value for 'qrCodeText'
 *      relatedPostAsset: // value for 'relatedPostAsset'
 *      relatedPosts: // value for 'relatedPosts'
 *      staleFlyoutTimeout: // value for 'staleFlyoutTimeout'
 *      tags: // value for 'tags'
 *      tileAssets: // value for 'tileAssets'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePostMutation,
    UpdatePostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(
    UpdatePostDocument,
    options,
  );
}
export type UpdatePostMutationHookResult = ReturnType<
  typeof useUpdatePostMutation
>;
export type UpdatePostMutationResult =
  Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<
  UpdatePostMutation,
  UpdatePostMutationVariables
>;
export const GetProfileDocument = gql`
  query GetProfile($id: String!) {
    item: getProfile(id: $id) {
      _id
      _version
      background {
        backgroundMedia
        backgroundMediaMode
      }
      createdAt
      deleted
      id
      layouts {
        detailed
        flyout {
          position {
            x
            y
            width
            height
          }
        }
        layout
        item {
          posts
          tags
        }
        items {
          posts
          tags
        }
        position {
          x
          y
          width
          height
        }
      }
      name
      organization
      resting {
        items {
          alphaOn
          canInterrupt
          imageSettings {
            showTime
          }
          media
          playAudio
          post
        }
        staleStateTimeout
      }
      screen {
        columns
        count
        orientation
        resolution
        rows
        size {
          width
          height
        }
      }
      type
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  > &
    (
      | { variables: GetProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export function useGetProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProfileQuery,
        GetProfileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>;
export type GetProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetProfileSuspenseQuery
>;
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const GetProfileGridDocument = gql`
  query GetProfileGrid(
    $filter: ProfileFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allProfiles(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      id
      name
      organization
      type
      updatedAt
      __typename
    }
    total: _allProfilesMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetProfileGridQuery__
 *
 * To run a query within a React component, call `useGetProfileGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProfileGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProfileGridQuery,
    GetProfileGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileGridQuery, GetProfileGridQueryVariables>(
    GetProfileGridDocument,
    options,
  );
}
export function useGetProfileGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileGridQuery,
    GetProfileGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileGridQuery, GetProfileGridQueryVariables>(
    GetProfileGridDocument,
    options,
  );
}
export function useGetProfileGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProfileGridQuery,
        GetProfileGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProfileGridQuery,
    GetProfileGridQueryVariables
  >(GetProfileGridDocument, options);
}
export type GetProfileGridQueryHookResult = ReturnType<
  typeof useGetProfileGridQuery
>;
export type GetProfileGridLazyQueryHookResult = ReturnType<
  typeof useGetProfileGridLazyQuery
>;
export type GetProfileGridSuspenseQueryHookResult = ReturnType<
  typeof useGetProfileGridSuspenseQuery
>;
export type GetProfileGridQueryResult = Apollo.QueryResult<
  GetProfileGridQuery,
  GetProfileGridQueryVariables
>;
export const GetProfileListNameIdDocument = gql`
  query GetProfileListNameId(
    $filter: ProfileFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allProfiles(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetProfileListNameIdQuery__
 *
 * To run a query within a React component, call `useGetProfileListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetProfileListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProfileListNameIdQuery,
    GetProfileListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProfileListNameIdQuery,
    GetProfileListNameIdQueryVariables
  >(GetProfileListNameIdDocument, options);
}
export function useGetProfileListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileListNameIdQuery,
    GetProfileListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProfileListNameIdQuery,
    GetProfileListNameIdQueryVariables
  >(GetProfileListNameIdDocument, options);
}
export function useGetProfileListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetProfileListNameIdQuery,
        GetProfileListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProfileListNameIdQuery,
    GetProfileListNameIdQueryVariables
  >(GetProfileListNameIdDocument, options);
}
export type GetProfileListNameIdQueryHookResult = ReturnType<
  typeof useGetProfileListNameIdQuery
>;
export type GetProfileListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetProfileListNameIdLazyQuery
>;
export type GetProfileListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetProfileListNameIdSuspenseQuery
>;
export type GetProfileListNameIdQueryResult = Apollo.QueryResult<
  GetProfileListNameIdQuery,
  GetProfileListNameIdQueryVariables
>;
export const CreateProfileDocument = gql`
  mutation CreateProfile(
    $background: ProfileBackgroundInput
    $layouts: [ProfileLayoutInput!]
    $name: String!
    $resting: ProfileRestingInput
    $screen: ProfileScreenModelInput
    $type: ScreenType!
  ) {
    data: createProfile(
      background: $background
      layouts: $layouts
      name: $name
      resting: $resting
      screen: $screen
      type: $type
    ) {
      _id
      _version
      background {
        backgroundMedia
        backgroundMediaMode
      }
      createdAt
      deleted
      id
      layouts {
        detailed
        flyout {
          position {
            x
            y
            width
            height
          }
        }
        layout
        item {
          posts
          tags
        }
        items {
          posts
          tags
        }
        position {
          x
          y
          width
          height
        }
      }
      name
      organization
      resting {
        items {
          alphaOn
          canInterrupt
          imageSettings {
            showTime
          }
          media
          playAudio
          post
        }
        staleStateTimeout
      }
      screen {
        columns
        count
        orientation
        resolution
        rows
        size {
          width
          height
        }
      }
      type
      updatedAt
      __typename
    }
  }
`;
export type CreateProfileMutationFn = Apollo.MutationFunction<
  CreateProfileMutation,
  CreateProfileMutationVariables
>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      background: // value for 'background'
 *      layouts: // value for 'layouts'
 *      name: // value for 'name'
 *      resting: // value for 'resting'
 *      screen: // value for 'screen'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProfileMutation,
    CreateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProfileMutation,
    CreateProfileMutationVariables
  >(CreateProfileDocument, options);
}
export type CreateProfileMutationHookResult = ReturnType<
  typeof useCreateProfileMutation
>;
export type CreateProfileMutationResult =
  Apollo.MutationResult<CreateProfileMutation>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateProfileMutation,
  CreateProfileMutationVariables
>;
export const DeleteProfileDocument = gql`
  mutation DeleteProfile($id: String!) {
    data: deleteProfile(id: $id)
  }
`;
export type DeleteProfileMutationFn = Apollo.MutationFunction<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
>;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMutation, { data, loading, error }] = useDeleteProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProfileMutation,
    DeleteProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProfileMutation,
    DeleteProfileMutationVariables
  >(DeleteProfileDocument, options);
}
export type DeleteProfileMutationHookResult = ReturnType<
  typeof useDeleteProfileMutation
>;
export type DeleteProfileMutationResult =
  Apollo.MutationResult<DeleteProfileMutation>;
export type DeleteProfileMutationOptions = Apollo.BaseMutationOptions<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
>;
export const UpdateProfileDocument = gql`
  mutation UpdateProfile(
    $id: String!
    $background: ProfileBackgroundInput
    $layouts: [ProfileLayoutInput!]
    $name: String!
    $resting: ProfileRestingInput
    $screen: ProfileScreenModelInput
    $type: ScreenType!
  ) {
    data: updateProfile(
      id: $id
      background: $background
      layouts: $layouts
      name: $name
      resting: $resting
      screen: $screen
      type: $type
    ) {
      _id
      _version
      background {
        backgroundMedia
        backgroundMediaMode
      }
      createdAt
      deleted
      id
      layouts {
        detailed
        flyout {
          position {
            x
            y
            width
            height
          }
        }
        layout
        item {
          posts
          tags
        }
        items {
          posts
          tags
        }
        position {
          x
          y
          width
          height
        }
      }
      name
      organization
      resting {
        items {
          alphaOn
          canInterrupt
          imageSettings {
            showTime
          }
          media
          playAudio
          post
        }
        staleStateTimeout
      }
      screen {
        columns
        count
        orientation
        resolution
        rows
        size {
          width
          height
        }
      }
      type
      updatedAt
      __typename
    }
  }
`;
export type UpdateProfileMutationFn = Apollo.MutationFunction<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      background: // value for 'background'
 *      layouts: // value for 'layouts'
 *      name: // value for 'name'
 *      resting: // value for 'resting'
 *      screen: // value for 'screen'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProfileMutation,
    UpdateProfileMutationVariables
  >(UpdateProfileDocument, options);
}
export type UpdateProfileMutationHookResult = ReturnType<
  typeof useUpdateProfileMutation
>;
export type UpdateProfileMutationResult =
  Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
>;
export const GetScheduledEventDocument = gql`
  query GetScheduledEvent($id: String!) {
    item: ScheduledEvent(id: $id) {
      _id
      _version
      createdAt
      deleted
      end
      endAction {
        ...ActionPayloadProps
      }
      endProcessed
      groupId
      id
      name
      notes
      organization
      recurring {
        bymonth
        byweekday
        count
        dtstart
        freq
        interval
        tzid
        until
      }
      start
      startAction {
        ...ActionPayloadProps
      }
      startProcessed
      timezone
      updatedAt
      __typename
    }
  }
  ${ActionPayloadPropsFragmentDoc}
`;

/**
 * __useGetScheduledEventQuery__
 *
 * To run a query within a React component, call `useGetScheduledEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduledEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduledEventQuery,
    GetScheduledEventQueryVariables
  > &
    (
      | { variables: GetScheduledEventQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduledEventQuery,
    GetScheduledEventQueryVariables
  >(GetScheduledEventDocument, options);
}
export function useGetScheduledEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduledEventQuery,
    GetScheduledEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduledEventQuery,
    GetScheduledEventQueryVariables
  >(GetScheduledEventDocument, options);
}
export function useGetScheduledEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScheduledEventQuery,
        GetScheduledEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduledEventQuery,
    GetScheduledEventQueryVariables
  >(GetScheduledEventDocument, options);
}
export type GetScheduledEventQueryHookResult = ReturnType<
  typeof useGetScheduledEventQuery
>;
export type GetScheduledEventLazyQueryHookResult = ReturnType<
  typeof useGetScheduledEventLazyQuery
>;
export type GetScheduledEventSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduledEventSuspenseQuery
>;
export type GetScheduledEventQueryResult = Apollo.QueryResult<
  GetScheduledEventQuery,
  GetScheduledEventQueryVariables
>;
export const GetScheduledEventsDocument = gql`
  query GetScheduledEvents(
    $filter: ScheduledEventFilter
    $groupId: String
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allScheduledEvents(
      filter: $filter
      groupId: $groupId
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      end
      endAction {
        ...ActionPayloadProps
      }
      endProcessed
      groupId
      id
      name
      notes
      organization
      recurring {
        bymonth
        byweekday
        count
        dtstart
        freq
        interval
        tzid
        until
      }
      start
      startAction {
        ...ActionPayloadProps
      }
      startProcessed
      timezone
      updatedAt
      __typename
    }
    total: _allScheduledEventsMeta(
      filter: $filter
      groupId: $groupId
      page: $page
      perPage: $perPage
    ) {
      count
      __typename
    }
  }
  ${ActionPayloadPropsFragmentDoc}
`;

/**
 * __useGetScheduledEventsQuery__
 *
 * To run a query within a React component, call `useGetScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      groupId: // value for 'groupId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetScheduledEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetScheduledEventsQuery,
    GetScheduledEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduledEventsQuery,
    GetScheduledEventsQueryVariables
  >(GetScheduledEventsDocument, options);
}
export function useGetScheduledEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduledEventsQuery,
    GetScheduledEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduledEventsQuery,
    GetScheduledEventsQueryVariables
  >(GetScheduledEventsDocument, options);
}
export function useGetScheduledEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScheduledEventsQuery,
        GetScheduledEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduledEventsQuery,
    GetScheduledEventsQueryVariables
  >(GetScheduledEventsDocument, options);
}
export type GetScheduledEventsQueryHookResult = ReturnType<
  typeof useGetScheduledEventsQuery
>;
export type GetScheduledEventsLazyQueryHookResult = ReturnType<
  typeof useGetScheduledEventsLazyQuery
>;
export type GetScheduledEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduledEventsSuspenseQuery
>;
export type GetScheduledEventsQueryResult = Apollo.QueryResult<
  GetScheduledEventsQuery,
  GetScheduledEventsQueryVariables
>;
export const CreateScheduledEventDocument = gql`
  mutation CreateScheduledEvent(
    $name: String!
    $groupId: String
    $start: DateTime!
    $startActionOneOf: [ActionPayloadInputCombo!]
    $end: DateTime
    $endActionOneOf: [ActionPayloadInputCombo!]
    $timezone: String
    $recurring: CreateScheduledEventRecurringSettingsInput
    $startProcessed: Boolean
    $endProcessed: Boolean
  ) {
    data: createScheduledEvent(
      name: $name
      groupId: $groupId
      start: $start
      startActionOneOf: $startActionOneOf
      end: $end
      endActionOneOf: $endActionOneOf
      startProcessed: $startProcessed
      endProcessed: $endProcessed
      timezone: $timezone
      recurring: $recurring
    ) {
      _id
      _version
      createdAt
      deleted
      end
      endAction {
        ...ActionPayloadProps
      }
      endProcessed
      groupId
      id
      name
      notes
      organization
      recurring {
        bymonth
        byweekday
        count
        dtstart
        freq
        interval
        tzid
        until
      }
      start
      startAction {
        ...ActionPayloadProps
      }
      startProcessed
      timezone
      updatedAt
      __typename
    }
  }
  ${ActionPayloadPropsFragmentDoc}
`;
export type CreateScheduledEventMutationFn = Apollo.MutationFunction<
  CreateScheduledEventMutation,
  CreateScheduledEventMutationVariables
>;

/**
 * __useCreateScheduledEventMutation__
 *
 * To run a mutation, you first call `useCreateScheduledEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledEventMutation, { data, loading, error }] = useCreateScheduledEventMutation({
 *   variables: {
 *      name: // value for 'name'
 *      groupId: // value for 'groupId'
 *      start: // value for 'start'
 *      startActionOneOf: // value for 'startActionOneOf'
 *      end: // value for 'end'
 *      endActionOneOf: // value for 'endActionOneOf'
 *      timezone: // value for 'timezone'
 *      recurring: // value for 'recurring'
 *      startProcessed: // value for 'startProcessed'
 *      endProcessed: // value for 'endProcessed'
 *   },
 * });
 */
export function useCreateScheduledEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScheduledEventMutation,
    CreateScheduledEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScheduledEventMutation,
    CreateScheduledEventMutationVariables
  >(CreateScheduledEventDocument, options);
}
export type CreateScheduledEventMutationHookResult = ReturnType<
  typeof useCreateScheduledEventMutation
>;
export type CreateScheduledEventMutationResult =
  Apollo.MutationResult<CreateScheduledEventMutation>;
export type CreateScheduledEventMutationOptions = Apollo.BaseMutationOptions<
  CreateScheduledEventMutation,
  CreateScheduledEventMutationVariables
>;
export const DeleteScheduledEventDocument = gql`
  mutation DeleteScheduledEvent($id: String!) {
    data: deleteScheduledEvent(id: $id)
  }
`;
export type DeleteScheduledEventMutationFn = Apollo.MutationFunction<
  DeleteScheduledEventMutation,
  DeleteScheduledEventMutationVariables
>;

/**
 * __useDeleteScheduledEventMutation__
 *
 * To run a mutation, you first call `useDeleteScheduledEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduledEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduledEventMutation, { data, loading, error }] = useDeleteScheduledEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduledEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteScheduledEventMutation,
    DeleteScheduledEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteScheduledEventMutation,
    DeleteScheduledEventMutationVariables
  >(DeleteScheduledEventDocument, options);
}
export type DeleteScheduledEventMutationHookResult = ReturnType<
  typeof useDeleteScheduledEventMutation
>;
export type DeleteScheduledEventMutationResult =
  Apollo.MutationResult<DeleteScheduledEventMutation>;
export type DeleteScheduledEventMutationOptions = Apollo.BaseMutationOptions<
  DeleteScheduledEventMutation,
  DeleteScheduledEventMutationVariables
>;
export const UpdateScheduledEventDocument = gql`
  mutation UpdateScheduledEvent(
    $id: String!
    $name: String!
    $groupId: String
    $start: DateTime!
    $startActionOneOf: [ActionPayloadInputCombo!]
    $end: DateTime
    $endActionOneOf: [ActionPayloadInputCombo!]
    $timezone: String
    $modifyType: ScheduledEventModificationType
    $startProcessed: Boolean
    $endProcessed: Boolean
  ) {
    data: updateScheduledEvent(
      id: $id
      name: $name
      groupId: $groupId
      start: $start
      startActionOneOf: $startActionOneOf
      end: $end
      endActionOneOf: $endActionOneOf
      startProcessed: $startProcessed
      endProcessed: $endProcessed
      timezone: $timezone
      modifyType: $modifyType
    ) {
      _id
      _version
      createdAt
      deleted
      end
      endAction {
        ...ActionPayloadProps
      }
      endProcessed
      groupId
      id
      name
      notes
      organization
      recurring {
        bymonth
        byweekday
        count
        dtstart
        freq
        interval
        tzid
        until
      }
      start
      startAction {
        ...ActionPayloadProps
      }
      startProcessed
      timezone
      updatedAt
      __typename
    }
  }
  ${ActionPayloadPropsFragmentDoc}
`;
export type UpdateScheduledEventMutationFn = Apollo.MutationFunction<
  UpdateScheduledEventMutation,
  UpdateScheduledEventMutationVariables
>;

/**
 * __useUpdateScheduledEventMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledEventMutation, { data, loading, error }] = useUpdateScheduledEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      groupId: // value for 'groupId'
 *      start: // value for 'start'
 *      startActionOneOf: // value for 'startActionOneOf'
 *      end: // value for 'end'
 *      endActionOneOf: // value for 'endActionOneOf'
 *      timezone: // value for 'timezone'
 *      modifyType: // value for 'modifyType'
 *      startProcessed: // value for 'startProcessed'
 *      endProcessed: // value for 'endProcessed'
 *   },
 * });
 */
export function useUpdateScheduledEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScheduledEventMutation,
    UpdateScheduledEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateScheduledEventMutation,
    UpdateScheduledEventMutationVariables
  >(UpdateScheduledEventDocument, options);
}
export type UpdateScheduledEventMutationHookResult = ReturnType<
  typeof useUpdateScheduledEventMutation
>;
export type UpdateScheduledEventMutationResult =
  Apollo.MutationResult<UpdateScheduledEventMutation>;
export type UpdateScheduledEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateScheduledEventMutation,
  UpdateScheduledEventMutationVariables
>;
export const GetServiceDocument = gql`
  query GetService($id: String!) {
    item: Service(id: $id) {
      _id
      _version
      createdAt
      customData
      deleted
      id
      machineName
      name
      options {
        ...ServiceOptionProps
      }
      type
      updatedAt
      __typename
    }
  }
  ${ServiceOptionPropsFragmentDoc}
`;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServiceQuery,
    GetServiceQueryVariables
  > &
    (
      | { variables: GetServiceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(
    GetServiceDocument,
    options,
  );
}
export function useGetServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceQuery,
    GetServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(
    GetServiceDocument,
    options,
  );
}
export function useGetServiceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceQuery,
        GetServiceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetServiceQuery, GetServiceQueryVariables>(
    GetServiceDocument,
    options,
  );
}
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<
  typeof useGetServiceLazyQuery
>;
export type GetServiceSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceSuspenseQuery
>;
export type GetServiceQueryResult = Apollo.QueryResult<
  GetServiceQuery,
  GetServiceQueryVariables
>;
export const GetServiceGridDocument = gql`
  query GetServiceGrid(
    $filter: ServiceQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allServices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      id
      machineName
      name
      type
      updatedAt
      __typename
    }
    total: _allServicesMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetServiceGridQuery__
 *
 * To run a query within a React component, call `useGetServiceGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetServiceGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceGridQuery,
    GetServiceGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServiceGridQuery, GetServiceGridQueryVariables>(
    GetServiceGridDocument,
    options,
  );
}
export function useGetServiceGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceGridQuery,
    GetServiceGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServiceGridQuery, GetServiceGridQueryVariables>(
    GetServiceGridDocument,
    options,
  );
}
export function useGetServiceGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceGridQuery,
        GetServiceGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServiceGridQuery,
    GetServiceGridQueryVariables
  >(GetServiceGridDocument, options);
}
export type GetServiceGridQueryHookResult = ReturnType<
  typeof useGetServiceGridQuery
>;
export type GetServiceGridLazyQueryHookResult = ReturnType<
  typeof useGetServiceGridLazyQuery
>;
export type GetServiceGridSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceGridSuspenseQuery
>;
export type GetServiceGridQueryResult = Apollo.QueryResult<
  GetServiceGridQuery,
  GetServiceGridQueryVariables
>;
export const GetServiceListFullDocument = gql`
  query GetServiceListFull(
    $filter: ServiceQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allServices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      customData
      deleted
      id
      machineName
      name
      options {
        ...ServiceOptionProps
      }
      type
      updatedAt
      __typename
    }
  }
  ${ServiceOptionPropsFragmentDoc}
`;

/**
 * __useGetServiceListFullQuery__
 *
 * To run a query within a React component, call `useGetServiceListFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceListFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceListFullQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetServiceListFullQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceListFullQuery,
    GetServiceListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceListFullQuery,
    GetServiceListFullQueryVariables
  >(GetServiceListFullDocument, options);
}
export function useGetServiceListFullLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceListFullQuery,
    GetServiceListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceListFullQuery,
    GetServiceListFullQueryVariables
  >(GetServiceListFullDocument, options);
}
export function useGetServiceListFullSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceListFullQuery,
        GetServiceListFullQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServiceListFullQuery,
    GetServiceListFullQueryVariables
  >(GetServiceListFullDocument, options);
}
export type GetServiceListFullQueryHookResult = ReturnType<
  typeof useGetServiceListFullQuery
>;
export type GetServiceListFullLazyQueryHookResult = ReturnType<
  typeof useGetServiceListFullLazyQuery
>;
export type GetServiceListFullSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceListFullSuspenseQuery
>;
export type GetServiceListFullQueryResult = Apollo.QueryResult<
  GetServiceListFullQuery,
  GetServiceListFullQueryVariables
>;
export const GetServiceListNameIdDocument = gql`
  query GetServiceListNameId(
    $filter: ServiceQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allServices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetServiceListNameIdQuery__
 *
 * To run a query within a React component, call `useGetServiceListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetServiceListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceListNameIdQuery,
    GetServiceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceListNameIdQuery,
    GetServiceListNameIdQueryVariables
  >(GetServiceListNameIdDocument, options);
}
export function useGetServiceListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceListNameIdQuery,
    GetServiceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceListNameIdQuery,
    GetServiceListNameIdQueryVariables
  >(GetServiceListNameIdDocument, options);
}
export function useGetServiceListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServiceListNameIdQuery,
        GetServiceListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServiceListNameIdQuery,
    GetServiceListNameIdQueryVariables
  >(GetServiceListNameIdDocument, options);
}
export type GetServiceListNameIdQueryHookResult = ReturnType<
  typeof useGetServiceListNameIdQuery
>;
export type GetServiceListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetServiceListNameIdLazyQuery
>;
export type GetServiceListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetServiceListNameIdSuspenseQuery
>;
export type GetServiceListNameIdQueryResult = Apollo.QueryResult<
  GetServiceListNameIdQuery,
  GetServiceListNameIdQueryVariables
>;
export const GetManagementServiceListNameIdDocument = gql`
  query GetManagementServiceListNameId(
    $filter: ServiceQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allManagementServices(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      name
    }
  }
`;

/**
 * __useGetManagementServiceListNameIdQuery__
 *
 * To run a query within a React component, call `useGetManagementServiceListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementServiceListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementServiceListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetManagementServiceListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetManagementServiceListNameIdQuery,
    GetManagementServiceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManagementServiceListNameIdQuery,
    GetManagementServiceListNameIdQueryVariables
  >(GetManagementServiceListNameIdDocument, options);
}
export function useGetManagementServiceListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManagementServiceListNameIdQuery,
    GetManagementServiceListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManagementServiceListNameIdQuery,
    GetManagementServiceListNameIdQueryVariables
  >(GetManagementServiceListNameIdDocument, options);
}
export function useGetManagementServiceListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetManagementServiceListNameIdQuery,
        GetManagementServiceListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetManagementServiceListNameIdQuery,
    GetManagementServiceListNameIdQueryVariables
  >(GetManagementServiceListNameIdDocument, options);
}
export type GetManagementServiceListNameIdQueryHookResult = ReturnType<
  typeof useGetManagementServiceListNameIdQuery
>;
export type GetManagementServiceListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetManagementServiceListNameIdLazyQuery
>;
export type GetManagementServiceListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetManagementServiceListNameIdSuspenseQuery
>;
export type GetManagementServiceListNameIdQueryResult = Apollo.QueryResult<
  GetManagementServiceListNameIdQuery,
  GetManagementServiceListNameIdQueryVariables
>;
export const GetTagDocument = gql`
  query GetTag($id: String!) {
    item: Tag(id: $id) {
      _id
      _version
      createdAt
      deleted
      icon
      iconType
      id
      mediaIcon
      organization
      title
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetTagQuery__
 *
 * To run a query within a React component, call `useGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTagQuery(
  baseOptions: Apollo.QueryHookOptions<GetTagQuery, GetTagQueryVariables> &
    ({ variables: GetTagQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagQuery, GetTagQueryVariables>(
    GetTagDocument,
    options,
  );
}
export function useGetTagLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTagQuery, GetTagQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagQuery, GetTagQueryVariables>(
    GetTagDocument,
    options,
  );
}
export function useGetTagSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTagQuery, GetTagQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTagQuery, GetTagQueryVariables>(
    GetTagDocument,
    options,
  );
}
export type GetTagQueryHookResult = ReturnType<typeof useGetTagQuery>;
export type GetTagLazyQueryHookResult = ReturnType<typeof useGetTagLazyQuery>;
export type GetTagSuspenseQueryHookResult = ReturnType<
  typeof useGetTagSuspenseQuery
>;
export type GetTagQueryResult = Apollo.QueryResult<
  GetTagQuery,
  GetTagQueryVariables
>;
export const GetTagGridDocument = gql`
  query GetTagGrid(
    $filter: TagQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allTags(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      icon
      id
      organization
      title
      updatedAt
      __typename
    }
    total: _allTagsMeta(filter: $filter, page: $page, perPage: $perPage) {
      count
      __typename
    }
  }
`;

/**
 * __useGetTagGridQuery__
 *
 * To run a query within a React component, call `useGetTagGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagGridQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetTagGridQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTagGridQuery,
    GetTagGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagGridQuery, GetTagGridQueryVariables>(
    GetTagGridDocument,
    options,
  );
}
export function useGetTagGridLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagGridQuery,
    GetTagGridQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagGridQuery, GetTagGridQueryVariables>(
    GetTagGridDocument,
    options,
  );
}
export function useGetTagGridSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTagGridQuery,
        GetTagGridQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTagGridQuery, GetTagGridQueryVariables>(
    GetTagGridDocument,
    options,
  );
}
export type GetTagGridQueryHookResult = ReturnType<typeof useGetTagGridQuery>;
export type GetTagGridLazyQueryHookResult = ReturnType<
  typeof useGetTagGridLazyQuery
>;
export type GetTagGridSuspenseQueryHookResult = ReturnType<
  typeof useGetTagGridSuspenseQuery
>;
export type GetTagGridQueryResult = Apollo.QueryResult<
  GetTagGridQuery,
  GetTagGridQueryVariables
>;
export const GetTagListFullDocument = gql`
  query GetTagListFull(
    $filter: TagQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allTags(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      _id
      _version
      createdAt
      deleted
      icon
      iconType
      id
      mediaIcon
      organization
      title
      updatedAt
      __typename
    }
  }
`;

/**
 * __useGetTagListFullQuery__
 *
 * To run a query within a React component, call `useGetTagListFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagListFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagListFullQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetTagListFullQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTagListFullQuery,
    GetTagListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagListFullQuery, GetTagListFullQueryVariables>(
    GetTagListFullDocument,
    options,
  );
}
export function useGetTagListFullLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagListFullQuery,
    GetTagListFullQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagListFullQuery, GetTagListFullQueryVariables>(
    GetTagListFullDocument,
    options,
  );
}
export function useGetTagListFullSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTagListFullQuery,
        GetTagListFullQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTagListFullQuery,
    GetTagListFullQueryVariables
  >(GetTagListFullDocument, options);
}
export type GetTagListFullQueryHookResult = ReturnType<
  typeof useGetTagListFullQuery
>;
export type GetTagListFullLazyQueryHookResult = ReturnType<
  typeof useGetTagListFullLazyQuery
>;
export type GetTagListFullSuspenseQueryHookResult = ReturnType<
  typeof useGetTagListFullSuspenseQuery
>;
export type GetTagListFullQueryResult = Apollo.QueryResult<
  GetTagListFullQuery,
  GetTagListFullQueryVariables
>;
export const GetTagListNameIdDocument = gql`
  query GetTagListNameId(
    $filter: TagQueryFilter
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
  ) {
    items: allTags(
      filter: $filter
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      id
      title
    }
  }
`;

/**
 * __useGetTagListNameIdQuery__
 *
 * To run a query within a React component, call `useGetTagListNameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagListNameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagListNameIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetTagListNameIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTagListNameIdQuery,
    GetTagListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagListNameIdQuery, GetTagListNameIdQueryVariables>(
    GetTagListNameIdDocument,
    options,
  );
}
export function useGetTagListNameIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagListNameIdQuery,
    GetTagListNameIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTagListNameIdQuery,
    GetTagListNameIdQueryVariables
  >(GetTagListNameIdDocument, options);
}
export function useGetTagListNameIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTagListNameIdQuery,
        GetTagListNameIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTagListNameIdQuery,
    GetTagListNameIdQueryVariables
  >(GetTagListNameIdDocument, options);
}
export type GetTagListNameIdQueryHookResult = ReturnType<
  typeof useGetTagListNameIdQuery
>;
export type GetTagListNameIdLazyQueryHookResult = ReturnType<
  typeof useGetTagListNameIdLazyQuery
>;
export type GetTagListNameIdSuspenseQueryHookResult = ReturnType<
  typeof useGetTagListNameIdSuspenseQuery
>;
export type GetTagListNameIdQueryResult = Apollo.QueryResult<
  GetTagListNameIdQuery,
  GetTagListNameIdQueryVariables
>;
export const CreateTagDocument = gql`
  mutation CreateTag(
    $title: String!
    $iconType: IconType!
    $icon: String
    $mediaIcon: ID
  ) {
    data: createTag(
      title: $title
      iconType: $iconType
      icon: $icon
      mediaIcon: $mediaIcon
    ) {
      _id
      _version
      createdAt
      deleted
      icon
      iconType
      id
      mediaIcon
      organization
      title
      updatedAt
      __typename
    }
  }
`;
export type CreateTagMutationFn = Apollo.MutationFunction<
  CreateTagMutation,
  CreateTagMutationVariables
>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      title: // value for 'title'
 *      iconType: // value for 'iconType'
 *      icon: // value for 'icon'
 *      mediaIcon: // value for 'mediaIcon'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagMutation,
    CreateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(
    CreateTagDocument,
    options,
  );
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<
  CreateTagMutation,
  CreateTagMutationVariables
>;
export const DeleteTagDocument = gql`
  mutation DeleteTag($id: ID!) {
    data: deleteTag(id: $id)
  }
`;
export type DeleteTagMutationFn = Apollo.MutationFunction<
  DeleteTagMutation,
  DeleteTagMutationVariables
>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTagMutation,
    DeleteTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(
    DeleteTagDocument,
    options,
  );
}
export type DeleteTagMutationHookResult = ReturnType<
  typeof useDeleteTagMutation
>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<
  DeleteTagMutation,
  DeleteTagMutationVariables
>;
export const UpdateTagDocument = gql`
  mutation UpdateTag(
    $id: String!
    $title: String!
    $iconType: IconType!
    $icon: String
    $mediaIcon: ID
  ) {
    data: updateTag(
      id: $id
      title: $title
      iconType: $iconType
      icon: $icon
      mediaIcon: $mediaIcon
    ) {
      _id
      _version
      createdAt
      deleted
      icon
      iconType
      id
      mediaIcon
      organization
      title
      updatedAt
      __typename
    }
  }
`;
export type UpdateTagMutationFn = Apollo.MutationFunction<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      iconType: // value for 'iconType'
 *      icon: // value for 'icon'
 *      mediaIcon: // value for 'mediaIcon'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagMutation,
    UpdateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(
    UpdateTagDocument,
    options,
  );
}
export type UpdateTagMutationHookResult = ReturnType<
  typeof useUpdateTagMutation
>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;
export const ValidateGqlModelDocument = gql`
  mutation ValidateGqlModel($action: String!, $data: JSONObject!) {
    data: validateGqlModel(action: $action, data: $data) {
      errors
    }
  }
`;
export type ValidateGqlModelMutationFn = Apollo.MutationFunction<
  ValidateGqlModelMutation,
  ValidateGqlModelMutationVariables
>;

/**
 * __useValidateGqlModelMutation__
 *
 * To run a mutation, you first call `useValidateGqlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGqlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGqlModelMutation, { data, loading, error }] = useValidateGqlModelMutation({
 *   variables: {
 *      action: // value for 'action'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useValidateGqlModelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateGqlModelMutation,
    ValidateGqlModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateGqlModelMutation,
    ValidateGqlModelMutationVariables
  >(ValidateGqlModelDocument, options);
}
export type ValidateGqlModelMutationHookResult = ReturnType<
  typeof useValidateGqlModelMutation
>;
export type ValidateGqlModelMutationResult =
  Apollo.MutationResult<ValidateGqlModelMutation>;
export type ValidateGqlModelMutationOptions = Apollo.BaseMutationOptions<
  ValidateGqlModelMutation,
  ValidateGqlModelMutationVariables
>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {},
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  ActionPayload: ActionPayloadLocationProfileChanged | ActionPayloadPostEnabled;
  AnimationOption:
    | AnimationOptionFade
    | AnimationOptionFlip
    | AnimationOptionWipe;
  ConditionValueType:
    | ConditionValueTypeBoolean
    | ConditionValueTypeNumber
    | ConditionValueTypeString;
  ExtraFieldType:
    | (Omit<ExtraFieldTypeArray, "extraFields"> & {
        extraFields: Array<_RefType["ExtraFieldType"]>;
      })
    | ExtraFieldTypeBoolean
    | (Omit<ExtraFieldTypeBox, "condition" | "extraFields"> & {
        condition?: Maybe<_RefType["ExtraFieldCondition"]>;
        extraFields: Array<_RefType["ExtraFieldType"]>;
      })
    | ExtraFieldTypeColor
    | ExtraFieldTypeHelp
    | ExtraFieldTypeMedia
    | (Omit<ExtraFieldTypeNumber, "condition"> & {
        condition?: Maybe<_RefType["ExtraFieldCondition"]>;
      })
    | ExtraFieldTypeReference
    | ExtraFieldTypeRichText
    | ExtraFieldTypeSearch
    | (Omit<ExtraFieldTypeSelect, "condition"> & {
        condition?: Maybe<_RefType["ExtraFieldCondition"]>;
      })
    | (Omit<ExtraFieldTypeText, "condition"> & {
        condition?: Maybe<_RefType["ExtraFieldCondition"]>;
      })
    | (Omit<ExtraFieldTypeTextLabel, "condition"> & {
        condition?: Maybe<_RefType["ExtraFieldCondition"]>;
      });
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActionPayload: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ActionPayload"]
  >;
  ActionPayloadInput: ActionPayloadInput;
  ActionPayloadInputCombo: ActionPayloadInputCombo;
  ActionPayloadLocationProfileChanged: ResolverTypeWrapper<ActionPayloadLocationProfileChanged>;
  ActionPayloadLocationProfileChangedInput: ActionPayloadLocationProfileChangedInput;
  ActionPayloadPostEnabled: ResolverTypeWrapper<ActionPayloadPostEnabled>;
  ActionPayloadPostEnabledInput: ActionPayloadPostEnabledInput;
  ActionPayloadType: ActionPayloadType;
  Animation: ResolverTypeWrapper<
    Omit<Animation, "option"> & { option: ResolversTypes["AnimationOption"] }
  >;
  AnimationInput: AnimationInput;
  AnimationOption: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["AnimationOption"]
  >;
  AnimationOptionFade: ResolverTypeWrapper<AnimationOptionFade>;
  AnimationOptionFlip: ResolverTypeWrapper<AnimationOptionFlip>;
  AnimationOptionWipe: ResolverTypeWrapper<AnimationOptionWipe>;
  AnimationWipeFunction: AnimationWipeFunction;
  BackgroundMediaMode: BackgroundMediaMode;
  Boolean: ResolverTypeWrapper<Scalars["Boolean"]["output"]>;
  ConditionValueType: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ConditionValueType"]
  >;
  ConditionValueTypeBoolean: ResolverTypeWrapper<ConditionValueTypeBoolean>;
  ConditionValueTypeNumber: ResolverTypeWrapper<ConditionValueTypeNumber>;
  ConditionValueTypeString: ResolverTypeWrapper<ConditionValueTypeString>;
  ContentUpdateOptions: ResolverTypeWrapper<ContentUpdateOptions>;
  ContentUpdateOptionsInput: ContentUpdateOptionsInput;
  CreateScheduledEventRecurringSettingsInput: CreateScheduledEventRecurringSettingsInput;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerAnalyticsConfigInput: CustomerAnalyticsConfigInput;
  CustomerAuth0Config: ResolverTypeWrapper<CustomerAuth0Config>;
  CustomerAuth0Settings: CustomerAuth0Settings;
  CustomerFilter: CustomerFilter;
  DateTime: ResolverTypeWrapper<Scalars["DateTime"]["output"]>;
  Device: ResolverTypeWrapper<Device>;
  DeviceActivationConfig: ResolverTypeWrapper<DeviceActivationConfig>;
  DeviceActivationConfigInput: DeviceActivationConfigInput;
  DeviceFilter: DeviceFilter;
  DeviceMenuLocation: DeviceMenuLocation;
  DeviceStatus: DeviceStatus;
  ExtraFieldCondition: ResolverTypeWrapper<
    Omit<ExtraFieldCondition, "value"> & {
      value: ResolversTypes["ConditionValueType"];
    }
  >;
  ExtraFieldMetadata: ResolverTypeWrapper<ExtraFieldMetadata>;
  ExtraFieldMetadataProperties: ResolverTypeWrapper<ExtraFieldMetadataProperties>;
  ExtraFieldType: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>["ExtraFieldType"]
  >;
  ExtraFieldTypeArray: ResolverTypeWrapper<
    Omit<ExtraFieldTypeArray, "extraFields"> & {
      extraFields: Array<ResolversTypes["ExtraFieldType"]>;
    }
  >;
  ExtraFieldTypeBoolean: ResolverTypeWrapper<ExtraFieldTypeBoolean>;
  ExtraFieldTypeBox: ResolverTypeWrapper<
    Omit<ExtraFieldTypeBox, "condition" | "extraFields"> & {
      condition?: Maybe<ResolversTypes["ExtraFieldCondition"]>;
      extraFields: Array<ResolversTypes["ExtraFieldType"]>;
    }
  >;
  ExtraFieldTypeColor: ResolverTypeWrapper<ExtraFieldTypeColor>;
  ExtraFieldTypeHelp: ResolverTypeWrapper<ExtraFieldTypeHelp>;
  ExtraFieldTypeMedia: ResolverTypeWrapper<ExtraFieldTypeMedia>;
  ExtraFieldTypeNumber: ResolverTypeWrapper<
    Omit<ExtraFieldTypeNumber, "condition"> & {
      condition?: Maybe<ResolversTypes["ExtraFieldCondition"]>;
    }
  >;
  ExtraFieldTypeReference: ResolverTypeWrapper<ExtraFieldTypeReference>;
  ExtraFieldTypeReferenceFilter: ResolverTypeWrapper<ExtraFieldTypeReferenceFilter>;
  ExtraFieldTypeReferenceSelectOptions: ResolverTypeWrapper<ExtraFieldTypeReferenceSelectOptions>;
  ExtraFieldTypeRichText: ResolverTypeWrapper<ExtraFieldTypeRichText>;
  ExtraFieldTypeSearch: ResolverTypeWrapper<ExtraFieldTypeSearch>;
  ExtraFieldTypeSelect: ResolverTypeWrapper<
    Omit<ExtraFieldTypeSelect, "condition"> & {
      condition?: Maybe<ResolversTypes["ExtraFieldCondition"]>;
    }
  >;
  ExtraFieldTypeSelectChoice: ResolverTypeWrapper<ExtraFieldTypeSelectChoice>;
  ExtraFieldTypeText: ResolverTypeWrapper<
    Omit<ExtraFieldTypeText, "condition"> & {
      condition?: Maybe<ResolversTypes["ExtraFieldCondition"]>;
    }
  >;
  ExtraFieldTypeTextLabel: ResolverTypeWrapper<
    Omit<ExtraFieldTypeTextLabel, "condition"> & {
      condition?: Maybe<ResolversTypes["ExtraFieldCondition"]>;
    }
  >;
  Float: ResolverTypeWrapper<Scalars["Float"]["output"]>;
  ID: ResolverTypeWrapper<Scalars["ID"]["output"]>;
  IconType: IconType;
  Int: ResolverTypeWrapper<Scalars["Int"]["output"]>;
  JSONObject: ResolverTypeWrapper<Scalars["JSONObject"]["output"]>;
  Layout: ResolverTypeWrapper<
    Omit<Layout, "animation"> & {
      animation?: Maybe<ResolversTypes["Animation"]>;
    }
  >;
  LayoutCustomModel: ResolverTypeWrapper<LayoutCustomModel>;
  LayoutCustomModelInput: LayoutCustomModelInput;
  LayoutCustomModelPosition: ResolverTypeWrapper<LayoutCustomModelPosition>;
  LayoutCustomModelPositionInput: LayoutCustomModelPositionInput;
  LayoutQueryFilter: LayoutQueryFilter;
  ListMetadata: ResolverTypeWrapper<ListMetadata>;
  Location: ResolverTypeWrapper<Location>;
  LocationDeviceConfig: ResolverTypeWrapper<LocationDeviceConfig>;
  LocationDeviceConfigAppMenu: ResolverTypeWrapper<LocationDeviceConfigAppMenu>;
  LocationDeviceConfigAppMenuInput: LocationDeviceConfigAppMenuInput;
  LocationDeviceConfigOverscan: ResolverTypeWrapper<LocationDeviceConfigOverscan>;
  LocationDeviceConfigOverscanInput: LocationDeviceConfigOverscanInput;
  LocationDeviceConfigScreen: ResolverTypeWrapper<LocationDeviceConfigScreen>;
  LocationDeviceConfigScreenInput: LocationDeviceConfigScreenInput;
  LocationDeviceConfigScreenOffset: ResolverTypeWrapper<LocationDeviceConfigScreenOffset>;
  LocationDeviceConfigScreenOffsetInput: LocationDeviceConfigScreenOffsetInput;
  LocationDeviceConfigVideoSource: ResolverTypeWrapper<LocationDeviceConfigVideoSource>;
  LocationDeviceConfigVideoSourceInput: LocationDeviceConfigVideoSourceInput;
  LocationDeviceInput: LocationDeviceInput;
  LocationFilter: LocationFilter;
  LottieAsset: ResolverTypeWrapper<LottieAsset>;
  Media: ResolverTypeWrapper<Media>;
  MediaLottieAsset: MediaLottieAsset;
  MediaQueryFilter: MediaQueryFilter;
  MediaUrlModel: ResolverTypeWrapper<MediaUrlModel>;
  Mutation: ResolverTypeWrapper<{}>;
  OrganizationFilter: OrganizationFilter;
  OrganizationModel: ResolverTypeWrapper<OrganizationModel>;
  OrientationType: OrientationType;
  Post: ResolverTypeWrapper<Post>;
  PostFilter: PostFilter;
  PostFlyoutPositionModel: ResolverTypeWrapper<PostFlyoutPositionModel>;
  PostFlyoutPositionModelInput: PostFlyoutPositionModelInput;
  PostQrCodeAlignHorizontal: PostQrCodeAlignHorizontal;
  PostQrCodeAlignVertical: PostQrCodeAlignVertical;
  PostQrCodeBoxShape: PostQrCodeBoxShape;
  PostQrCodeByProfile: ResolverTypeWrapper<PostQrCodeByProfile>;
  PostQrCodeByProfileInput: PostQrCodeByProfileInput;
  PostQrCodeLocation: ResolverTypeWrapper<PostQrCodeLocation>;
  PostQrCodeLocationInput: PostQrCodeLocationInput;
  PostQrCodeLocationPercent: ResolverTypeWrapper<PostQrCodeLocationPercent>;
  PostQrCodeLocationPercentInput: PostQrCodeLocationPercentInput;
  PostQrCodeLocationType: PostQrCodeLocationType;
  PostQrCodeSize: PostQrCodeSize;
  PostQrCodeStyle: ResolverTypeWrapper<PostQrCodeStyle>;
  PostQrCodeStyleInput: PostQrCodeStyleInput;
  PostTileAsset: ResolverTypeWrapper<PostTileAsset>;
  PostTileAssetInput: PostTileAssetInput;
  ProfileBackgroundInput: ProfileBackgroundInput;
  ProfileBackgroundModel: ResolverTypeWrapper<ProfileBackgroundModel>;
  ProfileFilter: ProfileFilter;
  ProfileLayoutInput: ProfileLayoutInput;
  ProfileLayoutModel: ResolverTypeWrapper<ProfileLayoutModel>;
  ProfileLayoutModelEntry: ResolverTypeWrapper<ProfileLayoutModelEntry>;
  ProfileLayoutModelEntryInput: ProfileLayoutModelEntryInput;
  ProfileLayoutScreenFlyoutModel: ResolverTypeWrapper<ProfileLayoutScreenFlyoutModel>;
  ProfileLayoutScreenFlyoutModelInput: ProfileLayoutScreenFlyoutModelInput;
  ProfileLayoutScreenModel: ResolverTypeWrapper<ProfileLayoutScreenModel>;
  ProfileLayoutScreenPositionModel: ResolverTypeWrapper<ProfileLayoutScreenPositionModel>;
  ProfileLayoutScreenPositionModelInput: ProfileLayoutScreenPositionModelInput;
  ProfileModel: ResolverTypeWrapper<ProfileModel>;
  ProfileRestingInput: ProfileRestingInput;
  ProfileRestingInputEntry: ProfileRestingInputEntry;
  ProfileRestingInputEntryImageSettings: ProfileRestingInputEntryImageSettings;
  ProfileRestingModel: ResolverTypeWrapper<ProfileRestingModel>;
  ProfileRestingModelEntry: ResolverTypeWrapper<ProfileRestingModelEntry>;
  ProfileRestingModelEntryImageSettings: ResolverTypeWrapper<ProfileRestingModelEntryImageSettings>;
  ProfileScreenModelInput: ProfileScreenModelInput;
  ProfileScreenModelSizeInput: ProfileScreenModelSizeInput;
  ProfileScreenSizeModel: ResolverTypeWrapper<ProfileScreenSizeModel>;
  Query: ResolverTypeWrapper<{}>;
  Resolution: Resolution;
  ScheduledEvent: ResolverTypeWrapper<
    Omit<ScheduledEvent, "endAction" | "startAction"> & {
      endAction?: Maybe<Array<ResolversTypes["ActionPayload"]>>;
      startAction?: Maybe<Array<ResolversTypes["ActionPayload"]>>;
    }
  >;
  ScheduledEventFilter: ScheduledEventFilter;
  ScheduledEventModificationType: ScheduledEventModificationType;
  ScheduledEventRecurringSettings: ResolverTypeWrapper<ScheduledEventRecurringSettings>;
  ScreenType: ScreenType;
  Service: ResolverTypeWrapper<
    Omit<Service, "options"> & {
      options?: Maybe<ResolversTypes["ServiceOption"]>;
    }
  >;
  ServiceAppCmsReferenceTypes: ServiceAppCmsReferenceTypes;
  ServiceOption: ResolverTypeWrapper<
    Omit<ServiceOption, "cms"> & {
      cms?: Maybe<ResolversTypes["ServiceOptionApp"]>;
    }
  >;
  ServiceOptionApp: ResolverTypeWrapper<
    Omit<ServiceOptionApp, "post" | "service"> & {
      post?: Maybe<ResolversTypes["ServiceOptionAppCmsFunction"]>;
      service?: Maybe<ResolversTypes["ServiceOptionAppCmsFunction"]>;
    }
  >;
  ServiceOptionAppCmsFunction: ResolverTypeWrapper<
    Omit<ServiceOptionAppCmsFunction, "extraFields"> & {
      extraFields?: Maybe<Array<ResolversTypes["ExtraFieldType"]>>;
    }
  >;
  ServiceQueryFilter: ServiceQueryFilter;
  ServiceTypes: ServiceTypes;
  String: ResolverTypeWrapper<Scalars["String"]["output"]>;
  Tag: ResolverTypeWrapper<Tag>;
  TagQueryFilter: TagQueryFilter;
  Templates: Templates;
  TileRotatePattern: TileRotatePattern;
  ValidationModel: ResolverTypeWrapper<ValidationModel>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActionPayload: ResolversUnionTypes<ResolversParentTypes>["ActionPayload"];
  ActionPayloadInput: ActionPayloadInput;
  ActionPayloadInputCombo: ActionPayloadInputCombo;
  ActionPayloadLocationProfileChanged: ActionPayloadLocationProfileChanged;
  ActionPayloadLocationProfileChangedInput: ActionPayloadLocationProfileChangedInput;
  ActionPayloadPostEnabled: ActionPayloadPostEnabled;
  ActionPayloadPostEnabledInput: ActionPayloadPostEnabledInput;
  Animation: Omit<Animation, "option"> & {
    option: ResolversParentTypes["AnimationOption"];
  };
  AnimationInput: AnimationInput;
  AnimationOption: ResolversUnionTypes<ResolversParentTypes>["AnimationOption"];
  AnimationOptionFade: AnimationOptionFade;
  AnimationOptionFlip: AnimationOptionFlip;
  AnimationOptionWipe: AnimationOptionWipe;
  Boolean: Scalars["Boolean"]["output"];
  ConditionValueType: ResolversUnionTypes<ResolversParentTypes>["ConditionValueType"];
  ConditionValueTypeBoolean: ConditionValueTypeBoolean;
  ConditionValueTypeNumber: ConditionValueTypeNumber;
  ConditionValueTypeString: ConditionValueTypeString;
  ContentUpdateOptions: ContentUpdateOptions;
  ContentUpdateOptionsInput: ContentUpdateOptionsInput;
  CreateScheduledEventRecurringSettingsInput: CreateScheduledEventRecurringSettingsInput;
  Customer: Customer;
  CustomerAnalyticsConfigInput: CustomerAnalyticsConfigInput;
  CustomerAuth0Config: CustomerAuth0Config;
  CustomerAuth0Settings: CustomerAuth0Settings;
  CustomerFilter: CustomerFilter;
  DateTime: Scalars["DateTime"]["output"];
  Device: Device;
  DeviceActivationConfig: DeviceActivationConfig;
  DeviceActivationConfigInput: DeviceActivationConfigInput;
  DeviceFilter: DeviceFilter;
  ExtraFieldCondition: Omit<ExtraFieldCondition, "value"> & {
    value: ResolversParentTypes["ConditionValueType"];
  };
  ExtraFieldMetadata: ExtraFieldMetadata;
  ExtraFieldMetadataProperties: ExtraFieldMetadataProperties;
  ExtraFieldType: ResolversUnionTypes<ResolversParentTypes>["ExtraFieldType"];
  ExtraFieldTypeArray: Omit<ExtraFieldTypeArray, "extraFields"> & {
    extraFields: Array<ResolversParentTypes["ExtraFieldType"]>;
  };
  ExtraFieldTypeBoolean: ExtraFieldTypeBoolean;
  ExtraFieldTypeBox: Omit<ExtraFieldTypeBox, "condition" | "extraFields"> & {
    condition?: Maybe<ResolversParentTypes["ExtraFieldCondition"]>;
    extraFields: Array<ResolversParentTypes["ExtraFieldType"]>;
  };
  ExtraFieldTypeColor: ExtraFieldTypeColor;
  ExtraFieldTypeHelp: ExtraFieldTypeHelp;
  ExtraFieldTypeMedia: ExtraFieldTypeMedia;
  ExtraFieldTypeNumber: Omit<ExtraFieldTypeNumber, "condition"> & {
    condition?: Maybe<ResolversParentTypes["ExtraFieldCondition"]>;
  };
  ExtraFieldTypeReference: ExtraFieldTypeReference;
  ExtraFieldTypeReferenceFilter: ExtraFieldTypeReferenceFilter;
  ExtraFieldTypeReferenceSelectOptions: ExtraFieldTypeReferenceSelectOptions;
  ExtraFieldTypeRichText: ExtraFieldTypeRichText;
  ExtraFieldTypeSearch: ExtraFieldTypeSearch;
  ExtraFieldTypeSelect: Omit<ExtraFieldTypeSelect, "condition"> & {
    condition?: Maybe<ResolversParentTypes["ExtraFieldCondition"]>;
  };
  ExtraFieldTypeSelectChoice: ExtraFieldTypeSelectChoice;
  ExtraFieldTypeText: Omit<ExtraFieldTypeText, "condition"> & {
    condition?: Maybe<ResolversParentTypes["ExtraFieldCondition"]>;
  };
  ExtraFieldTypeTextLabel: Omit<ExtraFieldTypeTextLabel, "condition"> & {
    condition?: Maybe<ResolversParentTypes["ExtraFieldCondition"]>;
  };
  Float: Scalars["Float"]["output"];
  ID: Scalars["ID"]["output"];
  Int: Scalars["Int"]["output"];
  JSONObject: Scalars["JSONObject"]["output"];
  Layout: Omit<Layout, "animation"> & {
    animation?: Maybe<ResolversParentTypes["Animation"]>;
  };
  LayoutCustomModel: LayoutCustomModel;
  LayoutCustomModelInput: LayoutCustomModelInput;
  LayoutCustomModelPosition: LayoutCustomModelPosition;
  LayoutCustomModelPositionInput: LayoutCustomModelPositionInput;
  LayoutQueryFilter: LayoutQueryFilter;
  ListMetadata: ListMetadata;
  Location: Location;
  LocationDeviceConfig: LocationDeviceConfig;
  LocationDeviceConfigAppMenu: LocationDeviceConfigAppMenu;
  LocationDeviceConfigAppMenuInput: LocationDeviceConfigAppMenuInput;
  LocationDeviceConfigOverscan: LocationDeviceConfigOverscan;
  LocationDeviceConfigOverscanInput: LocationDeviceConfigOverscanInput;
  LocationDeviceConfigScreen: LocationDeviceConfigScreen;
  LocationDeviceConfigScreenInput: LocationDeviceConfigScreenInput;
  LocationDeviceConfigScreenOffset: LocationDeviceConfigScreenOffset;
  LocationDeviceConfigScreenOffsetInput: LocationDeviceConfigScreenOffsetInput;
  LocationDeviceConfigVideoSource: LocationDeviceConfigVideoSource;
  LocationDeviceConfigVideoSourceInput: LocationDeviceConfigVideoSourceInput;
  LocationDeviceInput: LocationDeviceInput;
  LocationFilter: LocationFilter;
  LottieAsset: LottieAsset;
  Media: Media;
  MediaLottieAsset: MediaLottieAsset;
  MediaQueryFilter: MediaQueryFilter;
  MediaUrlModel: MediaUrlModel;
  Mutation: {};
  OrganizationFilter: OrganizationFilter;
  OrganizationModel: OrganizationModel;
  Post: Post;
  PostFilter: PostFilter;
  PostFlyoutPositionModel: PostFlyoutPositionModel;
  PostFlyoutPositionModelInput: PostFlyoutPositionModelInput;
  PostQrCodeByProfile: PostQrCodeByProfile;
  PostQrCodeByProfileInput: PostQrCodeByProfileInput;
  PostQrCodeLocation: PostQrCodeLocation;
  PostQrCodeLocationInput: PostQrCodeLocationInput;
  PostQrCodeLocationPercent: PostQrCodeLocationPercent;
  PostQrCodeLocationPercentInput: PostQrCodeLocationPercentInput;
  PostQrCodeStyle: PostQrCodeStyle;
  PostQrCodeStyleInput: PostQrCodeStyleInput;
  PostTileAsset: PostTileAsset;
  PostTileAssetInput: PostTileAssetInput;
  ProfileBackgroundInput: ProfileBackgroundInput;
  ProfileBackgroundModel: ProfileBackgroundModel;
  ProfileFilter: ProfileFilter;
  ProfileLayoutInput: ProfileLayoutInput;
  ProfileLayoutModel: ProfileLayoutModel;
  ProfileLayoutModelEntry: ProfileLayoutModelEntry;
  ProfileLayoutModelEntryInput: ProfileLayoutModelEntryInput;
  ProfileLayoutScreenFlyoutModel: ProfileLayoutScreenFlyoutModel;
  ProfileLayoutScreenFlyoutModelInput: ProfileLayoutScreenFlyoutModelInput;
  ProfileLayoutScreenModel: ProfileLayoutScreenModel;
  ProfileLayoutScreenPositionModel: ProfileLayoutScreenPositionModel;
  ProfileLayoutScreenPositionModelInput: ProfileLayoutScreenPositionModelInput;
  ProfileModel: ProfileModel;
  ProfileRestingInput: ProfileRestingInput;
  ProfileRestingInputEntry: ProfileRestingInputEntry;
  ProfileRestingInputEntryImageSettings: ProfileRestingInputEntryImageSettings;
  ProfileRestingModel: ProfileRestingModel;
  ProfileRestingModelEntry: ProfileRestingModelEntry;
  ProfileRestingModelEntryImageSettings: ProfileRestingModelEntryImageSettings;
  ProfileScreenModelInput: ProfileScreenModelInput;
  ProfileScreenModelSizeInput: ProfileScreenModelSizeInput;
  ProfileScreenSizeModel: ProfileScreenSizeModel;
  Query: {};
  ScheduledEvent: Omit<ScheduledEvent, "endAction" | "startAction"> & {
    endAction?: Maybe<Array<ResolversParentTypes["ActionPayload"]>>;
    startAction?: Maybe<Array<ResolversParentTypes["ActionPayload"]>>;
  };
  ScheduledEventFilter: ScheduledEventFilter;
  ScheduledEventRecurringSettings: ScheduledEventRecurringSettings;
  Service: Omit<Service, "options"> & {
    options?: Maybe<ResolversParentTypes["ServiceOption"]>;
  };
  ServiceOption: Omit<ServiceOption, "cms"> & {
    cms?: Maybe<ResolversParentTypes["ServiceOptionApp"]>;
  };
  ServiceOptionApp: Omit<ServiceOptionApp, "post" | "service"> & {
    post?: Maybe<ResolversParentTypes["ServiceOptionAppCmsFunction"]>;
    service?: Maybe<ResolversParentTypes["ServiceOptionAppCmsFunction"]>;
  };
  ServiceOptionAppCmsFunction: Omit<
    ServiceOptionAppCmsFunction,
    "extraFields"
  > & { extraFields?: Maybe<Array<ResolversParentTypes["ExtraFieldType"]>> };
  ServiceQueryFilter: ServiceQueryFilter;
  String: Scalars["String"]["output"];
  Tag: Tag;
  TagQueryFilter: TagQueryFilter;
  ValidationModel: ValidationModel;
};

export type ActionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ActionPayload"] = ResolversParentTypes["ActionPayload"],
> = {
  __resolveType: TypeResolveFn<
    "ActionPayloadLocationProfileChanged" | "ActionPayloadPostEnabled",
    ParentType,
    ContextType
  >;
};

export type ActionPayloadLocationProfileChangedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ActionPayloadLocationProfileChanged"] = ResolversParentTypes["ActionPayloadLocationProfileChanged"],
> = {
  location?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  profile?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["ActionPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionPayloadPostEnabledResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ActionPayloadPostEnabled"] = ResolversParentTypes["ActionPayloadPostEnabled"],
> = {
  enabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  post?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["ActionPayloadType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnimationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Animation"] = ResolversParentTypes["Animation"],
> = {
  enabled?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  option?: Resolver<ResolversTypes["AnimationOption"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnimationOptionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AnimationOption"] = ResolversParentTypes["AnimationOption"],
> = {
  __resolveType: TypeResolveFn<
    "AnimationOptionFade" | "AnimationOptionFlip" | "AnimationOptionWipe",
    ParentType,
    ContextType
  >;
};

export type AnimationOptionFadeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AnimationOptionFade"] = ResolversParentTypes["AnimationOptionFade"],
> = {
  duration?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnimationOptionFlipResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AnimationOptionFlip"] = ResolversParentTypes["AnimationOptionFlip"],
> = {
  direction?: Resolver<
    ResolversTypes["TileRotatePattern"],
    ParentType,
    ContextType
  >;
  duration?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnimationOptionWipeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AnimationOptionWipe"] = ResolversParentTypes["AnimationOptionWipe"],
> = {
  duration?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  function?: Resolver<
    ResolversTypes["AnimationWipeFunction"],
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConditionValueTypeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ConditionValueType"] = ResolversParentTypes["ConditionValueType"],
> = {
  __resolveType: TypeResolveFn<
    | "ConditionValueTypeBoolean"
    | "ConditionValueTypeNumber"
    | "ConditionValueTypeString",
    ParentType,
    ContextType
  >;
};

export type ConditionValueTypeBooleanResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ConditionValueTypeBoolean"] = ResolversParentTypes["ConditionValueTypeBoolean"],
> = {
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  valueBoolean?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConditionValueTypeNumberResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ConditionValueTypeNumber"] = ResolversParentTypes["ConditionValueTypeNumber"],
> = {
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  valueNumber?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConditionValueTypeStringResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ConditionValueTypeString"] = ResolversParentTypes["ConditionValueTypeString"],
> = {
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  valueString?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentUpdateOptionsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContentUpdateOptions"] = ResolversParentTypes["ContentUpdateOptions"],
> = {
  staleFlyoutTimeout?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  tileContentUpdateFrequency?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  tileContentUpdatePct?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Customer"] = ResolversParentTypes["Customer"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  auth0?: Resolver<
    Maybe<ResolversTypes["CustomerAuth0Config"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerAuth0ConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CustomerAuth0Config"] = ResolversParentTypes["CustomerAuth0Config"],
> = {
  organizationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["DateTime"], any> {
  name: "DateTime";
}

export type DeviceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Device"] = ResolversParentTypes["Device"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  accessToken?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  accessTokenSalt?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  assetTag?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  building?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  clientSecret?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  clientSecretSalt?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  config?: Resolver<
    Maybe<ResolversTypes["DeviceActivationConfig"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  customer?: Resolver<ResolversTypes["ID"], ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  license?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  licenseSalt?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  licenseVersion?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  location?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  room?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  settings?: Resolver<
    Maybe<Array<ResolversTypes["JSONObject"]>>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["DeviceStatus"], ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceActivationConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeviceActivationConfig"] = ResolversParentTypes["DeviceActivationConfig"],
> = {
  analytics?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  menu?: Resolver<
    Maybe<ResolversTypes["DeviceMenuLocation"]>,
    ParentType,
    ContextType
  >;
  openDevToolsOnStart?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldConditionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldCondition"] = ResolversParentTypes["ExtraFieldCondition"],
> = {
  field?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  value?: Resolver<
    ResolversTypes["ConditionValueType"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldMetadataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldMetadata"] = ResolversParentTypes["ExtraFieldMetadata"],
> = {
  allowOverride?: Resolver<
    Maybe<ResolversTypes["ExtraFieldMetadataProperties"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldMetadataPropertiesResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldMetadataProperties"] = ResolversParentTypes["ExtraFieldMetadataProperties"],
> = {
  defaultValue?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldType"] = ResolversParentTypes["ExtraFieldType"],
> = {
  __resolveType: TypeResolveFn<
    | "ExtraFieldTypeArray"
    | "ExtraFieldTypeBoolean"
    | "ExtraFieldTypeBox"
    | "ExtraFieldTypeColor"
    | "ExtraFieldTypeHelp"
    | "ExtraFieldTypeMedia"
    | "ExtraFieldTypeNumber"
    | "ExtraFieldTypeReference"
    | "ExtraFieldTypeRichText"
    | "ExtraFieldTypeSearch"
    | "ExtraFieldTypeSelect"
    | "ExtraFieldTypeText"
    | "ExtraFieldTypeTextLabel",
    ParentType,
    ContextType
  >;
};

export type ExtraFieldTypeArrayResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeArray"] = ResolversParentTypes["ExtraFieldTypeArray"],
> = {
  extraFields?: Resolver<
    Array<ResolversTypes["ExtraFieldType"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  showTitle?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeBooleanResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeBoolean"] = ResolversParentTypes["ExtraFieldTypeBoolean"],
> = {
  defaultValue?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  metadata?: Resolver<
    Maybe<ResolversTypes["ExtraFieldMetadata"]>,
    ParentType,
    ContextType
  >;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeBoxResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeBox"] = ResolversParentTypes["ExtraFieldTypeBox"],
> = {
  condition?: Resolver<
    Maybe<ResolversTypes["ExtraFieldCondition"]>,
    ParentType,
    ContextType
  >;
  extraFields?: Resolver<
    Array<ResolversTypes["ExtraFieldType"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeColorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeColor"] = ResolversParentTypes["ExtraFieldTypeColor"],
> = {
  defaultValue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  metadata?: Resolver<
    Maybe<ResolversTypes["ExtraFieldMetadata"]>,
    ParentType,
    ContextType
  >;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeHelpResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeHelp"] = ResolversParentTypes["ExtraFieldTypeHelp"],
> = {
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeMediaResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeMedia"] = ResolversParentTypes["ExtraFieldTypeMedia"],
> = {
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeNumberResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeNumber"] = ResolversParentTypes["ExtraFieldTypeNumber"],
> = {
  condition?: Resolver<
    Maybe<ResolversTypes["ExtraFieldCondition"]>,
    ParentType,
    ContextType
  >;
  defaultValue?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeReferenceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeReference"] = ResolversParentTypes["ExtraFieldTypeReference"],
> = {
  disabled?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  filter?: Resolver<
    Maybe<ResolversTypes["ExtraFieldTypeReferenceFilter"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  multiple?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  nullable?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  optionText?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  reference?: Resolver<
    ResolversTypes["ServiceAppCmsReferenceTypes"],
    ParentType,
    ContextType
  >;
  selectOptions?: Resolver<
    Maybe<ResolversTypes["ExtraFieldTypeReferenceSelectOptions"]>,
    ParentType,
    ContextType
  >;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeReferenceFilterResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeReferenceFilter"] = ResolversParentTypes["ExtraFieldTypeReferenceFilter"],
> = {
  enabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeReferenceSelectOptionsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeReferenceSelectOptions"] = ResolversParentTypes["ExtraFieldTypeReferenceSelectOptions"],
> = {
  optionText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeRichTextResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeRichText"] = ResolversParentTypes["ExtraFieldTypeRichText"],
> = {
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeSearchResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeSearch"] = ResolversParentTypes["ExtraFieldTypeSearch"],
> = {
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeSelectResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeSelect"] = ResolversParentTypes["ExtraFieldTypeSelect"],
> = {
  choices?: Resolver<
    Array<ResolversTypes["ExtraFieldTypeSelectChoice"]>,
    ParentType,
    ContextType
  >;
  condition?: Resolver<
    Maybe<ResolversTypes["ExtraFieldCondition"]>,
    ParentType,
    ContextType
  >;
  defaultChoice?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  defaultValue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeSelectChoiceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeSelectChoice"] = ResolversParentTypes["ExtraFieldTypeSelectChoice"],
> = {
  id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeTextResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeText"] = ResolversParentTypes["ExtraFieldTypeText"],
> = {
  condition?: Resolver<
    Maybe<ResolversTypes["ExtraFieldCondition"]>,
    ParentType,
    ContextType
  >;
  defaultValue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  disabled?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  label?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExtraFieldTypeTextLabelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ExtraFieldTypeTextLabel"] = ResolversParentTypes["ExtraFieldTypeTextLabel"],
> = {
  condition?: Resolver<
    Maybe<ResolversTypes["ExtraFieldCondition"]>,
    ParentType,
    ContextType
  >;
  initialValue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonObjectScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["JSONObject"], any> {
  name: "JSONObject";
}

export type LayoutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Layout"] = ResolversParentTypes["Layout"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  animation?: Resolver<
    Maybe<ResolversTypes["Animation"]>,
    ParentType,
    ContextType
  >;
  borderRadius?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  content?: Resolver<
    Maybe<ResolversTypes["ContentUpdateOptions"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  custom?: Resolver<
    Maybe<ResolversTypes["LayoutCustomModel"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  padding?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  template?: Resolver<
    Maybe<ResolversTypes["Templates"]>,
    ParentType,
    ContextType
  >;
  tileCount?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutCustomModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LayoutCustomModel"] = ResolversParentTypes["LayoutCustomModel"],
> = {
  height?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  positions?: Resolver<
    Array<ResolversTypes["LayoutCustomModelPosition"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutCustomModelPositionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LayoutCustomModelPosition"] = ResolversParentTypes["LayoutCustomModelPosition"],
> = {
  height?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  width?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  x?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  y?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListMetadataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ListMetadata"] = ResolversParentTypes["ListMetadata"],
> = {
  count?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Location"] = ResolversParentTypes["Location"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  device?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfig"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfig"] = ResolversParentTypes["LocationDeviceConfig"],
> = {
  appMenu?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfigAppMenu"]>,
    ParentType,
    ContextType
  >;
  screens?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfigScreen"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigAppMenuResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfigAppMenu"] = ResolversParentTypes["LocationDeviceConfigAppMenu"],
> = {
  positions?: Resolver<
    Maybe<Array<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  show?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigOverscanResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfigOverscan"] = ResolversParentTypes["LocationDeviceConfigOverscan"],
> = {
  bottom?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  left?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  right?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  top?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigScreenResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfigScreen"] = ResolversParentTypes["LocationDeviceConfigScreen"],
> = {
  fullscreen?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  overscan?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfigOverscan"]>,
    ParentType,
    ContextType
  >;
  screenOffset?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfigScreenOffset"]>,
    ParentType,
    ContextType
  >;
  videoSource?: Resolver<
    Maybe<ResolversTypes["LocationDeviceConfigVideoSource"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigScreenOffsetResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfigScreenOffset"] = ResolversParentTypes["LocationDeviceConfigScreenOffset"],
> = {
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationDeviceConfigVideoSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LocationDeviceConfigVideoSource"] = ResolversParentTypes["LocationDeviceConfigVideoSource"],
> = {
  enabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  showCloseButton?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LottieAssetResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["LottieAsset"] = ResolversParentTypes["LottieAsset"],
> = {
  data?: Resolver<Maybe<ResolversTypes["JSONObject"]>, ParentType, ContextType>;
  speed?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Media"] = ResolversParentTypes["Media"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  file?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  isDir?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  lottie?: Resolver<
    Maybe<ResolversTypes["LottieAsset"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  root?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaUrlModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MediaUrlModel"] = ResolversParentTypes["MediaUrlModel"],
> = {
  fileName?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Mutation"] = ResolversParentTypes["Mutation"],
> = {
  createCustomer?: Resolver<
    ResolversTypes["Customer"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateCustomerArgs, "name">
  >;
  createDevice?: Resolver<
    ResolversTypes["Device"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateDeviceArgs, "assetTag" | "customer" | "status">
  >;
  createLayout?: Resolver<
    ResolversTypes["Layout"],
    ParentType,
    ContextType,
    RequireFields<
      MutationCreateLayoutArgs,
      | "animation"
      | "borderRadius"
      | "content"
      | "name"
      | "padding"
      | "template"
      | "tileCount"
    >
  >;
  createLocation?: Resolver<
    ResolversTypes["Location"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateLocationArgs, "name">
  >;
  createMedia?: Resolver<
    ResolversTypes["Media"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateMediaArgs, "isDir" | "name">
  >;
  createPost?: Resolver<
    ResolversTypes["Post"],
    ParentType,
    ContextType,
    RequireFields<
      MutationCreatePostArgs,
      | "enabled"
      | "flyoutShowCloseButton"
      | "hideFromSearch"
      | "qrCodeLinkByLocationProfile"
      | "relatedPosts"
      | "tags"
      | "tileAssets"
    >
  >;
  createProfile?: Resolver<
    ResolversTypes["ProfileModel"],
    ParentType,
    ContextType,
    RequireFields<MutationCreateProfileArgs, "name" | "type">
  >;
  createScheduledEvent?: Resolver<
    ResolversTypes["ScheduledEvent"],
    ParentType,
    ContextType,
    Partial<MutationCreateScheduledEventArgs>
  >;
  createService?: Resolver<
    ResolversTypes["Service"],
    ParentType,
    ContextType,
    Partial<MutationCreateServiceArgs>
  >;
  createTag?: Resolver<
    ResolversTypes["Tag"],
    ParentType,
    ContextType,
    Partial<MutationCreateTagArgs>
  >;
  deleteCustomer?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCustomerArgs, "id">
  >;
  deleteDevice?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDeviceArgs, "id">
  >;
  deleteLayout?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLayoutArgs, "id">
  >;
  deleteLocation?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLocationArgs, "id">
  >;
  deleteMedia?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMediaArgs, "id">
  >;
  deletePost?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeletePostArgs, "id">
  >;
  deleteProfile?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteProfileArgs, "id">
  >;
  deleteScheduledEvent?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteScheduledEventArgs, "id">
  >;
  deleteService?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteServiceArgs, "id">
  >;
  deleteTag?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTagArgs, "id">
  >;
  enablePost?: Resolver<
    ResolversTypes["Post"],
    ParentType,
    ContextType,
    RequireFields<MutationEnablePostArgs, "enabled" | "id">
  >;
  regenerateDeviceLicense?: Resolver<
    ResolversTypes["Device"],
    ParentType,
    ContextType,
    RequireFields<MutationRegenerateDeviceLicenseArgs, "id">
  >;
  updateCustomer?: Resolver<
    ResolversTypes["Customer"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCustomerArgs, "id" | "name">
  >;
  updateDevice?: Resolver<
    ResolversTypes["Device"],
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateDeviceArgs,
      "assetTag" | "customer" | "id" | "status"
    >
  >;
  updateLayout?: Resolver<
    ResolversTypes["Layout"],
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateLayoutArgs,
      | "animation"
      | "borderRadius"
      | "content"
      | "id"
      | "name"
      | "padding"
      | "template"
      | "tileCount"
    >
  >;
  updateLocation?: Resolver<
    ResolversTypes["Location"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLocationArgs, "id" | "name">
  >;
  updateMedia?: Resolver<
    ResolversTypes["Media"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMediaArgs, "id" | "isDir" | "name">
  >;
  updatePost?: Resolver<
    ResolversTypes["Post"],
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdatePostArgs,
      | "enabled"
      | "flyoutShowCloseButton"
      | "hideFromSearch"
      | "id"
      | "qrCodeLinkByLocationProfile"
      | "relatedPosts"
      | "tags"
      | "tileAssets"
    >
  >;
  updateProfile?: Resolver<
    ResolversTypes["ProfileModel"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateProfileArgs, "id" | "name" | "type">
  >;
  updateScheduledEvent?: Resolver<
    ResolversTypes["ScheduledEvent"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateScheduledEventArgs, "id">
  >;
  updateService?: Resolver<
    ResolversTypes["Service"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateServiceArgs, "id">
  >;
  updateTag?: Resolver<
    ResolversTypes["Tag"],
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTagArgs, "id">
  >;
  validateGqlModel?: Resolver<
    ResolversTypes["ValidationModel"],
    ParentType,
    ContextType,
    RequireFields<MutationValidateGqlModelArgs, "action" | "data">
  >;
};

export type OrganizationModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["OrganizationModel"] = ResolversParentTypes["OrganizationModel"],
> = {
  id?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  orgId?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Post"] = ResolversParentTypes["Post"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  enabled?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  flyoutPosition?: Resolver<
    Maybe<ResolversTypes["PostFlyoutPositionModel"]>,
    ParentType,
    ContextType
  >;
  flyoutScale?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  flyoutShowCloseButton?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  flyoutType?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  hideFromSearch?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  qrCodeLink?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  qrCodeLinkByLocationProfile?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["PostQrCodeByProfile"]>>>,
    ParentType,
    ContextType
  >;
  qrCodeLocation?: Resolver<
    Maybe<ResolversTypes["PostQrCodeLocation"]>,
    ParentType,
    ContextType
  >;
  qrCodeLocationPercent?: Resolver<
    Maybe<ResolversTypes["PostQrCodeLocationPercent"]>,
    ParentType,
    ContextType
  >;
  qrCodeStyle?: Resolver<
    Maybe<ResolversTypes["PostQrCodeStyle"]>,
    ParentType,
    ContextType
  >;
  qrCodeText?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  relatedPostAsset?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  relatedPosts?: Resolver<Array<ResolversTypes["ID"]>, ParentType, ContextType>;
  staleFlyoutTimeout?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  tags?: Resolver<Array<ResolversTypes["ID"]>, ParentType, ContextType>;
  tileAssets?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["PostTileAsset"]>>>,
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostFlyoutPositionModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostFlyoutPositionModel"] = ResolversParentTypes["PostFlyoutPositionModel"],
> = {
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostQrCodeByProfileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostQrCodeByProfile"] = ResolversParentTypes["PostQrCodeByProfile"],
> = {
  location?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  profile?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  qrCodeLink?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostQrCodeLocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostQrCodeLocation"] = ResolversParentTypes["PostQrCodeLocation"],
> = {
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  size?: Resolver<
    Maybe<ResolversTypes["PostQrCodeSize"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<
    Maybe<ResolversTypes["PostQrCodeLocationType"]>,
    ParentType,
    ContextType
  >;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostQrCodeLocationPercentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostQrCodeLocationPercent"] = ResolversParentTypes["PostQrCodeLocationPercent"],
> = {
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostQrCodeStyleResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostQrCodeStyle"] = ResolversParentTypes["PostQrCodeStyle"],
> = {
  backdropColor?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  borderColor?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  borderEnabled?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  boxColor?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  boxShape?: Resolver<
    Maybe<ResolversTypes["PostQrCodeBoxShape"]>,
    ParentType,
    ContextType
  >;
  qrAlignHorizontal?: Resolver<
    Maybe<ResolversTypes["PostQrCodeAlignHorizontal"]>,
    ParentType,
    ContextType
  >;
  qrAlignVertical?: Resolver<
    Maybe<ResolversTypes["PostQrCodeAlignVertical"]>,
    ParentType,
    ContextType
  >;
  qrBackgroundColor?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  qrColor?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  qrSize?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  textAlignHorizontal?: Resolver<
    Maybe<ResolversTypes["PostQrCodeAlignHorizontal"]>,
    ParentType,
    ContextType
  >;
  textAlignVertical?: Resolver<
    Maybe<ResolversTypes["PostQrCodeAlignVertical"]>,
    ParentType,
    ContextType
  >;
  textColor?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  textHidden?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  textSize?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostTileAssetResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PostTileAsset"] = ResolversParentTypes["PostTileAsset"],
> = {
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  layout?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  qrLinkPrefix?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  tileBackingImage?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  tileType?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileBackgroundModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileBackgroundModel"] = ResolversParentTypes["ProfileBackgroundModel"],
> = {
  backgroundMedia?: Resolver<
    Maybe<Array<ResolversTypes["ID"]>>,
    ParentType,
    ContextType
  >;
  backgroundMediaMode?: Resolver<
    Maybe<ResolversTypes["BackgroundMediaMode"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLayoutModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileLayoutModel"] = ResolversParentTypes["ProfileLayoutModel"],
> = {
  detailed?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  flyout?: Resolver<
    Maybe<ResolversTypes["ProfileLayoutScreenFlyoutModel"]>,
    ParentType,
    ContextType
  >;
  item?: Resolver<
    Maybe<ResolversTypes["ProfileLayoutModelEntry"]>,
    ParentType,
    ContextType
  >;
  items?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ProfileLayoutModelEntry"]>>>,
    ParentType,
    ContextType
  >;
  layout?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes["ProfileLayoutScreenPositionModel"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLayoutModelEntryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileLayoutModelEntry"] = ResolversParentTypes["ProfileLayoutModelEntry"],
> = {
  posts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ID"]>>>,
    ParentType,
    ContextType
  >;
  tags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["ID"]>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLayoutScreenFlyoutModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileLayoutScreenFlyoutModel"] = ResolversParentTypes["ProfileLayoutScreenFlyoutModel"],
> = {
  position?: Resolver<
    Maybe<ResolversTypes["ProfileLayoutScreenPositionModel"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLayoutScreenModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileLayoutScreenModel"] = ResolversParentTypes["ProfileLayoutScreenModel"],
> = {
  columns?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  orientation?: Resolver<
    Maybe<ResolversTypes["OrientationType"]>,
    ParentType,
    ContextType
  >;
  resolution?: Resolver<
    Maybe<ResolversTypes["Resolution"]>,
    ParentType,
    ContextType
  >;
  rows?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  size?: Resolver<
    Maybe<ResolversTypes["ProfileScreenSizeModel"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLayoutScreenPositionModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileLayoutScreenPositionModel"] = ResolversParentTypes["ProfileLayoutScreenPositionModel"],
> = {
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  x?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  y?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileModel"] = ResolversParentTypes["ProfileModel"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  background?: Resolver<
    Maybe<ResolversTypes["ProfileBackgroundModel"]>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  layouts?: Resolver<
    Maybe<Array<ResolversTypes["ProfileLayoutModel"]>>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  resting?: Resolver<
    Maybe<ResolversTypes["ProfileRestingModel"]>,
    ParentType,
    ContextType
  >;
  screen?: Resolver<
    Maybe<ResolversTypes["ProfileLayoutScreenModel"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<Maybe<ResolversTypes["ScreenType"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileRestingModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileRestingModel"] = ResolversParentTypes["ProfileRestingModel"],
> = {
  items?: Resolver<
    Maybe<Array<ResolversTypes["ProfileRestingModelEntry"]>>,
    ParentType,
    ContextType
  >;
  staleStateTimeout?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileRestingModelEntryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileRestingModelEntry"] = ResolversParentTypes["ProfileRestingModelEntry"],
> = {
  alphaOn?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  canInterrupt?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  imageSettings?: Resolver<
    Maybe<ResolversTypes["ProfileRestingModelEntryImageSettings"]>,
    ParentType,
    ContextType
  >;
  media?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  playAudio?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  post?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileRestingModelEntryImageSettingsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileRestingModelEntryImageSettings"] = ResolversParentTypes["ProfileRestingModelEntryImageSettings"],
> = {
  showTime?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileScreenSizeModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProfileScreenSizeModel"] = ResolversParentTypes["ProfileScreenSizeModel"],
> = {
  height?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Query"] = ResolversParentTypes["Query"],
> = {
  Customer?: Resolver<
    ResolversTypes["Customer"],
    ParentType,
    ContextType,
    RequireFields<QueryCustomerArgs, "id">
  >;
  Device?: Resolver<
    ResolversTypes["Device"],
    ParentType,
    ContextType,
    RequireFields<QueryDeviceArgs, "id">
  >;
  Layout?: Resolver<
    ResolversTypes["Layout"],
    ParentType,
    ContextType,
    RequireFields<QueryLayoutArgs, "id">
  >;
  Location?: Resolver<
    ResolversTypes["Location"],
    ParentType,
    ContextType,
    RequireFields<QueryLocationArgs, "id">
  >;
  Media?: Resolver<
    ResolversTypes["Media"],
    ParentType,
    ContextType,
    RequireFields<QueryMediaArgs, "id">
  >;
  Post?: Resolver<
    ResolversTypes["Post"],
    ParentType,
    ContextType,
    RequireFields<QueryPostArgs, "id">
  >;
  ScheduledEvent?: Resolver<
    ResolversTypes["ScheduledEvent"],
    ParentType,
    ContextType,
    RequireFields<QueryScheduledEventArgs, "id">
  >;
  Service?: Resolver<
    ResolversTypes["Service"],
    ParentType,
    ContextType,
    RequireFields<QueryServiceArgs, "id">
  >;
  Tag?: Resolver<
    ResolversTypes["Tag"],
    ParentType,
    ContextType,
    RequireFields<QueryTagArgs, "id">
  >;
  _allCustomersMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllCustomersMetaArgs, "page" | "perPage">
  >;
  _allDevicesMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllDevicesMetaArgs, "page" | "perPage">
  >;
  _allLayoutsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllLayoutsMetaArgs, "page" | "perPage">
  >;
  _allLocationsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllLocationsMetaArgs, "page" | "perPage">
  >;
  _allManagementServicesMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllManagementServicesMetaArgs, "page" | "perPage">
  >;
  _allMediaMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllMediaMetaArgs, "page" | "perPage">
  >;
  _allPostsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllPostsMetaArgs, "page" | "perPage">
  >;
  _allProfilesMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllProfilesMetaArgs, "page" | "perPage">
  >;
  _allScheduledEventsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllScheduledEventsMetaArgs, "page" | "perPage">
  >;
  _allServicesMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllServicesMetaArgs, "page" | "perPage">
  >;
  _allTagsMeta?: Resolver<
    ResolversTypes["ListMetadata"],
    ParentType,
    ContextType,
    RequireFields<Query_AllTagsMetaArgs, "page" | "perPage">
  >;
  allCustomers?: Resolver<
    Array<ResolversTypes["Customer"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCustomersArgs, "page" | "perPage">
  >;
  allDevices?: Resolver<
    Array<ResolversTypes["Device"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDevicesArgs, "page" | "perPage">
  >;
  allLayouts?: Resolver<
    Array<ResolversTypes["Layout"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllLayoutsArgs, "page" | "perPage">
  >;
  allLocations?: Resolver<
    Array<ResolversTypes["Location"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllLocationsArgs, "page" | "perPage">
  >;
  allManagementServices?: Resolver<
    Array<ResolversTypes["Service"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllManagementServicesArgs, "page" | "perPage">
  >;
  allMedia?: Resolver<
    Array<ResolversTypes["Media"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllMediaArgs, "page" | "perPage">
  >;
  allPosts?: Resolver<
    Array<ResolversTypes["Post"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPostsArgs, "page" | "perPage">
  >;
  allProfiles?: Resolver<
    Array<ResolversTypes["ProfileModel"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProfilesArgs, "page" | "perPage">
  >;
  allScheduledEvents?: Resolver<
    Array<ResolversTypes["ScheduledEvent"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllScheduledEventsArgs, "page" | "perPage">
  >;
  allServices?: Resolver<
    Array<ResolversTypes["Service"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllServicesArgs, "page" | "perPage">
  >;
  allTags?: Resolver<
    Array<ResolversTypes["Tag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTagsArgs, "page" | "perPage">
  >;
  getDeviceLicense?: Resolver<
    ResolversTypes["Device"],
    ParentType,
    ContextType,
    RequireFields<QueryGetDeviceLicenseArgs, "id">
  >;
  getMediaDownloadUrl?: Resolver<
    ResolversTypes["MediaUrlModel"],
    ParentType,
    ContextType,
    RequireFields<QueryGetMediaDownloadUrlArgs, "fileName">
  >;
  getMediaUploadUrl?: Resolver<
    ResolversTypes["MediaUrlModel"],
    ParentType,
    ContextType,
    RequireFields<QueryGetMediaUploadUrlArgs, "fileName">
  >;
  getOrganizations?: Resolver<
    Array<ResolversTypes["OrganizationModel"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetOrganizationsArgs, "orgIds">
  >;
  getProfile?: Resolver<
    ResolversTypes["ProfileModel"],
    ParentType,
    ContextType,
    RequireFields<QueryGetProfileArgs, "id">
  >;
};

export type ScheduledEventResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ScheduledEvent"] = ResolversParentTypes["ScheduledEvent"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  end?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
  endAction?: Resolver<
    Maybe<Array<ResolversTypes["ActionPayload"]>>,
    ParentType,
    ContextType
  >;
  endProcessed?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  groupId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  recurring?: Resolver<
    Maybe<ResolversTypes["ScheduledEventRecurringSettings"]>,
    ParentType,
    ContextType
  >;
  start?: Resolver<Maybe<ResolversTypes["DateTime"]>, ParentType, ContextType>;
  startAction?: Resolver<
    Maybe<Array<ResolversTypes["ActionPayload"]>>,
    ParentType,
    ContextType
  >;
  startProcessed?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  timezone?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledEventRecurringSettingsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ScheduledEventRecurringSettings"] = ResolversParentTypes["ScheduledEventRecurringSettings"],
> = {
  bymonth?: Resolver<
    Maybe<Array<ResolversTypes["Float"]>>,
    ParentType,
    ContextType
  >;
  byweekday?: Resolver<
    Maybe<Array<ResolversTypes["Float"]>>,
    ParentType,
    ContextType
  >;
  count?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  dtstart?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  freq?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  interval?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  tzid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  until?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Service"] = ResolversParentTypes["Service"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  defaultValues?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  machineName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  options?: Resolver<
    Maybe<ResolversTypes["ServiceOption"]>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes["ServiceTypes"], ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceOptionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ServiceOption"] = ResolversParentTypes["ServiceOption"],
> = {
  cms?: Resolver<
    Maybe<ResolversTypes["ServiceOptionApp"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceOptionAppResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ServiceOptionApp"] = ResolversParentTypes["ServiceOptionApp"],
> = {
  post?: Resolver<
    Maybe<ResolversTypes["ServiceOptionAppCmsFunction"]>,
    ParentType,
    ContextType
  >;
  service?: Resolver<
    Maybe<ResolversTypes["ServiceOptionAppCmsFunction"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServiceOptionAppCmsFunctionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ServiceOptionAppCmsFunction"] = ResolversParentTypes["ServiceOptionAppCmsFunction"],
> = {
  extraFields?: Resolver<
    Maybe<Array<ResolversTypes["ExtraFieldType"]>>,
    ParentType,
    ContextType
  >;
  previewMediaSource?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  qrCodeEmbeddedInFlyout?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  showMediaInput?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Tag"] = ResolversParentTypes["Tag"],
> = {
  _id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  _version?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  customData?: Resolver<
    Maybe<ResolversTypes["JSONObject"]>,
    ParentType,
    ContextType
  >;
  deleted?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  deletedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  icon?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  iconType?: Resolver<
    Maybe<ResolversTypes["IconType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  mediaIcon?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  updatedAt?: Resolver<
    Maybe<ResolversTypes["DateTime"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationModelResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ValidationModel"] = ResolversParentTypes["ValidationModel"],
> = {
  errors?: Resolver<
    Maybe<Array<ResolversTypes["JSONObject"]>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActionPayload?: ActionPayloadResolvers<ContextType>;
  ActionPayloadLocationProfileChanged?: ActionPayloadLocationProfileChangedResolvers<ContextType>;
  ActionPayloadPostEnabled?: ActionPayloadPostEnabledResolvers<ContextType>;
  Animation?: AnimationResolvers<ContextType>;
  AnimationOption?: AnimationOptionResolvers<ContextType>;
  AnimationOptionFade?: AnimationOptionFadeResolvers<ContextType>;
  AnimationOptionFlip?: AnimationOptionFlipResolvers<ContextType>;
  AnimationOptionWipe?: AnimationOptionWipeResolvers<ContextType>;
  ConditionValueType?: ConditionValueTypeResolvers<ContextType>;
  ConditionValueTypeBoolean?: ConditionValueTypeBooleanResolvers<ContextType>;
  ConditionValueTypeNumber?: ConditionValueTypeNumberResolvers<ContextType>;
  ConditionValueTypeString?: ConditionValueTypeStringResolvers<ContextType>;
  ContentUpdateOptions?: ContentUpdateOptionsResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  CustomerAuth0Config?: CustomerAuth0ConfigResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Device?: DeviceResolvers<ContextType>;
  DeviceActivationConfig?: DeviceActivationConfigResolvers<ContextType>;
  ExtraFieldCondition?: ExtraFieldConditionResolvers<ContextType>;
  ExtraFieldMetadata?: ExtraFieldMetadataResolvers<ContextType>;
  ExtraFieldMetadataProperties?: ExtraFieldMetadataPropertiesResolvers<ContextType>;
  ExtraFieldType?: ExtraFieldTypeResolvers<ContextType>;
  ExtraFieldTypeArray?: ExtraFieldTypeArrayResolvers<ContextType>;
  ExtraFieldTypeBoolean?: ExtraFieldTypeBooleanResolvers<ContextType>;
  ExtraFieldTypeBox?: ExtraFieldTypeBoxResolvers<ContextType>;
  ExtraFieldTypeColor?: ExtraFieldTypeColorResolvers<ContextType>;
  ExtraFieldTypeHelp?: ExtraFieldTypeHelpResolvers<ContextType>;
  ExtraFieldTypeMedia?: ExtraFieldTypeMediaResolvers<ContextType>;
  ExtraFieldTypeNumber?: ExtraFieldTypeNumberResolvers<ContextType>;
  ExtraFieldTypeReference?: ExtraFieldTypeReferenceResolvers<ContextType>;
  ExtraFieldTypeReferenceFilter?: ExtraFieldTypeReferenceFilterResolvers<ContextType>;
  ExtraFieldTypeReferenceSelectOptions?: ExtraFieldTypeReferenceSelectOptionsResolvers<ContextType>;
  ExtraFieldTypeRichText?: ExtraFieldTypeRichTextResolvers<ContextType>;
  ExtraFieldTypeSearch?: ExtraFieldTypeSearchResolvers<ContextType>;
  ExtraFieldTypeSelect?: ExtraFieldTypeSelectResolvers<ContextType>;
  ExtraFieldTypeSelectChoice?: ExtraFieldTypeSelectChoiceResolvers<ContextType>;
  ExtraFieldTypeText?: ExtraFieldTypeTextResolvers<ContextType>;
  ExtraFieldTypeTextLabel?: ExtraFieldTypeTextLabelResolvers<ContextType>;
  JSONObject?: GraphQLScalarType;
  Layout?: LayoutResolvers<ContextType>;
  LayoutCustomModel?: LayoutCustomModelResolvers<ContextType>;
  LayoutCustomModelPosition?: LayoutCustomModelPositionResolvers<ContextType>;
  ListMetadata?: ListMetadataResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  LocationDeviceConfig?: LocationDeviceConfigResolvers<ContextType>;
  LocationDeviceConfigAppMenu?: LocationDeviceConfigAppMenuResolvers<ContextType>;
  LocationDeviceConfigOverscan?: LocationDeviceConfigOverscanResolvers<ContextType>;
  LocationDeviceConfigScreen?: LocationDeviceConfigScreenResolvers<ContextType>;
  LocationDeviceConfigScreenOffset?: LocationDeviceConfigScreenOffsetResolvers<ContextType>;
  LocationDeviceConfigVideoSource?: LocationDeviceConfigVideoSourceResolvers<ContextType>;
  LottieAsset?: LottieAssetResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  MediaUrlModel?: MediaUrlModelResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  OrganizationModel?: OrganizationModelResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  PostFlyoutPositionModel?: PostFlyoutPositionModelResolvers<ContextType>;
  PostQrCodeByProfile?: PostQrCodeByProfileResolvers<ContextType>;
  PostQrCodeLocation?: PostQrCodeLocationResolvers<ContextType>;
  PostQrCodeLocationPercent?: PostQrCodeLocationPercentResolvers<ContextType>;
  PostQrCodeStyle?: PostQrCodeStyleResolvers<ContextType>;
  PostTileAsset?: PostTileAssetResolvers<ContextType>;
  ProfileBackgroundModel?: ProfileBackgroundModelResolvers<ContextType>;
  ProfileLayoutModel?: ProfileLayoutModelResolvers<ContextType>;
  ProfileLayoutModelEntry?: ProfileLayoutModelEntryResolvers<ContextType>;
  ProfileLayoutScreenFlyoutModel?: ProfileLayoutScreenFlyoutModelResolvers<ContextType>;
  ProfileLayoutScreenModel?: ProfileLayoutScreenModelResolvers<ContextType>;
  ProfileLayoutScreenPositionModel?: ProfileLayoutScreenPositionModelResolvers<ContextType>;
  ProfileModel?: ProfileModelResolvers<ContextType>;
  ProfileRestingModel?: ProfileRestingModelResolvers<ContextType>;
  ProfileRestingModelEntry?: ProfileRestingModelEntryResolvers<ContextType>;
  ProfileRestingModelEntryImageSettings?: ProfileRestingModelEntryImageSettingsResolvers<ContextType>;
  ProfileScreenSizeModel?: ProfileScreenSizeModelResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ScheduledEvent?: ScheduledEventResolvers<ContextType>;
  ScheduledEventRecurringSettings?: ScheduledEventRecurringSettingsResolvers<ContextType>;
  Service?: ServiceResolvers<ContextType>;
  ServiceOption?: ServiceOptionResolvers<ContextType>;
  ServiceOptionApp?: ServiceOptionAppResolvers<ContextType>;
  ServiceOptionAppCmsFunction?: ServiceOptionAppCmsFunctionResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  ValidationModel?: ValidationModelResolvers<ContextType>;
};
